/**
* @fileOverview This javascript contains javascript functions used by the newsletter function
*/

NewsLetterJS={
        
    version: "Common Implementation v0.01",
	/** language ID to be used, default to -1 (English) */
	langId: "-1",
	
	/** store ID to be used */
	storeId: "",
	
	/** store Name to be used */
	appName :"",
	/** catalog ID to be used */
	catalogId: "",
	
	email :"",
	
	formId:"",
	
	/** 
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use

	*/	
	setCommonParameters:function(langId,storeId,catalogId,appName){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
        this.appName = appName;
	},
	
	updateParamObject:function(params, key, value, index){
		if(params == null){
			params = [];
		}

		if(index != null && index !== "" && index !== -1){
			//overwrite the old value at specified index
			params[key+"_"+index] = value;
		}else if(index === -1){
			var i = 1;
			while(params[key + "_" + i] != null){
				i++;
			}
			params[key + "_" + i] = value;
		}else{
			params[key] = value;
		}
		return params;
	},
	
	/**
	* This function clears all the input fields of the form passed in by parameter
	* @param {String} formName The name of the form containing the input fields.	
	*/
	 clearForm:function(formName){
		var form = document.forms[formName];
		for(var i=0; i<form.elements.length; i++) {
			if (form.elements[i].type == "text") {
				form.elements[i].value = "";
			}
		}
	},
	
	/**
	 * submitting to newsletter after checking email param
	 */
	subscribeToNewsLetter:function(formName, page){
		if(this.validateSubscriptionParams(formName)){
            var zipcode = '';  
            var firstName = '';
            var lastName = '';
            var gender = '';
            var dateOfBirth = '';
            var promo = false;
            var primaryNewsLetterFlow=true;
		    this.formId = formName;
		    emailInput = document.querySelector("form[name="+formName+"] #newsletterPopupEmail");
		    if (formName == "newsLetterForm") {
		        emailInput = document.querySelector("form[name="+formName+"] #newsletterEmail");
		        if (isCarol) {
		            emailInput.parentElement.classList.remove("errorGeneric");
	                emailInput.parentElement.classList.remove("errorDuplicate");
		        }
            }
            if(formName == "newsLetterFormLandingPage" && isOliver) {
                emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
                if(countryCode == 'US' || countryCode == 'CA') {
                	zipcode = document.querySelector("form[name="+formName+"] #newsletterZipcodeLandingPage").value;
                }
                firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            } else if (formName == "newsLetterFormPromoLandingPage"){
            	emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
            	firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            	promo = true;
            } //#EMAIL_ME# 
            else if (formName == "newsLetterForm_emailme") { 
		        emailInput = document.querySelector("form[name="+formName+"] #input_Emailme");
			} //#EMAIL_ME#
		    this.email = emailInput.value.toLowerCase();
		    
		    var cidCookie = null;
	        
	        if(document.cookie.includes('X_WC_CID')){
	        	cidCookie = $.cookie("X_WC_CID");
	        }
		    
			var params = {
				storeId: this.storeId,
				langId : this.langId,
				email: this.email,
                zipCode: zipcode,
                promo: promo,
                pageIdentifier: page,
                firstName: firstName,
                lastName: lastName,
                gender: gender,
                dob: dateOfBirth,
                primaryNewsLetterFlow:primaryNewsLetterFlow,
                cid: cidCookie
			}
            if(typeof updateDuplicate != 'undefined' && updateDuplicate == 'true')
                params.update = updateDuplicate

		 	cursor_wait();
		 	wcService.invoke("JoinNewsletterService", params);
		 	
		 	if(formName=="newsletterPopupForm"){
		 		setCookie("WELCOME_STICKY_SHOWN_"+this.appName,true,{expires: 10000,path: "/", domain: cookieDomain});
		 	}
		}
		
	},

    validateSubscriptionParams: function(formName) {
        this.cleanErrors(formName); 
        var namePattern = /[A-Za-z]/;
        var isValid = true; //we use this variable to check all fields and show,eventually, all errors

        /*EMAIL VALDATION - MANDATORY*/
        var emailInput = $("form[name="+formName+"] [name='EMAIL']");
        if (!emailInput.val()) { //empty or undefined
            this.toggleFormError('EMAIL','EMPTY',formName);
            isValid = false;
        } else if (emailInput.length > 0 && !AddressHelper.validateEmail(emailInput.get(0))) {
            this.toggleFormError('EMAIL','INVALID',formName);
            isValid = false;
        }
        
        /*FIRSTNAME VALDATION*/
        var firstNameInput = $("form[name="+formName+"] [name='NAME'],form[name="+formName+"] [name='FIRSTNAME']");
        if (firstNameInput.length > 0 && needsValidation(firstNameInput)) { //if fild not available or disabled do not check
            var firstNameValue = firstNameInput.val();
            if (!firstNameValue) {
                this.toggleFormError('NAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(firstNameValue)){
                this.toggleFormError('NAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*LASTNAME VALIDATION*/
        var lastNameInput = $("form[name="+formName+"] [name='LASTNAME']");
        if (lastNameInput.length > 0 && needsValidation(lastNameInput)) { //if fild not available or disabled do not check
            var lastNameValue = lastNameInput.val();
            if (!lastNameValue) {
                this.toggleFormError('LASTNAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(lastNameValue)){
                this.toggleFormError('LASTNAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*GENDER VALIDATION*/
        var genderInput = $("form[name="+formName+"] [name='gender']");
        if (genderInput.length > 0 && needsValidation(genderInput)) { //if fild not available or disabled do not check
            var genderSelected = genderInput.find('option:selected').val();

            if(!genderSelected) {
                this.toggleFormError('GENDER','EMPTY',formName);  
                isValid = false;
            } 
        }
       
        /*BIRTHDAY VALIDATION*/
        var birthdayInput = $("form[name="+formName+"] [name='BIRTHDAY']");
        if (birthdayInput.length > 0 && needsValidation(birthdayInput)) { //if fild not available or disabled do not check
            var  dateOfBirth = birthdayInput.val();
            // Variables for birthday validation
            var birthdayDate = new Date(dateOfBirth);
            var birthdayYear = birthdayDate.getFullYear();
            var currentYear = new Date().getFullYear();
            var maxAge = currentYear - birthdayYear;

            if (dateOfBirth == '') {
                this.toggleFormError('BIRTHDAY','EMPTY',formName);   
                isValid = false;
            } else if (maxAge > 100 || maxAge < 16 || birthdayYear >= currentYear){
                this.toggleFormError('BIRTHDAY','INVALID',formName);  
                isValid = false;
            }
        }

         /*ZIPCODE VALIDATION*/
         var zipCodeInput = $("form[name="+formName+"] [name='ZIPCODE']");
         if (zipCodeInput.length > 0 && needsValidation(zipCodeInput)) { //if fild not available or disabled do not check
            var  zipCodeValue = zipCodeInput.val();
            var zipCodeRegexp = AddressHelper.getZipCodeRegexpForCurrentCountryCode();
            
            if (!zipCodeRegexp.test(zipCodeValue)){
                this.toggleFormError('ZIPCODE','INVALID',formName);  
                isValid = false;
            }
         }

                 
        return isValid;
    },

    toggleFormError: function(element,error, formName) {
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                switch(element) {
                    case 'EMAIL': {
                        $("#mce-error-response-landingpage--email").show();
                        $("#mce-error-response-landingpage--email").children().hide();
                        $("#newsletterEmailForm input").css('border','solid 1px red');
                        if(error=='EMPTY'){ 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }    
                        else if (error=='INVALID') { 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-invalid-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - EMAIL CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    case 'NAME': {
                        $('#mce-error-response-landingpage--name').show();
                        $('#mce-error-response-landingpage--name').children().hide();
                        $('#newsletterNameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--name [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--name  [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - NAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'LASTNAME': {
                        $('#mce-error-response-landingpage--lastname').show();
                        $('#mce-error-response-landingpage--lastname').children().hide();
                        $('#newsletterLastnameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--lastname [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--lastname [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - LASTNAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    } 
        
                    case 'GENDER': {
                        $('#mce-error-response-landingpage--gender').show();
                        $('#mce-error-response-landingpage--gender').children().hide();
                        $('#newsletterGenderForm select').css('border','solid 1px red');
                        $('#newsletterGenderForm select').css('margin-bottom','0');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--gender [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - GENDER CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'BIRTHDAY': {
                        $('#mce-error-response-landingpage--birthday').show();
                        $('#mce-error-response-landingpage--birthday').children().hide();
                        $('#newsletterBirthdayForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--birthday [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--birthday [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - BIRTHDAY CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
        
                    case 'ZIPCODE': {
                        $('#mce-error-response-landingpage').show();
                        $('#mce-error-response-landingpage').children().hide();
                        $('#newsletterZipCodeForm input').css('border','solid 1px red');
        
                        if(error == 'INVALID') {
                            $('#mce-error-response-zipcode-landingpage').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - ZIPCODE CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    default: console.log('NewsletterJS.toggleFormError - '+element+' CASE  NOT DEFINED')
                }

                break;
            }
            case 'newsLetterForm_emailme' : {
                $("#mce-error-response_emailme").show();
                $("#mce-error-response_emailme").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty_emailme").show();  
                else if (error=='INVALID') $("#mce-error-response-invalid_emailme").show();
                else console.log('NewsletterJS.toggleFormError - EMAILME - CASE '+error+' NOT DEFINED')
                break;
            }
            default : {
                $("#mce-error-response").show();
                $("#mce-error-response").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty").show();
                else if (error=='INVALID') $("#mce-error-response-invalid").show();
                else console.log('NewsletterJS.toggleFormError - '+formName+' - CASE '+error+' NOT DEFINED');
            }
        }
    },

    cleanErrors: function(formName) {
        $("[id^=mce-error-response").hide()
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                $("form[name="+formName+"] input").css('border','');
                $("form[name="+formName+"] select").css('border','');
                $("form[name="+formName+"] select").css('margin-bottom','40px');
                break;
            }
            default : {
                $("#mce-error-response").hide();
            }
        }
    },

	hideAllMessagews : function () {
	    $('#newsletterSignUpResultPopup .message-error').hide();
	    $('#newsletterSignUpResultPopup .message-duplicate').hide();
	    $('#newsletterSignUpResultPopup .message-success').hide();
	},
    handleJoinNewsletterError : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorGeneric");
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-error').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#mce-error-response-error-landingpage').show();
        } else {
            $('#newsletterSignUpResultPopup .message-error').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  

    handleJoinNewsletterDuplicate : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorDuplicate");           
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                if(window.innerWidth < 1024) {
                    $('.newsletter__title').hide();
                }
                //$('.newsletter__policy').hide();
                //$('.newsletter__form').hide();
                $('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-duplicate-landingpage').show();
            
        } else if (this.formId == "newsLetterFormPromoLandingPage") {
            $('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-landingpage--email #mce-error-response-duplicate-landingpage').show();
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
         /* email me messaggi di errore per duplicati newsletter 
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-error-response-duplicate_emailme').show();
            $('#mce-success-response_emailme').hide();*/
        } //#EMAIL_ME#
        else {
            $('#newsletterSignUpResultPopup .message-duplicate').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  
    
    handleJoinNewsletterSuccess : function(){
        this.hideAllMessagews();
        
        /*if(typeof customerWeekActive != 'undefined' && customerWeekActive){
          activateCustomerWeek();
        }*/
        
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                $('#newsLetterFormDiv').hide();
                $('#newsLetterSuccessDiv').fadeIn("fast");
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                $('.newsletter__policy').hide();
                $('.newsletter--form--input.input-style').hide();
                $('.button.gray-alpha.button--newsletter').hide()
                $('#mce-success-response').show();
                
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-success-response').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
            $('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#opnewsletter-success-response-landingpage').show();
            $('.newsletter__wrapper').hide();
        } else if (this.formId == "newsLetterFormPromoLandingPage"){
        	//Generic
        	 $('.newsletter-page .newsletter__form').hide();
        	 $('.newsletter_homepage-button').show();
        	 $('.newsletter__policy.no-gdpr').hide();
        	//Vogue
        	 $('#mbb-success-response-landingpage').show();
        	 $('.newsletter__title-mbb').hide();
 	         $('.newsletter__info-mbb').hide();
 	         $('.newsletter__image.newsletter-mbb_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-mbb_image img:nth-child(3)').show();
        	//Persol
        	 $('#ponewsletter-success-response-landingpage').show();
        	 $('.newsletter__title-ponewsletter').hide();
 	         $('.newsletter__info-ponewsletter').hide();
 	         $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(3)').show();
             $('#POnewsletterImage').hide();
             $('#POnewsletterImageMobile').hide();
             if(window.mobilecheck()){
            	 $('#POnewsletterImageMobile_TP').show();
             }
             else {
            	 $('#POnewsletterImage_TP').show();
             }

            window.scrollTo(0,0);
            if (isPersol || isVogue) {
                window.setTimeout(function(){
                    window.location.href = WCParamJS.homePageURL + ($('#redirectSunglasses').length > 0 && $('#redirectSunglasses').attr('value') != undefined && $('#redirectSunglasses').attr('value') != '' ? $('#redirectSunglasses').attr('value') : '');
                }, 3200);
            }
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-success-response_emailme').show();
            $('#mce-error-response-duplicate_emailme').hide();//#EMAIL_ME#
        } else {
            $('#newsletterSignUpResultPopup .message-success').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }

        /* START Early Access */
        if (isPersol || isVogue) { 
            if ($("#boxCheckout").length == 0){
                assignCustomerSegment();
                if (this.formId == "newsLetterForm"){
                    if (window.customerSegment != undefined && document.cookie.includes("X_WC_PR_SEGMENTS")){
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        if (!urlParams.has('promo')) {
                            if (location.href.indexOf("?") === -1){
                                window.setTimeout(function(){
                                    window.location = location.href += "?promo=" + window.customerSegment;
                                }, 2000);
                            } else {
                                window.setTimeout(function(){
                                    window.location = location.href += "&promo=" + window.customerSegment;
                                }, 2000);
                            }
                        }   
                    }
                }
            }
        }
        /* END Early Access */
    }		
},
 
/**
 * This service calls JoinNewsletterCmd to make a subscription to newsLetter
 */
wcService.declare({
	id: "JoinNewsletterService",
	actionId: "JoinNewsletterService",
	url: "JoinNewsletterService",
	formId: "",

	successHandler: function(serviceResponse) {
		localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
		if(serviceResponse.responseMessage == 'duplicate'){
		    NewsLetterJS.handleJoinNewsletterDuplicate();
		}else if(serviceResponse.responseMessage == 'success'){
		    if(typeof utag_data !== 'undefined')
               utag_data.User_EmailOptin = serviceResponse.userOptin;
		    if(pageType!=='Delivery'){
		    	tealiumPushUserOptin(serviceResponse.userOptin,serviceResponse.email);
		    }
			NewsLetterJS.handleJoinNewsletterSuccess();
            if(isVogue){
                setCookieNlEvent();
            }
		}
		cursor_clear();
		
	},

	failureHandler: function(serviceResponse) {
	    NewsLetterJS.handleJoinNewsletterError();
	    cursor_clear();
	}
});

//  Display/undisplay Landing Page fields
function toggleLandingPageFields() {
    var landingForm = $("form[name='newsLetterFormPromoLandingPage'],form[name='newsLetterFormLandingPage']");
    if (landingForm.length > 0) {
        var formId = landingForm.attr('id')
        toggleSubscriptionForms("X_SignInForms_Info");
        if (typeof subscriptionFormsJSONData != 'undefined'){
        for (var key in subscriptionFormsJSONData) {
            var dataValue = subscriptionFormsJSONData[key];
            switch(dataValue) {
                case 'disabled','false': {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("disabled","disabled");
                    $("#"+formId+" #"+key).hide();
                    if (key == 'newsletterBirthdayForm') {
                        $('#newsletter_age-disclaimer').hide();
                    }
                    break;
                }
                case 'optional' : {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("optional","optional");
                    break;
                }
                default:{}
            }
        }
      }
    }
}

function toggleSubscriptionForms(espotName){

    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
  
    $.ajax({
      type: "GET", 
      dataType: 'json', 
      url: espotServiceUrl,
      async: false,
      contentType: "application/json",
      success: function (data) {
        //console.log(data);
        if (data.MarketingSpotData[0].baseMarketingSpotActivityData != undefined) {
          window.subscriptionFormsJSONData = JSON.parse(data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText);
        }
      },
      error: function(data){
        console.log("Error retrieving newsletter subscription forms info");
      }
    });
}

function needsValidation(inputElement) {
    var needValidation = true;

    if(inputElement.attr('disabled'))
        needValidation = false;

    if(inputElement.attr('optional'))
        needValidation = false;

    return needValidation;
}
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by UserRegistrationAddForm.jsp and CheckoutLogon.jsp.
 * @version 1.0
 */

/**
 *  The functions defined in the class helps the customer to register with the store. Another function enables a returning
 *  customer to Sign in for quickcheckout from the shopping cart page.
 *
 *  @class This LogonForm class defines all the functions and variables used to validate the information provided by the
 *  customer to register with the store.To register, a customer creates a logon ID and password. Then, the customer provides their first name,
 *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number. Other registration options
 *  include promotional e-mails, preferred language and currency, age, gender, and the remember me option.
 */
LogonForm ={

    /**
     * This function validates the logon ID and password for returning customers to sign in and complete the checkout process.
     * @param {string} form The name of the form containing logon ID and password fields.
     */
    SubmitAjaxLogin:function(form){

        if(!this.validateAjaxLogin(form)){
            return;
        };
        setDeleteCartCookie();

        form.submit();

    },

    validateAjaxLogin:function(form){
        reWhiteSpace = new RegExp(/^\s+$/);

        if(form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == ""){
            MessageHelper.formErrorHandleClient(form.logonId.id,MessageHelper.messages["LOGON_REQUIRED_FIELD_ENTER"]); return false;}

        if(form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == ""){
            MessageHelper.formErrorHandleClient(form.logonPassword.id,MessageHelper.messages["PASSWORD_REQUIRED_FIELD_ENTER"]); return false;}

        return true;
    },

    /**
     * This function is called when the Submit button is clicked on the Registration page. 
     * Ensures that the newsletter check exists and perform the submit.
     * 
     * @param {string} form The name of the registration form containing all the customer information.
     */
    performRegistration:function(form){

        //HB-2946 - All registration an newsletter should be performed on lower case
        form.elements.email1.value = form.elements.email1.value.toLowerCase();

        var newsletterCheck = $("#gdpr-checkbox-newsletter").is(":checked");
        if(isPersol){
        	var profiling = $("#gdpr-checkbox-personal").is(":checked");
        }else{
        	var profiling = $("#gdpr-checkbox-profiling").is(":checked");
        }
        
        
        
        var emailRegistration = form.elements.email1.value;
        var fName = form.elements.firstName.value;
        var lName = form.elements.lastName.value;

        //Validate just in case that isChecked the newsletter only for Persol or is a non GDPR store
        if (typeof isGDPR !== 'undefined' && (!isGDPR && !isPersol) || newsletterCheck || profiling) {
            wcService.declare({
                id: "JoinNewsletterServiceRegistration",
                actionId: "JoinNewsletterService",
                url: "JoinNewsletterService",
                formId: ""
            
                ,successHandler: function(serviceResponse) {
                    form.submit();
                    localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
                    /* START Early Access */
                    if (isPersol || isVogue) assignCustomerSegment();
                    /* END Early Access */
                    cursor_clear();
                }
                ,failureHandler: function(serviceResponse) {
                    form.submit();
                    cursor_clear();
                }
            
            });
            var cidCookie = null;
            
            if(document.cookie.includes('X_WC_CID')){
            	cidCookie = $.cookie("X_WC_CID");
            }
            
            var params = {
                    storeId: WCParamJS.storeId,
                    langId : WCParamJS.langId,
                    email: emailRegistration,
                    firstName: fName,
                    lastName: lName,
                    profiling: profiling,
                    subscription: newsletterCheck,
                    isFormRegistration:true,  
                    cid: cidCookie
                }
            cursor_wait();
            wcService.invoke("JoinNewsletterServiceRegistration", params);

        } else {
            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */
            form.submit();
        }
        
    },
    /**
     * This function is called when the Submit button is clicked on the Registration page. All the fields containing customer
     * information are validated and PersonProcessServicePersonRegistration is called.
     * @param {string} form The name of the registration form containing all the customer information.
     */
    prepareSubmit:function (form) {
        //cursor_clear();
        if(CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' || CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true') {
            var random = Math.random();
            var randomPassword = random.toString(36).slice(-7); // Get last 7 chars. Will add one numeric char to make it 8 char long...
            var randomInt = Math.floor((random * 9) + 1);
            randomPassword += randomInt; //Password should contain atleast one numeric character...
            if ($("#logonPassword").val() == null || $("#logonPassword").val() == "") {
                $('<input>').attr({
                    type: 'hidden',
                    value: randomPassword,
                    name: "logonPassword",
                    id: "logonPassword",
                }).appendTo('form');
            }

            if ($("#logonPasswordVerify").val() == null || $("#logonPasswordVerify").val() == "") {
                $('<input>').attr({
                    type: 'hidden',
                    value: randomPassword,
                    name: "logonPasswordVerify",
                    id: "logonPasswordVerify"
                }).appendTo('form');
            }

            if ($("#passwordExpired").val() == null || $("#passwordExpired").val() == "") {
                $("#passwordExpired").val("1");
            }
        }

        if (!this.validatePrepareForm(form)) {
            moveToError();
            console.log("There is something wrong with in register form");
            restoreAjaxButtons();
             /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
            	var message =  $('.password-policies-title-error').text();
	             var trackData = {};
	             trackData['id'] = "Event";
                 trackData['Events_Error'] = "1";
	             trackData['Error_Code'] = 'Form Filling Error';
	             trackData['Error_Source'] = "User";
	             trackData['Error_Message'] = this.tealiumValidateError;
	             trackData['Error_Details'] = this.tealiumValidateError;
	             tealium_data2track.push(trackData);
            }
            /* TEALIUM END */
            console.log("TEALIUM::Create user fail.");
            
            return;
        }

        setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {path:'/', domain:cookieDomain});
        if(CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true' ||
                (CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' &&  form.userId != null && form.userId.value != null)){
            // CSR is creating the user OR
            // OnBehalf session is started and CSR is registering existing guestUser.
            // Uses UserRegistrationAdminAddCmd
            if(registeredCustomersJS != null) {
                registeredCustomersJS.createRegisteredUser(form.landingURL_CSR.value);
            }
        } else {
            this.performRegistration(form);
        }
    },

    /**
     * The function is called to validate and prepare the form.
     * @param {string} form The name of the registration form containing all the customer information.
     * @return (Boolean) true if the form is ready to submit, false otherwise.
     */
    validatePrepareForm: function(form) {
        var isValid = true;
        reWhiteSpace = new RegExp(/^\s+$/);
        if (form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == "") {
            this.manageMultipleErrorFields(form.logonId,MessageHelper.messages["ERROR_LogonIdEmpty"], false);
            isValid = false;
        } else if (!AddressHelper.validateEmail(form.logonId)) {
            this.manageMultipleErrorFields(form.logonId,MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"], false);
            isValid = false;
        } else if (typeof this.validateLoginId == "function") {
            if (!this.validateLoginId(form.logonId)) {
                isValid = false;
            }
        } else {
            this.manageMultipleErrorFields(form.logonId, "", true);
        }

        $('#emailError').css('display', 'none');

        if (form.ancestorOrgs != null) {
            if (form.ancestorOrgs.value == "") {
            	validateError = MessageHelper.messages["ERROR_OrgNameEmpty"];
                this.manageMultipleErrorFields(form.ancestorOrgs,MessageHelper.messages["ERROR_OrgNameEmpty"], false);
                this.tealiumValidateError = validateError;
                isValid = false;
            } else if (form.ancestorOrgs.value == "Default Organization") {
            	validateError = MessageHelper.messages["ERROR_DefaultOrgRegistration"];
                this.manageMultipleErrorFields(form.ancestorOrgs,MessageHelper.messages["ERROR_DefaultOrgRegistration"], false);
                this.tealiumValidateError = validateError;
                isValid = false;
            }
        }

        if (form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == "") {
	        validateError = MessageHelper.messages["ERROR_PasswordEmpty"];
            this.manageMultipleErrorFields(form.logonPassword,MessageHelper.messages["ERROR_PasswordEmpty"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else {
            this.manageMultipleErrorFields(form.logonPassword, "", true);
        }

        if (form.logonPasswordVerify != null && reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == "") {
	        validateError = MessageHelper.messages["ERROR_VerifyPasswordEmpty"];
            this.manageMultipleErrorFields(form.logonPasswordVerify,MessageHelper.messages["ERROR_VerifyPasswordEmpty"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else {
            this.manageMultipleErrorFields(form.logonPasswordVerify, "", true);
        }

        if (form.logonPassword.value != form.logonPasswordVerify.value) {
	        validateError = MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"];
            this.manageMultipleErrorFields(form.logonPasswordVerify,MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else if (!(reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == "")) {
            this.manageMultipleErrorFields(form.logonPasswordVerify, "", true);
        }

        if(!checkPasswordStrenght(form.logonPassword)) {
            $('.password-policies-title').addClass('hidden');
            $('.password-policies-title-error').removeClass('hidden');
            $('.input-style--password').addClass('error');
            this.tealiumValidateError =  $('.password-policies-title-error').text();
            isValid = false;
            var trackData = {};
            trackData['id'] = "Error"
            trackData['Error_Code'] = 'Form Filling Error' ;
            trackData['Error_Source'] = "User";
            trackData['Error_Message'] = this.tealiumValidateError;
            trackData['Error_Details'] = this.tealiumValidateError;
            pushDataToTealium(trackData);
        }
        else {
            $('.password-policies-title').removeClass('hidden');
            $('.password-policies-title-error').addClass('hidden');
            $('.input-style--password').removeClass('error');
            this.tealiumValidateError =  $('.password-policies-title-error').text();
        }
        

        /** Uses the common validation function defined in AddressHelper class for validating first name,
         *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number.
         */
        if (!AddressHelper.validateAddressForm(form)) {
            isValid = false;
        }

        /* Checks whether the customer has registered for promotional e-mails. */
        if (form.sendMeEmail && form.sendMeEmail.checked) {
            form.receiveEmail.value = true;
        } else if (form["gdpr-checkbox-newsletter"] && form["gdpr-checkbox-newsletter"].checked) {
            form.receiveEmail.value = true;
        } else {
            form.receiveEmail.value = false;
        }

        if (form.sendMeSMSNotification &&  form.sendMeSMSNotification.checked) {
            form.receiveSMSNotification.value = true;
        } else {
            form.receiveSMSNotification.value = false;
        }

        if (form.sendMeSMSPreference && form.sendMeSMSPreference.checked) {
            form.receiveSMS.value = true;
        } else {
            form.receiveSMS.value = false;
        }

        if (form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true") {
            if (!MyAccountDisplay.validateMobileDevice(form)) {
                isValid = false;
            }
        }
        if (form.birthdayEnabled != null && form.birthdayEnabled.value == "true") {
            if (!MyAccountDisplay.validateBirthday(form)) {
                isValid =  false;
            }
        }
        return isValid;
    },
    
    /**
     * Manage multiple address form error messages for each concerned field.
    */
    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;
        // var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (field.name != undefined && field.name.indexOf('logonPassword') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name == 'logonPassword') {
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                }
            }
        }
    },
   
   /**
    * mandatory field shown when one or multiple empty fields in forms
    */
   getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
       //showing specific message per field
       if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
           errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
       }

       var mandatoryField = document.createElement('div');
       mandatoryField.setAttribute("class", "address-erros-message-cont");
       mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';
/* <div class="address-erros-message-cont"><span id="mandatoryField_+ parentID" +  class="error-message"> errorMsg </span></div> */
       return mandatoryField;
   }
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
ServicesDeclarationJS = {
    langId: "-1", /* language of the  store */
    storeId: "", /*numeric unique identifier of the store */
    catalogId: "", /*catalog of the store that is currently in use */

    /**
     * Sets common parameters used by the services
     * @param (int) langId The language of the store.
     * @param (int) storeId The store currently in use.
     * @param (int) catalogId The catalog of the store currently in use.
     */
    setCommonParameters:function(langId,storeId,catalogId){
            this.langId = langId;
            this.storeId = storeId;
            this.catalogId = catalogId;
    }
}

function nullCartTotalCookie(orderId){
    setCookie("WC_CartTotal_"+orderId, null, {expires: -1, path:'/', domain:cookieDomain});

    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("=");
        var name = cookies[i].substr(0,index);
        var value = cookies[i].substr(index+1)
        name = name.replace(/^\s+|\s+$/g,"");
        value = value.replace(/^\s+|\s+$/g,"");
        if (value == orderId) {
            setCookie(name, null, {expires: -1, path:'/', domain:cookieDomain});
            break;
        }
    }
}

    /**
    * Adds an item to to the wishlist and remove the same item from the shopping
    * cart.
    * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAddAndDeleteFromCart",
        actionId: "AjaxInterestItemAddAndDeleteFromCart",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            MessageHelper.hideAndClearMessage();
            resetRequest();
            CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId,true);
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Add an item to a shopping cart in Ajax mode. A message is displayed after
     * the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddOrderItem",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
            cursor_clear();
            if(categoryDisplayJS){

                var attributes = document.getElementsByName("attrValue");

                var singleSKU = true;

                for(var i=0; i<attributes.length; i++){
                    if (attributes[i].options.length > 1)
                    {
                        singleSKU = false;
                    }
                }

                if (!singleSKU)
                {
                    categoryDisplayJS.selectedAttributes = [];
                    for(var i=0; i<attributes.length; i++){
                        if(attributes[i] != null){
                            attributes[i].value = "";
                        }
                    }
                }
            }
            if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
                ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

   /**
   * Add an item to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
    wcService.declare({
        id: "AjaxAddOrderItem_shopCart",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
        formId: ""

     /**
     * redirects to the shopping cart page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            document.location.href =  appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Remove an item from shopping cart. A message is displayed after the service
     * call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""
    /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse, params) {
            MessageHelper.hideAndClearMessage();
            if (typeof addCheckoutLoader === 'function') {
                addCheckoutLoader();
            }
            if (typeof params.editLensesAddToCart === 'function') {
                params.editLensesAddToCart();
            } else {
                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            }
            if (typeof addToCartInput !== "undefined") {
                fn_ext_genericAddToCart(addToCartInput.frameObject, addToCartInput.lensObject, addToCartInput.warrantyObject, addToCartInput.reviewObject, addToCartInput.imagery, addToCartInput.merchandisingAssociations);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }
    }),


    /**
     * Removes an item from shopping cart on the shipping & billing page. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemForShippingBillingPage",
        actionId: "AjaxDeleteOrderItemForShippingBillingPage",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""

        /**
         * display a success message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            resetRequest();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            /* HB-1050 :: workaround */
            if (!$("#page").hasClass("pdp")) {
            	setTimeout(function() { location.reload(); }, 500);
            }
        }

        /**
         * display an error message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),


    /**
     * Remove an item from shopping cart. A message is only displayed if the service
     * call returns an error Message. It is used to remove an item from the shopping
     * cart and add the same item to the wish list.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemFromCart",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }


    }),

    /**
     * Remove an item from shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page or the OrderShippingBillingView page depending on what page the service was invoked from.
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem1",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            addCheckoutLoader();
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                setDeleteCartCookie();
                if(CheckoutHelperJS.shoppingCartPage){

                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }else{
                    document.location.href = appendWcCommonRequestParameters("OrderShippingBillingView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service updates an order item in the shopping cart.
     * A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.hideFormErrorHandle();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),

    /**
     * Updates an order item in the shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem1",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""
    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                if(CheckoutHelperJS.shoppingCartPage){
                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service updates shipping information (shipping mode, shipping address)
     * for a shopping cart. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderShippingInfo",
        actionId: "AjaxUpdateOrderShippingInfo",
        url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service prepares an order for submission. Upon success, it submits the order.
     * @constructor
     */
    wcService.declare({
        id: "AjaxPrepareOrderForSubmit",
        actionId: "AjaxPrepareOrderForSubmit",
        url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
        formId: ""

    /**
     * On success, checkout the order by calling order submit.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            CheckoutHelperJS.setOrderPrepared("true");
            CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service submits the order. Upon success, the order billing confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitOrder",
        actionId: "AjaxSubmitOrder",
        url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
        formId: ""

    /**
     *redirect to the Order Confirmation page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            nullCartTotalCookie(serviceResponse.orderId);
            /* START - Online Return Form */
            if (typeof goToOnlineReturnTYP == 'function') {
                goToOnlineReturnTYP();
            } else {
                var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
                document.location.href = appendWcCommonRequestParameters("OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId);
            }
            /* END - Online Return Form */
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     *
     * In case of failure, the next error messages will not be sent to Tealium: See paymentResponseCodesNotToSendToTealium set in CommonUtilities.js
     *
     */
        ,failureHandler: function(serviceResponse) {

            //NERD-727: Start the authentication session in case the card is enrolled in pyaer authentications.
            if (serviceResponse.errorMessageKey == "PLUGIN_RC_475" && $("#JWT").length > 0) {
                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/cart/@self/payment_instruction";
                createPaymentLoaderOverlay() //creates a dark overlay with a spinner;

                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                    data: {
                        "timestamp": Date.now()
                    },
                    success: function (data) {
                        if (data != undefined) {
                            var payerAuthEnrollReply_paReq;
                            var payerAuthEnrollReply_acsURL;
                            var payerAuthEnrollReply_authenticationTransactionID;
                            $.each(data.paymentInstruction[0].protocolData, function (index, value) {
                                if (value.name == 'payerAuthEnrollReply_paReq') {
                                    payerAuthEnrollReply_paReq = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_acsURL') {
                                    payerAuthEnrollReply_acsURL = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_authenticationTransactionID') {
                                    payerAuthEnrollReply_authenticationTransactionID = value.value;
                                }
                            });
                            // Start the authentication session.
                            Cardinal.continue('cca',
                            {
                                "AcsUrl": payerAuthEnrollReply_acsURL,
                                "Payload": payerAuthEnrollReply_paReq
                            },
                            {
                                "OrderDetails":{
                                    "TransactionId" : payerAuthEnrollReply_authenticationTransactionID
                                }
                            });
                        }
                    },
                    error: function(data){
                        deletePaymentLoaderOverlay();

                        MessageHelper.displayErrorMessage("There was a problem while retrieving the payment data.");
                        cursor_clear();
                    }
                });
            } else if (serviceResponse.errorMessage) {
                deletePaymentLoaderOverlay();

                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                cursor_clear();
            } else {
                if (serviceResponse.errorMessageKey) {
                    deletePaymentLoaderOverlay();

                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                    cursor_clear();
                }
            }
        }

    }),

    /**
     * This service submits the quote. Upon success, the quote  confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitQuote",
        actionId: "AjaxSubmitQuote",
        url: getAbsoluteURL() + "AjaxSubmitQuote",
        formId: ""

   /**
    *redirect to the Quote Confirmation page
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,successHandler: function(serviceResponse) {
            var redirectURL = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId
            + "&catalogId=" + ServicesDeclarationJS.catalogId
            + "&langId=" + ServicesDeclarationJS.langId
            + "&orderId=" + CheckoutHelperJS.getOrderId()
            + "&shipmentTypeId=" + CheckoutHelperJS.getShipmentTypeId()
            + "&isQuote=true"
            + "&quoteId=" + serviceResponse.outOrderId// outOrderId is the id of the new quote created.

            if(serviceResponse.outExternalQuoteId != undefined && serviceResponse.outExternalQuoteId != null){
                redirectURL += redirectURL + "&externalQuoteId=" + serviceResponse.outExternalQuoteId;
            }
            document.location.href = appendWcCommonRequestParameters(redirectURL);
        }

   /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddAddressForPerson",
        actionId: "AjaxAddAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateAddressForPerson",
        actionId: "AjaxUpdateAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service calls AjaxRESTOrderItemUpdate to update order total after shipping address is updated in the order.
     */
    wcService.declare({
        id: "AjaxUpdateOrderAfterAddressUpdate",
        actionId: "AjaxUpdateOrderAfterAddressUpdate",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
            categoryDisplayJS.selectedAttributes = [];
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist in non-Ajax mode. Upon success,
     * the shopping cart page is displayed. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd_shopCart",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This service deletes an item from the wish list. An error message will be
   * displayed if the service call failed.
   */
    wcService.declare({
        id: "AjaxInterestItemDelete",
        actionId: "AjaxInterestItemDelete",
        url: getAbsoluteURL() + "AjaxInterestItemDelete",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service sends the wish list to a specified email address.
     */
    wcService.declare({
        id: "AjaxInterestItemListMessage",
        actionId: "AjaxInterestItemListMessage",
        url: getAbsoluteURL() + "AjaxInterestItemListMessage",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeManage",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            var objsucces = {
                'id' : 'Event',
                'Events_DiscountApplied' : '1',
                'Order_DiscountCode':serviceResponse.promoCode,
                'Order_DiscountName':serviceResponse.promoCode
            }
            pushDiscountCode(objsucces)
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/

            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage){
                $("#promoCode").addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, serviceResponse.errorMessage);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1',
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ (serviceResponse.errorMessage ? serviceResponse.errorMessage.trim() : ""),
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName':"",
                        'Error_Message' : 'PromoCode -'+ (serviceResponse.errorMessage ? serviceResponse.errorMessage.trim() : "")
                }
                pushDiscountCode(obj);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            } else if (serviceResponse.errorMessageKey){
                $("#promoCode").addClass("error");
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessageKey,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName':""
                }
                pushDiscountCode(obj);
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeDelete",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/

            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsAdd",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsRemove",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds a billing address to the order(s).
     */
    wcService.declare({
        id: "AddBillingAddress",
        actionId: "AddBillingAddress",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        var originalOrderId = document.getElementById("orderIdToSchedule").value;
        var newOrderId = serviceResponse.orderId;
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var purchaseOrderNumber = "";
        if(document.forms["purchaseOrderNumberInfo"].purchase_order_number.value != null){
            purchaseOrderNumber = document.forms["purchaseOrderNumberInfo"].purchase_order_number.value;
        }
        var url = "RESTOrderCancel?orderId=" + originalOrderId + "&storeId="  + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" + newOrderId + "%26originalOrderId%3D" + originalOrderId + "%26shipmentTypeId%3D" + shipmentTypeId + "%26purchaseOrderNumber%3D" + purchaseOrderNumber;
        document.location.href = appendWcCommonRequestParameters(url);
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var url = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId;
        document.location.href = appendWcCommonRequestParameters(url);
        cursor_clear();
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service updates the free gift choices made by the shopper for the
 * promotion.
 */
wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: ""

/**
 * Hides all the messages and the progress bar.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();

    }
 /**
 * Display an error message.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {

        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }

}),

    /**
     * Create a new saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCreate",
        actionId: "AjaxOrderCreate",
        url: getAbsoluteURL() + "AjaxOrderCreate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_CREATED"]);

            cursor_clear();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {

                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CREATED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a single saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCancel",
        actionId: "AjaxSingleOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDERS_CANCELLED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a saved order. This service is used to delete multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCancel",
        actionId: "AjaxOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.cancelSavedOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Update the description of a saved order. This service is used to update the description of multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderSave",
        actionId: "AjaxOrderSave",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.saveOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SAVED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Set the current order to be that of a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSetPendingOrder",
        actionId: "AjaxSetPendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();

            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);

            savedOrdersJS.determinePageForward("AjaxSetPendingOrder");

            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E" || serviceResponse.errorCode == "CMN1024E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Updates the current pending order setting it to the current shopping cart.
     * This service does not cause a refresh of the ListOrdersDisplay_Controller registered widgets.
     * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
     * Perform the service or command call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdatePendingOrder",
        actionId: "AjaxUpdatePendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * There is nothing to do in the event of a success of this service since it is executed in the background.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder");
            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCopy",
        actionId: "AjaxSingleOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxSingleOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCopy",
        actionId: "AjaxOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

    /**
    * display a success message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

    /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCalculate",
        actionId: "AjaxSingleOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_COPIED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxCurrentOrderCalculate",
        actionId: "AjaxCurrentOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCalculate",
        actionId: "AjaxOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            // Call again to copy any other orders in the list.
            savedOrdersJS.copyOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Processes a punchout payment request.
     */
    wcService.declare({
        id: "AjaxPunchoutPay",
        actionId: "AjaxPunchoutPay",
        url: "AjaxRESTOrderRePay",
        formId: ""

        /**
         * Calls PunchoutJS.handleResponse to render the punchout payment section on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            PunchoutJS.handleResponse(serviceResponse.orderId);
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),


    /**
     * Subscribes to or unsubscribes from receiving information related to a particular category in the store.
     */
    wcService.declare({
        id: "AjaxCategorySubscribe",
        actionId: "AjaxCategorySubscribe",
        url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
        formId: ""

        /**
         * Clear messages on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_UPDATED"]);
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    })

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript contains declarations of AJAX services used within
 * WebSphere Commerce.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
MyAccountServicesDeclarationJS = {
	/* The common parameters used in service calls */
	langId: "-1",
	storeId: "",
	catalogId: "",
	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */

	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 *  Removes an item from the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemDelete",
		actionId: "InterestItemDelete",
		url: "AjaxInterestItemDelete",
		formId: ""

	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_REMOVEITEM"]);
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  Adds an item to the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAdd",
		actionId: "AjaxInterestItemAdd",
		url: "AjaxInterestItemAdd",
		formId: ""
	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
                categoryDisplayJS.selectedAttributes = [];
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables the customer to email his/her wishlist.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemListMessage",
		actionId: "InterestItemListMessage",
		url: "AjaxInterestItemListMessage",
		formId: ""

	/**
	 * hdes the progress bar and displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "AddBillingAddress",
		actionId: "AddBillingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddBillingAddress::successHandler");
			resetRequest();
			javascript:AddressHelper.saveAddress('AddShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddBillingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "AddShippingAddress",
		actionId: "AddShippingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddShippingAddress::successHandler");
			//document.location.href=appendWcCommonRequestParameters("OrderShippingBillingView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&shipmentType=single&orderPrepare=true");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddShippingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 * This service updates a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "UpdateBillingAddress",
		actionId: "UpdateBillingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateBillingAddress::successHandler");
			resetRequest();
			javascript:AddressHelper.saveAddress('UpdateShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateBillingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "UpdateShippingAddress",
		actionId: "UpdateShippingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateShippingAddress::successHandler");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateShippingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

  /**
   * This services adds or removes a coupon from the order(s).
   * @constructor
   */
	wcService.declare({
		id: "AjaxCouponsAddRemove",
		actionId: "AjaxCouponsAddRemove",
		url: "AjaxCouponsAddRemove",
		formId: ""

   /**
	 * Hides all the messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),
	

	/**
	 * This services deletes a coupon from the wallet.
	 * 
	 * @constructor
	 */
	wcService.declare({
		id : "AjaxRESTWalletCouponsDelete",
		actionId : "AjaxCouponsAddRemove",
		url : "AjaxRESTWalletCouponsDelete",
		formId : ""

		/**
		 * Hides all the messages and the progress bar.
		 * 
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		successHandler : function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

		/**
		 * display an error message.
		 * 
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		failureHandler : function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds or removes a wallet item.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxWalletItemProcessServiceDelete",
		actionId: "AjaxWalletItemProcessServiceDelete",
		url: "AjaxWalletItemProcessServiceDelete",
		formId: ""

	/**
	 * Hides all messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays an error message in case of a failure.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
		}

	}),

	/**
	 * This service cancels a subscription.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxCancelSubscription",
		actionId: "AjaxCancelSubscription",
		url: "AjaxRESTRecurringOrSubscriptionCancel",
		formId: ""

		/**
		 * Clear messages on the page.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
            closeAllDialogs();
			if(serviceResponse.subscriptionType == "RecurringOrder"){
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_CANCEL_MSG"]);
				}
			}
			else{
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_CANCEL_MSG"]);
				}
			}
		}

		/**
		 * Displays an error message on the page if the request failed.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}
	}),


	/**
	 *  This service enables customer to Reorder an already existing order.
	 *  @constructor
	 */
	wcService.declare({
		id: "OrderCopy",
		actionId: "OrderCopy",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			if (serviceResponse.newOrderItemsCount != null && serviceResponse.newOrderItemsCount<=0){
				MessageHelper.displayErrorMessage(MessageHelper.messages["CANNOT_REORDER_ANY_MSG"]);
			}
			else {
				setDeleteCartCookie();

				var postRefreshHandlerParameters = [];
				var initialURL = "AjaxRESTOrderPrepare";
				var urlRequestParams = [];
				urlRequestParams["orderId"] = serviceResponse.orderId;

				postRefreshHandlerParameters.push({"URL":"AjaxCheckoutDisplayView","requestType":"GET", "requestParams":{}}); 
				var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
				wcService.invoke(service.getParam("id"), urlRequestParams);

			}
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables customer to Reorder an already existing order in external system.
	 *  @constructor
	 */
	wcService.declare({
		id: "SSFSOrderCopy",
		actionId: "SSFSOrderCopy",
		url: "AjaxSSFSOrderCopy",
		formId: ""

		 /**
		  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
		  *  @param (object) serviceResponse The service response object, which is the
		  *  JSON object returned by the service invocation.
		  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			setDeleteCartCookie();
			document.location.href=appendWcCommonRequestParameters("AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

		/**
		* display an error message.
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation.
		*/
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service enables customer to Renew a subscription.
	 *  @constructor
	 */
	wcService.declare({
		id: "SubscriptionRenew",
		actionId: "SubscriptionRenew",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing subscription to the shopping cart and calls service to update requested shipping date.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			var params = [];

			params.storeId		= MyAccountServicesDeclarationJS.storeId;
			params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
			params.langId		= MyAccountServicesDeclarationJS.langId;
			params.orderId      = serviceResponse.orderId;
			params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
			params.requestedShipDate = MyAccountDisplay.getSubscriptionDate();

			MyAccountDisplay.subscriptionOrderId = serviceResponse.orderId;
			MyAccountDisplay.subscriptionOrderItemId = serviceResponse.orderItemId[0];

			wcService.invoke("SetRequestedShippingDate",params);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service sets the requested shipping date for a subscription renewal.
	 *  @constructor
	 */
	wcService.declare({
		id: "SetRequestedShippingDate",
		actionId: "SetRequestedShippingDate",
		url: "AjaxRESTOrderShipInfoUpdate",
		formId: ""
	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			cursor_clear();
			document.location.href=appendWcCommonRequestParameters("RESTOrderPrepare?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&orderId="+serviceResponse.orderId+"&URL=AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET") {
				var params = [];

				params.storeId		= MyAccountServicesDeclarationJS.storeId;
				params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
				params.langId		= MyAccountServicesDeclarationJS.langId;
				params.orderId      = MyAccountDisplay.subscriptionOrderId;
				params.orderItemId      = MyAccountDisplay.subscriptionOrderItemId;
				params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
				wcService.invoke("RemoveSubscriptionItem",params);

				MessageHelper.displayStatusMessage(MessageHelper.messages["CANNOT_RENEW_NOW_MSG"]);
			}
			else{
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
				cursor_clear();
			}
		}

	}),

	/**
	 * This service removes the subscription item from the shopping cart if renewal fails.
	 * @constructor
	 */
	wcService.declare({
		id: "RemoveSubscriptionItem",
		actionId: "RemoveSubscriptionItem",
		url: "AjaxRESTOrderItemDelete",
		formId: ""

		/**
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation.
		 */
		,successHandler: function(serviceResponse) {
				cursor_clear();
		}

		 /**
		 * display an error message
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}
			cursor_clear();
		}

	}),

/**
 *  This service enables customer to cancel a scheduled order or an order waiting for approval.
 *  @constructor
 */
wcService.declare({
	id: "AjaxScheduledOrderCancel",
	actionId: "AjaxScheduledOrderCancel",
	url: "AjaxRESTRecurringOrSubscriptionCancel",
	formId: ""

	/**
	 * Displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MO_ORDER_CANCELED_MSG"]);
	}

	/**
	 * Displays an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used to display
 *and handle the information messages, error messages.
 */

if (typeof (MessageHelper) == "undefined" || !MessageHelper || !MessageHelper.topicNamespace) {

  /**
     * @class The MessageHelper class contains variables and functions that are used
     * to initialize, display and handle informational and error message.
     */
  MessageHelper = {
    /**A variable that contains all the messages to be displayed*/
    messages: {},

    /**
         * internal variable to keep track of the current element id that has
         * an error tooltip assigned to it */
    identifier: "",

    /**
         * internal variable to keep track of the element id that needs to
         * give focus to on dialog dismissal */
    focusElement: "",

    /**
         * returns the current year
         * @return (int) the current year
         */
    getCurrentYear: function () {
      return new Date().getFullYear();
    },

    /**
         * returns the current month. January is 1, and December is 12.
         * @return (int) the current month
         */
    getCurrentMonth: function () {
      return new Date().getMonth() + 1;
    },

    /**
         * returns the current day of the current month, starting from 1.
         * @return (int) the current day
         */
    getCurrentDay: function () {
      return new Date().getDate();
    },

    /**
         *
         *summary: retrieves the value of the property from a render context
         *description: This function retrieves the value of the property whose name is propertName
         *from the given context.
         *
         * @param (wc.render.Content) content The context in which the properties
         * belong to.
         * @param (string) propertyName The property to be retrieved
         * @return (string) null if the context is null. undefined if the property is not found.
         * otherwise, the value of the property int he given context.
         */
    getRenderContextProperty: function ( /*wc.render.Context*/ context, /*String*/ propertyName) {

      console.debug("enter getRenderContextProperty with propertyName = " + propertyName);
      if (context == null) {
        console.debug("context is null. Return null...");
        return null;
      }

      var result = context.properties[propertyName]
      console.debug("the found property value is: " + result);

      return result;
    },

    /**
         * This function is used to initialize the messages object with all the
         * required messages. It is used to setup a JS object with any key/value.
         * @param (string) key The key used to access this message.
         * @param (string) msg The message in the correct language.
         *
         */
    setMessage: function (key, msg) {
      this.messages[key] = msg;
    },
    /**
         * This function is used to initialize the element that needs to give focus to on dialog dismissal.
         * @param (string) element The element needs to give focus to.
         *
         */
    setFocusElement: function (element) {
      this.focusElement = element;
    },



    /**
         * Use fadeIn and fadeOut to display error and informative messages in the store.
         * @param (int) topOffset how far from the top the message display area will be displayed.
         */
    showHideMessageArea: function (topOffset) {
      cursor_clear();
      if (topOffset == null || topOffset == undefined) {
        topOffset = 0;
      }
      var node = $("#MessageArea");

      if ($("#MessageArea_ACCE_Title") !== null) {
        $("#MessageArea_ACCE_Title").css("display", "block");
      }
      // fade in
      $(node).fadeIn(200);


    },

    /**
         * Use fadeOut to hide error and informative messages in the store.
         */
    hideMessageArea: function () {
      cursor_clear();
      var focusOnElement = "";
      if (this.focusElement !== "" && $("#" + this.focusElement) !== null) {
        focusOnElement = $("#" + this.focusElement);
      }
      var node = $("#MessageArea");

      if ($("#MessageArea_ACCE_Title") !== null) {
        $("#MessageArea_ACCE_Title").css("display", "none");
      }
      if (document.getElementById(focusOnElement) != null) {
        focusOnElement.focus();
      }
      $(node).fadeOut(500);
      $('#ErrorMessageText').html("");
      this.focusElement = "";
      if (typeof removeCheckoutLoader == 'function') {
        setTimeout(removeCheckoutLoader, 250);
      }
      setTimeout(function() {
        $('#MessageArea .message_text').removeClass('oosMessage');
    }, 400);
    },

    /**
         * This function is used to display the error messages to the user.
         * @param (string) msg The error/information message to be displayed
         * @param (int) topOffset how far from the top the message display area will be displayed.
         * @param (boolean) showType whether or not the message type should be appended to the actual message
         *
         * @return (element) a HTML element that contains the error message.
         *
         */
    displayErrorMessage: function (msg, topOffset, showType) {
      //HB-1988 BEGIN
      restoreAjaxButtons();
      //HB-1988 END        

      if (topOffset == null || topOffset == undefined) {
        topOffset = 0;
      }

      if (showType == undefined || showType == null || showType == true) {
        //if showType is undefined, keep the FEP1 behaviour.
        if (this.messages["ERROR_MESSAGE_TYPE"] != null && this.messages["ERROR_MESSAGE_TYPE"] != 'undefined') {
          var MsgType = this.messages["ERROR_MESSAGE_TYPE"];
          msg = MsgType + msg;
        }
      }

      this.setMessageAreaStyle('error_icon');
      $('#ErrorMessageText').html(msg);
      $('#MessageArea').addClass('active');
      this.showHideMessageArea(topOffset);
      $('#clickableErrorMessageImg').focus();
      setTimeout(function () {
        if ($('#ErrorMessageText') !== null) {
          $('#ErrorMessageText').focus();
        }
      }, 1000);
      if (typeof TealeafWCJS != "undefined") {
        TealeafWCJS.logClientValidationCustomEvent({
          fieldId: "-1",
          message: msg
        });
      }
    },


    /**
         * Sets the style for the message area on the page.
         * @param (String) styleId The style Id.
         */
    setMessageAreaStyle: function (styleId) {
      $("#success_icon").css("display", "none");
      $("#error_icon").css("display", "none");
      if ($("#" + styleId) != null) {
        $("#" + styleId).css("display", "inline");
      }
    },


    /**
         * This function is used to display the informative messages to the user.
         * @param (string) msg The status message to be displayed.
         * @param (int) topOffset how far from the top of the browser the message will be displayed.
         * @return (element) a HTML element that contains the status message.
         */
    displayStatusMessage: function (msg, topOffset) {
      //HB-1988 BEGIN
      restoreAjaxButtons();
      //HB-1988 END
      
      if (topOffset == null || topOffset == undefined) {
        topOffset = 0;
      }
      this.setMessageAreaStyle('success_icon');
      $('#ErrorMessageText').html(msg);
      $('#MessageArea').addClass('active');
      this.showHideMessageArea(topOffset);
      $('#clickableErrorMessageImg').focus();
      
      setTimeout(function () {
        if ($('#ErrorMessageText') !== null) {
          $('#ErrorMessageText').focus();
        }
      }, 1000);
    },

    

    /**
         * This function is used to hide and clear the message display area in
         * the page.
         */
    hideAndClearMessage: function () {
      $('#ErrorMessageText').html("");
      $('#MessageArea').css("display", "none");
      $('#MessageArea').removeClass('active')
    },

    /**
         * This function is used to re-adjust the coordinates of the message display area on the page. Its location is relative to the "page" element.
         * @param (int) topOffset how far from the top the message display area will be displayed.
         */
    adjustCoordinates: function (topOffset) {
      if ($("#MessageArea").css("display") != "none") {
        var page = $("#page");
        var node = $("#MessageArea");
        if (page != null && node != null) {
          var postion = $(page).position();;
          var width = $(page).width();


          if (topOffset == null || topOffset == undefined) {
            topOffset = 0;
          }

          $(node).css({
            "width": width + 20 + "px",
            "left": postion.left - 10 + "px",
            "top": (postion.top + topOffset) + "px"
          });
        }
      }
    },

    /**
         * This function will show the an error message tooltip
         * around the input field with the problem.
         *
         * The function assumes the "serviceResponse" is the
         * JSON object from a WebSphere Commerce exception. The error
         * field is in the serviceResponse.errorMessageParam and the
         * error message is in the serviceResponse.errorMessage.
         *
         * @see MessageHelper.formErrorHandleClient
         * @param (object) serviceResponse The JSON object with the error data.
         * @param (string) formName The name of the form where the error field is.
         *
         */
    formErrorHandle: function (serviceResponse, formName) {

      this.formErrorHandleClient(serviceResponse.errorMessageParam, serviceResponse.errorMessage);

    },


    /**
         * This function will show the an error message tooltip
         * around the input field with the problem.
         *
         * This function will check for the emptiness of the required
         * filed and displays the "errorMessage" related to that field as a tooltip.
         * The tooltip will be closed on focus lost.
         *
         * @param (string) id The identifier for the filed in the form.
         * @param (string) errorMessage The message that should be displayed to the user.
         */
    formErrorHandleClient: function (id, errorMessage) {
      if (id.id) {
        id = id.id;
      }
      var element = $("#"+id);
      if (errorMessage == null) {
        console.debug("formErrorHandleClient: The error message is null.");
        return;
      }
      if (element) {
        if (Utils.has_ios()) {
          this.setMessageAreaStyle('error_icon');
          $('#MessageArea').css("display", "block");
          $('#ErrorMessageText').html(errorMessage);
          window.setTimeout( function (){window.scrollTo(0, 0);} , 0);
        } else if (this.identifier != (id + "_tooltip")) {
          element.focus();
          this.identifier = id + "_tooltip";
          var node = document.createElement('span');
          var imgDirPath = getImageDirectoryPath();
          if (Utils.get_IE_version() < 7) {
            node.innerHTML = errorMessage + "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" + imgDirPath + "images/empty.gif'></iframe>";
          } else {
            node.innerHTML = errorMessage;
          }


          if (Utils.hasTouch()) {
            var _this = this;
            setTimeout(function () {
              var _this = this;
              var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
              this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
              $("#" + id).after(this.tooltip);
              this.tooltip.position({
                my: "center top",
                at: "center bottom",
                of: $("#" + id)

              });

              $("#" + id).blur(function () {
                if (_this.tooltip) {
                  _this.tooltip.hide();
                  _this.tooltip.remove();
                }
                MessageHelper.clearCurrentIdentifier();

              });

            }, 1000);
          } else {
            var _this = this;
            var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
            this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
            $("#" + id).after(this.tooltip);
            this.tooltip.position({
              my: "center top",
              at: "center bottom",
              of: $("#" + id)

            });

            $("#" + id).blur(function () {
              if (_this.tooltip) {
                _this.tooltip.hide();
                _this.tooltip.remove();
              }
              MessageHelper.clearCurrentIdentifier();

            });

          }
        }
        if (typeof TealeafWCJS != "undefined") {
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: element.id,
            message: errorMessage
          });
        }
      }
    },

    /**
             * This function hides and destroys the current form error handler tooltip that is displayed
             * and clears the identifier that is currently tracked.
             */
    hideFormErrorHandle: function () {
      if (this.tooltip != null) {
        this.tooltip.destroyRecursive();
        this.tooltip = null;
        this.clearCurrentIdentifier();
      }
    },

    /**
             * This function clears the internal variable that has the element id
             * with the error tooltip.
             *
             */
    clearCurrentIdentifier: function () {

      this.identifier = "";
    },

    /**
             * This function is used to override any of the default functions
             * associated with the events. Ex: Tooltip widget tracks onMouseOver event
             * and display the tooltip. To remove this association,
             * tooltip widgets onMouseOver function will be overridden by this empty
             * function.
             *
             * It is an empty implementation which does nothing.
             *
             * @param (string) event  The event which triggers this function.
             */
    emptyFunc: function (event) {

    },



    /**
             * Checks whether a string contains a double byte character.
             *
             * @param (string) target the string to be checked
             * @return (boolean) true if target contains a double byte char;
             * false otherwise
             */
    containsDoubleByte: function (target) {

      var str = new String(target);
      var oneByteMax = 0x007F;

      for (var i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        if (chr > oneByteMax) {
          return true;
        }
      }
      return false;
    },

    /**
             * This function validate email address. It does not allow double byte
             * characters in the email address.
             *
             * @return (boolean) true if the email address is valid; false otherwise
             *
             * @param (string) strEmail the email address string to be validated
             */
    isValidEmail: function (strEmail) {

      if (this.containsDoubleByte(strEmail)) {
        return false;
      }

      if (strEmail.length == 0) {
        return true;
      } else if (strEmail.length < 5) {
        return false;
      } else {
        if (strEmail.indexOf(" ") > 0) {
          return false;
        } else {
          if (strEmail.indexOf("@") < 1) {
            return false;
          } else {
            if (strEmail.lastIndexOf(".") < (strEmail.indexOf("@") + 2)) {
              return false;
            } else {
              if (strEmail.lastIndexOf(".") >= strEmail.length - 2) {
                return false;
              }
            }
          }
        }
      }
      return true;
    },

    /**
             * This function will check if the number of bytes of the string
             * is within the maxlength specified.
             *
             * @param (string) UTF16String the UTF-16 string
             * @param (int) maxlength the maximum number of bytes allowed in your input
             *
             * @return (boolean) false is this input string is larger than maxlength
             */
    isValidUTF8length: function (UTF16String, maxlength) {
      if (this.utf8StringByteLength(UTF16String) > maxlength) return false;
      else return true;
    },

    /**
             * This function will count the number of bytes represented in a UTF-8
             * string.
             *
             * @param (string) UTF16String the UTF-16 string you want a byte count of
             * @return (int) the integer number of bytes represented in a UTF-8 string
             */
    utf8StringByteLength: function (UTF16String) {

      if (UTF16String === null) return 0;

      var str = String(UTF16String);
      var oneByteMax = 0x007F;
      var twoByteMax = 0x07FF;
      var byteSize = str.length;

      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        if (chr > oneByteMax) byteSize = byteSize + 1;
        if (chr > twoByteMax) byteSize = byteSize + 1;
      }
      return byteSize;
    },

    /**
             * this function will check whether the text is a numeric or not.
             *
             * @param allowDot is a boolean wich specifies whether to consider
             * the '.' or not.
             *
             * @return (boolean) true if text is numeric
             */
    IsNumeric: function (text, allowDot) {
      if (allowDot) var ValidChars = "0123456789.";
      else var ValidChars = "0123456789";

      var IsNumber = true;
      var Char;


      for (i = 0; i < text.length && IsNumber == true; i++) {
        Char = text.charAt(i);
        if (ValidChars.indexOf(Char) == -1) {
          IsNumber = false;
        }
      }
      return IsNumber;
    },

    /**
             *
             *This function will check for a valid Phone Number
             *
             *@param (string) text The string to check
             *
             *@return (boolean) true if text is a phone number, ie if each character of
             *input is one of 0123456789() -+
             */
    IsValidPhone: function (text) {

      var ValidChars = "0123456789()-+ ";

      var IsValid = true;
      var Char;

      for (i = 0; i < text.length && IsValid == true; i++) {
        Char = text.charAt(i);
        if (ValidChars.indexOf(Char) == -1) {
          IsValid = false;
        }
      }
      return IsValid;
    },

    /**
             *  To use confirmation popup, the ${StoreDirectory}/Common/ConfirmationPopup.jspf must be included
             *  in the jsp page where the confirmation popup launches from.
             *	This function launch confirmation popup
             *
             * @param (string) topicName The name of the topic that calling widget subscribing to.
             * @param (stirng) message The message to be displayed in the confirmation dialog.
             */
    showConfirmationDialog: function (topicName, message) {
      $("#confirmationPopupMessage").html(message);
      var confirmationPopupWidget = $("#confirmationPopup").data("wc-WCDialog"),
          // Also add a namespace to the click event so we
          // only remove our click handler instead of other click handlers
          eventName = "click.MessageHelper";
      // Do this only once.
      confirmationPopupWidget.primary_button.one(eventName, function (e) {
        e.preventDefault();
        confirmationPopupWidget.secondary_button.off(eventName);
        wcTopic.publish(topicName, {
          action: "YES"
        });
      });

      confirmationPopupWidget.secondary_button.one(eventName, function (e) {
        e.preventDefault();
        confirmationPopupWidget.primary_button.off(eventName);
        wcTopic.publish(topicName, {
          action: "NO"
        });
      });
      confirmationPopupWidget.open();

    }
  }
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Global Login widget to handle the services
 * @version 1.10
 */

/* global document, window, $, wc, Utils, WCParamJS, MessageHelper, cursor_clear, getAbsoluteURL */


/**
 * This service allows customer to sign in
 * @constructor
 */
wcService.declare({
    id: "globalLoginAjaxLogon", 
    actionId: "globalLoginAjaxLogon",
    url: getAbsoluteURL() + "AjaxLogon",
    formId: "",

    /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        cursor_clear();
        var errorMessage = "";
        
        // START - HB-16650
        if(localStorage.getItem('trackMyOrder')){
        	localStorage.removeItem('trackMyOrder');
        }
        // END - HB-16650
        
        if (serviceResponse.ErrorCode != null) {
            var errorCode = Number(serviceResponse.ErrorCode);
            switch (errorCode) {
            case 2000:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2000"];
                break;
            case 2010:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2010"];
                break;
            case 2020:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2020"];
                break;
            case 2030:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"];
                break;
            case 2110:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2300:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2300"];
                break;
            case 2340:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2340"];
                break;
            case 2400:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2400"];
                break;
            case 2410:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2410"];
                break;
            case 2420:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2420"];
                break;
            case 2430:
                document.location.href = "ResetPasswordForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode;
                break;
            case 2490:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2170:
                document.location.href = "ChangePassword?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode + "&logonId=" + serviceResponse.logonId;
                break;
            case 2570:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2570"];
                break;
            case 2440:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2440"];
                break;
            case 2450:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2450"];
                break;
            case 2711 : 
                GlobalLoginJS.InitHTTPSecureFromPolicy();
                GlobalLoginJS.showPolicyPopup();
                	
            }
            if (document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL") != null) {
                document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL").innerHTML = errorMessage;
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.querySelectorAll(".form-group .myaccount_error").forEach((el) => {
                    el.classList.add("active");
                });
            }

            /*--- WCAG Begin MCB --*/
            var attr = $('.myaccount_error').attr('tabindex');
            if(!(typeof attr !== typeof undefined && attr !== false)) {
                $('.myaccount_error').attr('tabindex', '0');
            }
            //this if prevents js error if WCAG.js are not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }
            /*--- WCAG Begin MCB --*/

            /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
	            var code = 'Error while trying to login user';
	            pushErrorToTealium('Server', '', code, errorMessage);
            }
            /* TEALIUM END */

        } else {
        	sessionStorage.setItem('logged', 'true');
            var url = serviceResponse.URL[0].replace(/&amp;/g, '&'),
                languageId = serviceResponse.langId;
            if (languageId != null && document.getElementById('langSEO' + languageId) != null) { // Need to switch language.

                var browserURL = document.location.href,
                    currentLangSEO = '/' + $('#currentLanguageSEO').val() + '/';

                if (browserURL.indexOf(currentLangSEO) !== -1) {
                    // If it's SEO URL.
                    var preferLangSEO = '/' + $('#langSEO' + languageId).val() + '/';

                    var query = url.substring(url.indexOf('?') + 1, url.length),
                        parameters = Utils.queryToObject(query);
                    if (parameters["URL"] != null) {
                        var redirectURL = parameters["URL"],
                            query2 = redirectURL.substring(redirectURL.indexOf('?') + 1, redirectURL.length),
                            parameters2 = Utils.queryToObject(query2);
                        // No redirect URL
                        if (parameters2["URL"] != null) {
                            var finalRedirectURL = parameters2["URL"];
                            if (finalRedirectURL.indexOf(currentLangSEO) != -1) {
                                // Get the prefer language, and replace with prefer language.
                                finalRedirectURL = finalRedirectURL.replace(currentLangSEO, preferLangSEO);
                                parameters2["URL"] = finalRedirectURL;
                            }
                            query2 = $.param(parameters2);
                            redirectURL = redirectURL.substring(0, redirectURL.indexOf('?')) + '?' + query2;
                        } else {
                            //Current URL is the final redirect URL.
                            redirectURL = redirectURL.toString().replace(currentLangSEO, preferLangSEO);
                        }
                        parameters["URL"] = redirectURL;
                    }
                    query = $.param(parameters);
                    url = url.substring(0, url.indexOf('?')) + '?' + query;

                } else {
                    // Not SEO URL.
                    // Parse the parameter and check whether if have langId parameter.
                    if (url.contains('?')) {
                        var query = url.substring(url.indexOf('?') + 1, url.length),
                            parameters = Utils.queryToObject(query);
                        if (parameters["langId"] != null) {
                            parameters["langId"] = languageId;
                            var query2 = $.param(parameters);
                            url = url.substring(0, url.indexOf('?')) + '?' + query2;
                        } else {
                            url = url + "&langId=" + languageId;
                        }
                    } else {
                        url = url + "?langId=" + languageId;
                    }
                }
            }

            if (isPersol && $("#page").hasClass("checkout")){
                var physicalStoreSelectionURL = $("#GLPhysicalStoreSelectionURL").val();
                var billingShippingPageURLForOnline = $("#GLRegisteredUserOrderCalculateURL").val();
		
                if (ShipmodeSelectionExtJS.isBOPISEnabled() && ShipmodeSelectionExtJS.isPickUpInStore()) {
                    url = physicalStoreSelectionURL;
                } else {
                    url = billingShippingPageURLForOnline;
                }
            }

            if (serviceResponse["MERGE_CART_FAILED_SHOPCART_THRESHOLD"] == "1") {
                setCookie("MERGE_CART_FAILED_SHOPCART_THRESHOLD", "1", {path: "/", domain: cookieDomain});
            }

            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */

            /* START - Wishlist */
            if (isPersol || isOliver) {
                sessionStorage.removeItem("defaultWishlistExternalId");
                sessionStorage.removeItem("wishlistObj");
            }
            /* END - Wishlist */

            window.location = url;

             /*--- WCAG Begin MCB --*/
             var attr = $('.myaccount_error').attr('tabindex');
             if(typeof attr !== typeof undefined && attr !== false) {
                 $('.myaccount_error'). removeAttr('tabindex');
             }
             /*--- WCAG Begin MCB --*/
            
            /* TEALIUM BEGIN Login success */
            /* HB-11904 BEGIN*/
            /*if(typeof tealium_data2track !== 'undefined'){
                tealium_data2track.push({
             	   'id' : 'X-X-CheckoutDelivery-Login',
             	   'User_Email_MD5' : serviceResponse.userEmail
             	});
            }*/
            /* HB-11904 END*/
            /* TEALIUM END */
        }
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides all the functions and variables to manage Global Login panel.
 */

/* global document, window, $, setCookie, getCookie, cookieDomain, WCParamJS, GlobalLoginJS, Utils, cursor_clear, cursor_wait, submitRequest, wc, processAndSubmitForm, invokeItemAdd, invokeOtherService, isOnPasswordUpdateForm, service */

/**
* Constant key in activePanel
*/
var KEY_ACTIVE = 'active',

    /**
    * Constant key in activePanel
    */
    KEY_SELECTED = 'selected'; 

GlobalLoginJS = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    activePanel: {},

    widgetsLoadedOnPage: [],

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    isPanelVisible: true,

    /**
     * True if mouse down event registered, false otherwise (prevents registering
     * event more than once).
     */
    mouseDownConnectHandle: null,
          
    logonId:null,
        
    reLogonURL : null,
       
    URL:null,
    
    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        cursor_clear();
    },

    hideGLPanel: function (isPanelVisible) {
        this.isPanelVisible = isPanelVisible;
    },

    registerWidget: function (widgetId) {
        this.widgetsLoadedOnPage.push(widgetId);
    },
    
       
      /**
       * 
       */
     InitHTTPSecureFromPolicy : function(){
        	
        	 var href = document.location.href;
             var index = href.lastIndexOf("s", 4);
        	
             if(index == -1){
             	// Loaded with HTTP. Change it to HTTPS along with appropriate port.
         		if (WCParamJS.urlPrefixForHTTP) {
         			var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
         			index = newHref.indexOf("/");
         			newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
         		} else {
         			var newHref = href.substring(0,4) + "s" + (href.substring(4));
        		}
                 setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                     path: '/',
                     domain: cookieDomain
                 });
                 window.location = newHref;
             }
    
            
            return;
        	
     },

    InitHTTPSecure: function (widgetId) {
        var href = document.location.href;
        var index = href.lastIndexOf("s", 4);

        if (index != -1) {
            // Open sign in panel if loaded with HTTPS.
            GlobalLoginJS.displayPanel(widgetId);

        } else {
			// Loaded with HTTP. Change it to HTTPS along with appropriate port.
			if (WCParamJS.urlPrefixForHTTP) {
				var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
				index = newHref.indexOf("/");
				newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
			} else {
				var newHref = href.substring(0,4) + "s" + (href.substring(4));
			}
            setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                path: '/',
                domain: cookieDomain
            });
            window.location = newHref;
            return;
        }
    },

    displayPanel: function (widgetId) {
        //check if the sign in panel is loaded. if loaded, toggle the dropdown. Else, trigger a refresh.
        var widgetNode = $("#" + widgetId);
        if (widgetNode.length > 0) {
            var panelLoaded = widgetNode.attr("panel-loaded");
            if (panelLoaded) {
                this.togglePanel(widgetNode);
            } else if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
                if (!submitRequest()) {
                    return;
                }
                cursor_wait();
                wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId" : widgetId});
            }
        }
    },

    togglePanel: function (widgetNode) {
        // toggle the current active global login panel
    	 if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
    		 //HB-661
    		 var idPrefix = this.activePanel[KEY_ACTIVE] + "_";
    		 var form_input_user = idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1";
    		 var form_input_pass = idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1";
    		 if (!$("#" + form_input_user).is(":focus") && !$("#" + form_input_pass).is(":focus")) {
    			 $("#" + this.activePanel[KEY_ACTIVE]).toggleClass("active");
	             $("#" + this.activePanel[KEY_SELECTED]).toggleClass("selected");
	
	             //if the current active panel is not the caller
	             if (this.activePanel[KEY_ACTIVE] != widgetNode.attr("id")) {
	                 var toggleControl = widgetNode.attr("data-toggle-control");
	                 //toggle current widget
	                 widgetNode.toggleClass("active");
	                 toggleControl.toggleClass("selected");
	
	                 //set the current caller as active
	                 this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
	                 this.activePanel[KEY_SELECTED] = toggleControl;
	             } else {
	                 delete this.activePanel.active;
	                 delete this.activePanel.selected;
	                 widgetNode.attr("panel-loaded", false);
	                 this.unregisterMouseDown();
	             }
    		 }
         } else {
             var toggleControl = widgetNode.attr("data-toggle-control");
             //no panel is active. toggle the current
             widgetNode.toggleClass("active");
             $("#" + toggleControl).toggleClass("selected");

             //set the current caller as active
             this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
             this.activePanel[KEY_SELECTED] = toggleControl;
             this.registerMouseDown();
         }
    },

    updateGlobalLoginSignInContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        var redirectToPageName = getCookie("WC_RedirectToPage_" + WCParamJS.storeId);
        if (redirectToPageName != undefined && redirectToPageName != null) {
            setCookie("WC_RedirectToPage_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId": widgetId, "redirectToPageName": redirectToPageName});
    },

    updateGlobalLoginUserDisplay: function (displayName) {
        $("#Header_GlobalLogin_signOutQuickLinkUser").html(displayName);
    },

    updateGlobalLoginContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if($('#'+widgetId).length){
	    	wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"true", "widgetId": widgetId});
	    }else{
	    	cursor_clear();
	    }
    },

    updateOrganization: function (formName, widgetId) {
        var orgSetInSessionURL = widgetId + '_' + 'orgSetInSessionURL';
        var orgSetInSessionURLEle = document.getElementById(orgSetInSessionURL);
        if (orgSetInSessionURLEle != null) {
            var href = document.location.href;
            orgSetInSessionURLEle.value = href;
        }
        var form = document.forms[widgetId + '_' + formName];
        if (!submitRequest()) {
            return;
        }
        processAndSubmitForm(form);
    },

    prepareSubmit: function (widgetId) {
        var idPrefix = widgetId + "_";
        if (document.getElementById(idPrefix + "signInDropdown") != null && document.getElementById(idPrefix + "signInDropdown").className.indexOf("active") > -1) {
            document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").setAttribute("class", "wcag__error errorLabel");
            document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").setAttribute("class", "wcag__error errorLabel");
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className = document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className + " active";
                    return false;
                }
            }
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className = document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className + " active";
                    return false;
                }
            }
        }
        return true;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str == '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Updates the contract that is available to the current user.
     * @param {string} formName  The name of the form that contains the selected contracts.
     */
    updateContract: function (formName) {
        var form = document.forms[formName];

        /* For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }

        form.submit();
    },

    deleteUserLogonIdCookie: function (contractURL) {
        var userLogonIdCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        sessionStorage.setItem('logged', 'false');
        if (userLogonIdCookie != null) {
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        /* START - Wishlist */
        if (isPersol || isOliver) {
            sessionStorage.removeItem("defaultWishlistExternalId");
            sessionStorage.removeItem("wishlistObj");
        }
        /* END - Wishlist */
    },

    changeRememberMeState: function (jspStoreImgDir, target) {
        var targetEle = document.getElementById(target);
        if (targetEle.className.indexOf("active") > -1) {
            targetEle.className = targetEle.className.replace('active', '');
            targetEle.setAttribute("aria-checked", "false");
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox.png");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "false");
        } else {
            targetEle.className = targetEle.className + " active";
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox_checked.png");
            targetEle.setAttribute("aria-checked", "true");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "true");
        }
    },

    deleteLoginCookies: function () {
        this.deleteUserLogonIdCookie();
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
    },

    /**
     * Submit a global login sign in form
     * @param (object) widgetId The form widgetId id.
     */
    submitGLSignInForm: function (formId, widgetId) {
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var logonForm = document.getElementById(formId);
        if(logonForm != null){
        	if(logonForm.logonId != null){
                this.logonId = logonForm.logonId.value;
        	}
        	if(logonForm.URL != null){
        		this.URL = logonForm.URL.value
        	}
        	if(logonForm.reLogonURL != null){
        		this.relogonURL = logonForm.reLogonURL.value;
        	}
        }

        
        var params = {
            widgetId: widgetId,
            acceptedPolicyValue: 'false',
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke('globalLoginAjaxLogon', params);
    },
    
    /**
     * 
     */
    submitGLSignInFormFromPolicyPopup : function(formId,widgetId,reLogonURL){
    	
        var encodedReLogonURI = encodeURI(reLogonURL);
        var acceptedPolicyValue = "";
           	
        //NERD-93 accept policy
        var acceptPolicyCheckBox = document.getElementById('agreeConcent_popup');

        
        if(acceptPolicyCheckBox != null){
        	acceptedPolicyValue = acceptPolicyCheckBox.checked;
        }
                
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var params = {
            acceptedPolicyValue:acceptedPolicyValue,
        	reLogonURL : this.relogonURL,
            URL : this.URL,
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        
        wcService.invoke('globalLoginAjaxLogon', params);
    	
    },

    /**
     * After successful login and setting a contract in session, we need to process the action that the shopper
     * was performing before signing in. It will do nothing if shopper was not trying to perform any actions.
     */
    processNextURL: function () {
        var myNextURL = getCookie("WC_nextURL_" + WCParamJS.storeId);
        if (myNextURL != undefined && myNextURL.length > 0) {
            myNextURL = myNextURL.replace(/&amp;/g, "&");
            if (myNextURL.indexOf('AjaxRESTOrderItemAdd') != -1) {
                invokeItemAdd(myNextURL);
            } else {
                invokeOtherService(myNextURL);
            }
        }
    },

    registerMouseDown: function () {
        if (!this.mouseDownConnectHandle) {
            $(document.documentElement).on("mousedown", $.proxy(this.handleMouseDown, this));
            this.mouseDownConnectHandle = true;
        }
    },

    unregisterMouseDown: function () {
        if (this.mouseDownConnectHandle) {
            $(document.documentElement).off("mousedown");
            this.mouseDownConnectHandle = false;
        }
    },

    handleMouseDown: function (evt) {
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            Utils.ifSelectorExists("#" + this.activePanel[KEY_ACTIVE], function(widgetNode) {
                var toggleControl = $("#" + this.activePanel[KEY_SELECTED]);
                var node = evt.target;
                if (node != document.documentElement) {
                    var close = true;
                    while (node && node != document.documentElement) {
                        if (Utils.elementExists("#" + node.id + "_dropdown") && Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") != null && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position(node),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropdownHeight = $("#" + node.id + "_dropdown").get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                $("#" + node.id + "_dropdown").css("height", newHeight + "px");
                            }
                        }
                        if (widgetNode.is(node) || toggleControl.is(node) || $(node).hasClass("dijitPopup")) {
                            close = false;
                            break;
                        }
                        node = node.parentNode;
                    }
                    node = null;
                    if (node == null) {
                        widgetNode.children("div").each(function(i, e) {
                            var position = Utils.position(e);
                            if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                                evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                                close = false;
                                return false; // breaks
                            }
                        });
                        if (Utils.elementExists("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown") &&
                            $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown").css("display") != "none" &&
                            Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2"),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropDown = $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown"),
                                dropdownHeight = dropDown.get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                dropDown.css("height", newHeight + "px");
                            }
                        }
                    }
                    if (close) {
                        this.togglePanel(widgetNode);
                    }
                }
            }, this);
        }
    },
    
      /**
        * show store policy popup
        */
       showPolicyPopup : function(){
         var policyPopup = $('#acceptance_policy_popup');
         policyPopup.data("wc-WCDialog").open();
        },
        
        /**
         * hides store policy popup
         */
        hidePolicyPopup : function(){
        	var policyPopup = $('#acceptance_policy_popup');
        	policyPopup.data("wc-WCDialog").close();
         }
};
/*
 * Copyright (C) 2012 PrimeBox
 * 
 * This work is licensed under the Creative Commons
 * Attribution 3.0 Unported License. To view a copy
 * of this license, visit
 * http://creativecommons.org/licenses/by/3.0/.
 * 
 * Documentation available at:
 * http://www.primebox.co.uk/projects/cookie-bar/
 * 
 * When using this software you use it at your own risk. We hold
 * no responsibility for any damage caused by using this plugin
 * or the documentation provided.
 */
(function($){
	$.cookieBar = function(options,val){
		if(options=='cookies'){
			var doReturn = 'cookies';
		}else if(options=='set'){
			var doReturn = 'set';
		}else{
			var doReturn = false;
		}
		var defaults = {
			message: 'We use cookies to track usage and preferences.', //Message displayed on bar
			acceptButton: true, //Set to true to show accept/enable button
			acceptText: 'I Understand', //Text on accept/enable button
			acceptFunction: function(cookieValue){if(cookieValue!='enabled' && cookieValue!='accepted') window.location = window.location.href;}, //Function to run after accept
			declineButton: false, //Set to true to show decline/disable button
			declineText: 'Disable Cookies', //Text on decline/disable button
			declineFunction: function(cookieValue){if(cookieValue=='enabled' || cookieValue=='accepted') window.location = window.location.href;}, //Function to run after decline
			policyButton: false, //Set to true to show Privacy Policy button
			policyText: 'Privacy Policy', //Text on Privacy Policy button
			policyURL: '/privacy-policy/', //URL of Privacy Policy
			autoEnable: true, //Set to true for cookies to be accepted automatically. Banner still shows
			acceptOnContinue: false, //Set to true to accept cookies when visitor moves to another page
			acceptOnScroll: false, //Set to true to accept cookies when visitor scrolls X pixels up or down
			acceptAnyClick: false, //Set to true to accept cookies when visitor clicks anywhere on the page
			expireDays: 365, //Number of days for cookieBar cookie to be stored for
			renewOnVisit: false, //Renew the cookie upon revisit to website
			forceShow: false, //Force cookieBar to show regardless of user cookie preference
			effect: 'slide', //Options: slide, fade, hide
			element: 'body', //Element to append/prepend cookieBar to. Remember "." for class or "#" for id.
			append: false, //Set to true for cookieBar HTML to be placed at base of website. Actual position may change according to CSS
			fixed: false, //Set to true to add the class "fixed" to the cookie bar. Default CSS should fix the position
			bottom: false, //Force CSS when fixed, so bar appears at bottom of website
			zindex: '', //Can be set in CSS, although some may prefer to set here
			domain: String(window.location.hostname), //Location of privacy policy
			referrer: String(document.referrer) //Where visitor has come from
		};
		var options = $.extend(defaults,options);
		
		//Sets expiration date for cookie
		var expireDate = new Date();
		expireDate.setTime(expireDate.getTime()+(options.expireDays*86400000));
		expireDate = expireDate.toGMTString();
		
		var cookieEntry = 'cb-enabled={value}; expires='+expireDate+'; path=/';
		
		//Retrieves current cookie preference
		var i,cookieValue='',aCookie,aCookies=document.cookie.split('; ');
		for (i=0;i<aCookies.length;i++){
			aCookie = aCookies[i].split('=');
			if(aCookie[0]=='cb-enabled'){
    			cookieValue = aCookie[1];
			}
		}
		//Sets up default cookie preference if not already set
		if(cookieValue=='' && doReturn!='cookies' && options.autoEnable){
			cookieValue = 'enabled';
			document.cookie = cookieEntry.replace('{value}','enabled');
		}else if((cookieValue=='accepted' || cookieValue=='declined') && doReturn!='cookies' && options.renewOnVisit){
			document.cookie = cookieEntry.replace('{value}',cookieValue);
		}
		if(options.acceptOnContinue){
			if(options.referrer.indexOf(options.domain)>=0 && String(window.location.href).indexOf(options.policyURL)==-1 && doReturn!='cookies' && doReturn!='set' && cookieValue!='accepted' && cookieValue!='declined'){
				doReturn = 'set';
				val = 'accepted';
			}
		}
		if(doReturn=='cookies'){
			//Returns true if cookies are enabled, false otherwise
			if(cookieValue=='enabled' || cookieValue=='accepted'){
				return true;
			}else{
				return false;
			}
		}else if(doReturn=='set' && (val=='accepted' || val=='declined')){
			//Sets value of cookie to 'accepted' or 'declined'
			document.cookie = cookieEntry.replace('{value}',val);
			if(val=='accepted'){
				return true;
			}else{
				return false;
			}
		}else{
			//Sets up enable/accept button if required
			var message = options.message.replace('{policy_url}',options.policyURL);
			
			if(options.acceptButton){
                //Changed for WCAG - Miguel Castro
                var acceptButton = '<bt tabindex="0" class="cb-enable">'+options.acceptText+'</bt>';
                // var acceptButton = '<bt href="#" class="cb-enable">'+options.acceptText+'</bt>';
			}else{
				var acceptButton = '';
			}
			//Sets up disable/decline button if required
			if(options.declineButton){
				var declineButton = '<bt href="#" class="cb-disable">'+options.declineText+'</bt>';
			}else{
				var declineButton = '';
			}
			//Sets up privacy policy button if required
			if(options.policyButton){
				var policyButton = '<bt href="'+options.policyURL+'" class="cb-policy">'+options.policyText+'</bt>';
			}else{
				var policyButton = '';
			}
			//Whether to add "fixed" class to cookie bar
			if(options.fixed){
				if(options.bottom){
					var fixed = ' class="fixed bottom"';
				}else{
					var fixed = ' class="fixed"';
				}
			}else{
				var fixed = '';
			}
			if(options.zindex!=''){
				var zindex = ' style="z-index:'+options.zindex+';"';
			}else{
				var zindex = '';
			}
			
			//Displays the cookie bar if arguments met
			if(options.forceShow || cookieValue=='enabled' || cookieValue==''){
				if(options.append){
					$(options.element).append('<div id="cookie-bar"'+fixed+zindex+'><div>'+'<p>'+message+'</p>'+acceptButton+declineButton+policyButton+'</div></div>');
				}else{
					$(options.element).prepend('<div id="cookie-bar"'+fixed+zindex+'><div>'+'<p>'+message+'</p>'+acceptButton+declineButton+policyButton+'</div></div>');
				}
			}
			
			var removeBar = function(func){
				if(options.acceptOnScroll) $(document).off('scroll');
				if(typeof(func)==='function') func(cookieValue);
				if(options.effect=='slide'){
					$('#cookie-bar').slideUp(300,function(){$('#cookie-bar').remove();});
				}else if(options.effect=='fade'){
					$('#cookie-bar').fadeOut(300,function(){$('#cookie-bar').remove();});
				}else{
					$('#cookie-bar').hide(0,function(){$('#cookie-bar').remove();});
				}
				$(document).unbind('click',anyClick);
			};
			var cookieAccept = function(){
				document.cookie = cookieEntry.replace('{value}','accepted');
				removeBar(options.acceptFunction);
			};
			var cookieDecline = function(){
				var deleteDate = new Date();
				deleteDate.setTime(deleteDate.getTime()-(864000000));
				deleteDate = deleteDate.toGMTString();
				aCookies=document.cookie.split('; ');
				for (i=0;i<aCookies.length;i++){
					aCookie = aCookies[i].split('=');
					if(aCookie[0].indexOf('_')>=0){
						document.cookie = aCookie[0]+'=0; expires='+deleteDate+'; domain='+options.domain.replace('www','')+'; path=/';
					}else{
						document.cookie = aCookie[0]+'=0; expires='+deleteDate+'; path=/';
					}
				}
				document.cookie = cookieEntry.replace('{value}','declined');
				removeBar(options.declineFunction);
			};
			var anyClick = function(e){
				if(!$(e.target).hasClass('cb-policy')) cookieAccept();
			};
			
			$('#cookie-bar .cb-enable').click(function(){cookieAccept();return false;});
			$('#cookie-bar .cb-disable').click(function(){cookieDecline();return false;});
			if(options.acceptOnScroll){
				var scrollStart = $(document).scrollTop(),scrollNew,scrollDiff;
				$(document).on('scroll',function(){
					scrollNew = $(document).scrollTop();
					if(scrollNew>scrollStart){
						scrollDiff = scrollNew - scrollStart;
					}else{
						scrollDiff = scrollStart - scrollNew;
					}
					if(scrollDiff>=Math.round(options.acceptOnScroll)) cookieAccept();
				});
			}
			if(options.acceptAnyClick){
				$(document).bind('click',anyClick);
			}
		}
	};
})(jQuery);
/* ------- Begin Common/WCAG/WCAG.js ------- */

$(document).ready(function () {
    /**
     * This function looks for all the ID on the current page, except for Vogue brand.
     * If there is any ID duplicated, it will change it.
     */
    if(!isVogue) {
        document.querySelectorAll('[id]').forEach(function (cur) {
            var ids = document.querySelectorAll('[id="' + cur.id + '"]');
            var labels = document.querySelectorAll('[for="' + cur.id + '"]');
            var curId = cur.id;
    
            if (ids.length > 1) {
                ids.forEach(function (cur, index) {
                    if (index !== 0) {
                        cur.setAttribute('id', curId + "_" + index);
                        console.debug('----------------------------------');
                        $('#' + curId).siblings().each(function() {
                            var hasComment = false;
                            $(this).contents().each(function() {                            
                                if (this.nodeType == 8) {
                                    var msg = '';
                                    if(this.nodeValue != null || this.nodeValue !=undefined) {
                                        msg = (this.nodeValue).trim();
                                    }
                                    if (msg.startsWith('Begin') || msg.startsWith('BEGIN')) {
                                        //This comment shows in which JSP/JSPF the duplicated id is
                                        console.debug('MCB ---> jsp/jspf: ' + this.nodeValue);
                                        hasComment = true;
                                        if(msg.includes('Content_UI')) {
                                            //This comment shows in which EMS the duplicated id is
                                            console.debug('MCB ---> EMS: ' + this.parentElement.id);
                                        }
                                        return false;
                                    }
                                }
                            });
                            if(hasComment) {
                                return false;
                            }
                        });
                        $('#' + curId).parents().each(function() {
                            var hasComment = false;
                            $(this).contents().each(function() {                            
                                if (this.nodeType == 8) {
                                    var msg = '';
                                    if(this.nodeValue != null || this.nodeValue !=undefined) {
                                        msg = (this.nodeValue).trim();
                                    }
                                    if (msg.startsWith('Begin') || msg.startsWith('BEGIN')) {
                                        //This comment shows in which JSP/JSPF the duplicated id is
                                        console.debug('MCB ---> jsp/jspf: ' + this.nodeValue);
                                        hasComment = true;
                                        if(msg.includes('Content_UI')) {
                                            //This comment shows in which EMS the duplicated id is
                                            console.debug('MCB ---> EMS: ' + this.parentElement.id);
                                        }
                                        return false;
                                    }
                                }
                            });
                            if(hasComment) {
                                return false;
                            }
                        });
                        //This comment shows the duplicated id                              
                        console.debug('MCB ---> ID duplicado: ' + curId);
                        console.debug('----------------------------------');
                    }
                });
            }

            //This code only affects at duplicated ids inside the for label's attribute
            if (labels.length > 1) {
                labels.forEach(function (cur, index) {
                    if (index !== 0) {
                        cur.setAttribute('for', curId + "_" + index);
                        console.debug('----------------------------------');
                        $('#' + curId).parents().each(function() {
                            var hasComment = false;
                            $(this).contents().each(function() {                            
                                if (this.nodeType == 8) {
                                    var msg = '';
                                    if(this.nodeValue != null || this.nodeValue !=undefined) msg = (this.nodeValue).trim();
                                    if (msg.startsWith('Begin') || msg.startsWith('BEGIN')) {
                                        //This comment shows in which JSP/JSPF the duplicated id is
                                        console.debug('MCB ---> jsp/jspf: ' + this.nodeValue);
                                        hasComment = true;
                                        if(msg.includes('Content_UI')) {
                                            //This comment shows in which EMS the duplicated id is
                                            console.debug('MCB ---> EMS: ' + this.parentElement.id);
                                        }
                                        return false;
                                    }
                                }
                            });
                            if(hasComment) {
                                return false;
                            }
                        });
                        //This comment shows the duplicated id                                
                        console.debug('MCB ---> FOR duplicado: ' + curId);
                        console.debug('----------------------------------');
                    }
                });
            }                       
        });
    }
});

$(window).on('load', function () {
    defautBehaviourOwlCarousel();
    clickOnElementWithEnter();
    closeElementOnEscape();

    $('.prop65__a').click(function() {
    	$('html').css('overflow', 'hidden');
        $('body').prepend($('#prop65__popup')[0]);
        $('#prop65__popup').addClass('display');
        $('.prop65__popup-wrapper *:focusable').first().focus();
    });
    
    $('.prop65__close').click(function() {
    	$('html').css('overflow', 'unset');
        $('#prop65__popup').removeClass('display');
    });
});

/**
 * This function change all tabindex inside a block of code from 0 to -1 or vice versa
 * 
 * @param {content} -  code block to change the tabindex of its elements
 */
function changeTabIndex(content) {
    $(content).find('*').each(function(){
        var attr = $(this).attr('tabindex');
        if(typeof attr !== typeof undefined && attr !== false) {
            if(attr === '0') {
                $(this).attr('tabindex', '-1').removeClass('focus');
            } else {
                $(this).attr('tabindex', '0').addClass('focus');
            }
        }
    });
}

/**
 * Function that adds a focus only with tab press
 */
function setFocusOnTab() {
    
    $(':focusable, *[tabindex]:not([tabindex="-1"]), button, a, .button_primary').keyup(function (e) {
        var key = e.which;
        if (key == 9) {
            $(this).addClass('focus');
            // console.log('Element with focus::' + document.activeElement.innerHTML);
        }
    }).blur(function () {
        $(this).removeClass('focus');
    });
}

/**
 * Function that make a click event on the focused element when you press enter
 */
function clickOnElementWithEnter() {
    $(':focusable, *[tabindex]:not([tabindex="-1"]), button, a').keyup(function (e) {
        var key = e.which;
        if (key == 13) {
            var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
            var isAdd2Cart = $(this).is('#add2CartBtn');
            var isDropDownInput = $(this).find('*[role="option"]').length > 0;
            var attr = $(this).attr('href');

            if ($(this).is('[aria-describedby="quick_cart_container"] #cartDropdown') ||
                $(this).is('[aria-describedby="MiniShopCartProductAdded"] #cartDropdown')) {
                    e.preventDefault();
            }

            if(typeof attr !== typeof undefined && attr !== false) {
                window.location = $(this).attr('href');
            } else if (isCatalogEntryRecom && !(typeof attr !== typeof undefined && attr !== false)) {
                window.location = $(this).find('a').first().attr('href');
            } else if(isDropDownInput){
                $(this).click();
                $(prevElementClicked).focus();
            } else if(isAdd2Cart && isOliver) {
                $(this).click();
                productPageAdd2Cart();
                $('#MiniShopCartProductAdded #cartDropdown *:focusable').first().focus();
            } else {
                $(this).click();

            }                
            prevElementClicked = $(this);
            return false;
        }
    });
}

/**
 * This function set the focus in the first form error
 */
function moveToError() {
    $('.wcag__error:focusable').first().focus();
    // console.log("MCB :: enter in the function moveToError for WCAG.js");
}

/**
 * This function makes posible to close popups or hide them when the user press the ESC key
 */
function closeElementOnEscape(){
    $('*').keyup(function (e) {
        var key = e.which;
        if (key == 27) {
            $(".popup").removeClass("open");
            $(".popup").css("display","none");
            $(".panel.signInForm").addClass("hide");
        };
    }); 
}

/**
 * This function set the default carousel behaviour 
 * @param {carouselId} - this param is an element id but can be empty. If its not empty, the following behavior 
 *                       only affects to the element passed in this variable. If its empty, affects at all 
 *                       carousels that doesn't have carouselCMC class
 */

function defautBehaviourOwlCarousel(carouselId) {
    //previus element clicked
    var prevElementClicked = "";
    var carousel = '.owl-carousel:not(.carouselCMC) ';
    if(carouselId != null) {
        carousel = '#' + carouselId + ' ';
    }

    if(isVogue) {
        $('.nextPageButton, .prevPageButton').each(function () {
            $(this).attr("tabindex", "-1");
        });
    }

    /**
     * This function make all anchor tags inside owl-items no focusables except the first one 
     * to prevent a malfunction with the position of owl-carousel.
     */
    $(carousel + '.owl-item').each(function() {
        $(this).find('a').each(function(i) {
            var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
            var isOPHomePageZone3Slider = isOliver && $(this).parents("#x-hp-zone3-slider").length > 0;
            var isOPCustomLenses = isOliver && $(this).find('.owl-custom-lenses__product').length > 0;

            if (i !== 0 && (isCatalogEntryRecom == true && isOPCustomLenses == false) && isOPHomePageZone3Slider == false) {
                $(this).attr("tabindex", "-1");
            }
            
            //this is a fix for Edge
            if (i !== 0) {
                $(this).css('display', 'block');
            }
        });
    });

    /**
     * This function make all anchor tags inside products in PLP no focusables except the first one.
     */
    if($('.plp').length > 0) {
        $('.product').each(function() {
            $(this).find('a').each(function(i) {
                if (i !== 0) {
                    $(this).attr("tabindex", "-1");
                }
            });
        });
    }

    /**
     * This function make all anchor tags focusables inside owl-items except inside in 
     * the catalog entry recommendation. OPCustomLenses is excluded.
     */
    $(carousel + '.owl-item a').focus(function () {
        var owlItem = $(this).parents('.owl-item');
        var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
        var links = $(owlItem).find('a');
        var isOPCustomLenses = $(this).closest('.owl-custom-lenses__product').length > 0;    

        if (links[0] == $(this)[0] && links.length > 1 && isCatalogEntryRecom == false || (isCatalogEntryRecom == true && isOPCustomLenses == true)) {
            for (var x = 1; x < links.length; x++) {
                $(links[x]).attr("tabindex", "0")
            }
        }
    }).blur(function () {
        var owlItem = $(this).parents('.owl-item');
        var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
        var isOPHomePageZone3Slider = $(this).parents("#x-hp-zone3-slider").length > 0;
        var links = $(owlItem).find('a');
        var owlItemLostFocus = true;

        if (links.length > 1 && isCatalogEntryRecom == false && isOPHomePageZone3Slider == false) {
            for (var i = 0; i < links.length; i++) {
                if ($(links[i]).is(':focus')) {
                    owlItemLostFocus = false;
                    break;
                }
            }
            if (owlItemLostFocus == true) {
                for (var x = 1; x < links.length; x++) {
                    $(links[x]).attr("tabindex", "-1")
                }
            }
        }
    });

    /**
     * This function set tabindex attribute to owl-items to make them focusable 
     * only if they haven't got a focusable link inside
     */
    $(carousel + ".owl-item").each(function () {
        var haveLink = $(this).find("a").length > 0;
        var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
        // var isOPCustomLenses = $(this).find('.owl-custom-lenses__product').length > 0;

        if (haveLink === false && isCatalogEntryRecom == false) {
        // if (haveLink === false) {

            $(this).attr("tabindex", "0");
        }            
    });

    /**
     * This function catch the key pressed when the focus is inside the owl-carousel
     * and it makes navigable with cursor arrows
     */
    $(carousel).keyup(function (e) {
        e.preventDefault();
        var key = e.which;
        var isLink = $('a:focus').length > 0;
        var links = "";

        if (key == 37) {
            if (isLink) {
                links = $(':focus').parents('.owl-item').prev('.owl-item').find('a');
                $(links[0]).focus().addClass('focus');

            } else {
                $(':focus').prev('.owl-item').focus().addClass('focus');
            }
        } else if (key == 39) {
            if (isLink) {
                links = $(':focus').parents('.owl-item').next('.owl-item').find('a');
                $(links[0]).focus().addClass('focus');

            } else {
                $(':focus').next('.owl-item').focus().addClass('focus');
            }
        }
    });

    setFocusOnTab();

    /**
     * This function move the active owl-item to the owl-item focused only if the visible owl items are par
     */
    $(carousel + ".owl-item").focus(function () {
        var carousel = $(this).parents('.owl-carousel');
        var owl = carousel.data('owlCarousel');
        var visibleOwlItems = owl.visibleItems.length;

        if (visibleOwlItems % 2 == false) {
            owl.goTo($(this).index());
        }
    });
    
}
/* ------- END Common/WCAG/WCAG.js ------- */
/*
Copyright © 2013 Adobe Systems Incorporated.
Licensed under the Apache License, Version 2.0 (the “License”);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an “AS IS” BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * See <a href="http://jquery.com">http://jquery.com</a>.
 * @name jquery
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 */

/**
 * See <a href="http://jquery.com">http://jquery.com</a>
 * @name fn
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @memberOf jquery
 */

/**
 * @fileOverview accessibleMegaMenu plugin
 *
 *<p>Licensed under the Apache License, Version 2.0 (the “License”)
 *<br />Copyright © 2013 Adobe Systems Incorporated.
 *<br />Project page <a href="https://github.com/adobe-accessibility/Accessible-Mega-Menu">https://github.com/adobe-accessibility/Accessible-Mega-Menu</a>
 * @version 0.1
 * @author Michael Jordan
 * @requires jquery
 */

/*jslint browser: true, devel: true, plusplus: true, nomen: true */
/*global jQuery, window, document */
(function ($, window, document) {
    "use strict";
    var pluginName = "accessibleMegaMenu",
        defaults = {
            uuidPrefix: "accessible-megamenu", // unique ID's are required to indicate aria-owns, aria-controls and aria-labelledby
            menuClass: "accessible-megamenu", // default css class used to define the megamenu styling
            topNavItemClass: "accessible-megamenu-top-nav-item", // default css class for a top-level navigation item in the megamenu
            panelClass: "accessible-megamenu-panel", // default css class for a megamenu panel
            panelGroupClass: "accessible-megamenu-panel-group", // default css class for a group of items within a megamenu panel
            hoverClass: "hover", // default css class for the hover state
            focusClass: "focus", // default css class for the focus state
            openClass: "open", // default css class for the open state,
            toggleButtonClass: "accessible-megamenu-toggle", // default css class responsive toggle button
            openDelay: 0, // default open delay when opening menu via mouseover
            closeDelay: 250, // default open delay when opening menu via mouseover
            openOnMouseover: false // default setting for whether menu should open on mouseover
        },
        Keyboard = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
            keyMap: {
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
                190: "."
            }
        },
        clearTimeout = window.clearTimeout,
        setTimeout = window.setTimeout,
        isOpera = window.opera && window.opera.toString() === '[object Opera]';
    /**
     * @desc Creates a new accessible mega menu instance.
     * @param {jquery} element
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @constructor
     */
    function AccessibleMegaMenu(element, options) {
        this.element = element;

        // merge optional settings and defaults into settings
        this.settings = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.mouseTimeoutID = null;
        this.focusTimeoutID = null;
        this.mouseFocused = false;
        this.justFocused = false;

        this.init();
    }

    AccessibleMegaMenu.prototype = (function () {

        /* private attributes and methods ------------------------ */
        var uuid = 0,
            keydownTimeoutDuration = 1000,
            keydownSearchString = "",
            isTouch = 'ontouchstart' in window || window.navigator.msMaxTouchPoints,
            _getPlugin,
            _addUniqueId,
            _togglePanel,
            _clickHandler,
            _touchmoveHandler,
            _clickOutsideHandler,
            _DOMAttrModifiedHandler,
            _focusInHandler,
            _focusOutHandler,
            _keyDownHandler,
            _mouseDownHandler,
            _mouseOverHandler,
            _mouseOutHandler,
            _clickToggleHandler,
            _toggleExpandedEventHandlers,
            _addEventHandlers,
            _removeEventHandlers;

        /**
         * @name jQuery.fn.accessibleMegaMenu~_getPlugin
         * @desc Returns the parent accessibleMegaMenu instance for a given element
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _getPlugin = function (element) {
            return $(element).closest(':data(plugin_' + pluginName + ')').data("plugin_" + pluginName);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_addUniqueId
         * @desc Adds a unique id and element.
         * The id string starts with the
         * string defined in settings.uuidPrefix.
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _addUniqueId = function (element) {
            element = $(element);
            var settings = this.settings;
            if (!element.attr("id")) {
                element.attr("id", settings.uuidPrefix + "-" + new Date().getTime() + "-" + (++uuid));
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_togglePanel
         * @desc Toggle the display of mega menu panels in response to an event.
         * The optional boolean value 'hide' forces all panels to hide.
         * @param {event} event
         * @param {Boolean} [hide] Hide all mega menu panels when true
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _togglePanel = function (event, hide) {
            var target = $(event.target),
                that = this,
                settings = this.settings,
                menu = this.menu,
                topli = target.closest('.' + settings.topNavItemClass),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                newfocus;

            _toggleExpandedEventHandlers.call(this, true);

            if (hide) {
                topli = menu.find('.' + settings.topNavItemClass + ' .' + settings.openClass + ':first').closest('.' + settings.topNavItemClass);
                if (!(topli.is(event.relatedTarget) || topli.has(event.relatedTarget).length > 0)) {
                    if ((event.type === 'mouseout' || event.type === 'focusout') && topli.has(document.activeElement).length > 0) {
                        return;
                    }
                    topli.find('[aria-expanded]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                    if ((event.type === 'keydown' && event.keyCode === Keyboard.ESCAPE) || event.type === 'DOMAttrModified') {
                        newfocus = topli.find(':tabbable:first');
                        setTimeout(function () {
                            menu.find('[aria-expanded].' + that.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
                            newfocus.focus();
                            that.justFocused = false;
                        }, 99);
                    }
                } else if (topli.length === 0) {
                    menu.find('[aria-expanded=true]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                }
            } else {
                clearTimeout(that.focusTimeoutID);
                topli.siblings()
                    .find('[aria-expanded]')
                    .attr('aria-expanded', 'false')
                    .removeClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'true');
                topli.find('[aria-expanded]')
                    .attr('aria-expanded', 'true')
                    .addClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'false');

                var pageScrollPosition = $('html')[0].scrollTop;
                var openPanelTopPosition = $('.' + settings.panelClass + '.' + settings.openClass).parent().offset().top;

                if(pageScrollPosition > openPanelTopPosition) {
                    $('html')[0].scrollTop = openPanelTopPosition;
                }

                if (event.type === 'mouseover' && target.is(':tabbable') && topli.length === 1 && panel.length === 0 && menu.has(document.activeElement).length > 0) {
                    target.focus();
                    that.justFocused = false;
                }

                _toggleExpandedEventHandlers.call(that);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickHandler
         * @desc Handle click event on mega menu item
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickHandler = function (event) {
            var target = $(event.target).closest(':tabbable'),
                topli = target.closest('.' + this.settings.topNavItemClass),
                panel = target.closest('.' + this.settings.panelClass);
            if (topli.length === 1
                    && panel.length === 0
                    && topli.find('.' + this.settings.panelClass).length === 1) {
                if (!target.hasClass(this.settings.openClass)) {
                    event.preventDefault();
                    event.stopPropagation();
                    _togglePanel.call(this, event);
                    this.justFocused = false;
                } else {
                    if (this.justFocused) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.justFocused = false;
                    } else if (isTouch || !isTouch && !this.settings.openOnMouseover) {
                        event.preventDefault();
                        event.stopPropagation();
                        _togglePanel.call(this, event, target.hasClass(this.settings.openClass));
                    }
                }
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_touchmoveHandler
         * @desc Handle touch move event on menu
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _touchmoveHandler = function () {
            this.justMoved = true;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickOutsideHandler
         * @desc Handle click event outside of a the megamenu
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickOutsideHandler = function (event) {
            if ($(event.target).closest(this.menu).length === 0) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_DOMAttrModifiedHandler
         * @desc Handle DOMAttrModified event on panel to respond to Windows 8 Narrator ExpandCollapse pattern
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _DOMAttrModifiedHandler = function (event) {
            if (event.originalEvent.attrName === 'aria-expanded'
                    && event.originalEvent.newValue === 'false'
                    && $(event.target).hasClass(this.settings.openClass)) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusInHandler
         * @desc Handle focusin event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusInHandler = function (event) {
            clearTimeout(this.focusTimeoutID);
            var target = $(event.target),
                panel = target.closest('.' + this.settings.panelClass);
            target
                .addClass(this.settings.focusClass);
            this.justFocused = !this.mouseFocused || (!this.settings.openOnMouseover && this.mouseFocused);
            this.mouseFocused = false;
            if (this.justFocused && this.panels.not(panel).filter('.' + this.settings.openClass).length) {
                _togglePanel.call(this, event);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusOutHandler
         * @desc Handle focusout event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusOutHandler = function (event) {
            this.justFocused = false;
            var that = this,
                target = $(event.target),
                topli = target.closest('.' + this.settings.topNavItemClass);
            target
                .removeClass(this.settings.focusClass);

            if (window.cvox) {
                // If ChromeVox is running...
                that.focusTimeoutID = setTimeout(function () {
                    window.cvox.Api.getCurrentNode(function (node) {
                        if (topli.has(node).length) {
                            // and the current node being voiced is in
                            // the mega menu, clearTimeout,
                            // so the panel stays open.
                            clearTimeout(that.focusTimeoutID);
                        } else {
                            that.focusTimeoutID = setTimeout(function (scope, event, hide) {
                                _togglePanel.call(scope, event, hide);
                            }, 275, that, event, true);
                        }
                    });
                }, 25);
            } else {
                that.focusTimeoutID = setTimeout(function () {
                    if (that.mouseFocused && event.relatedTarget === null) {
                        return;
                    }
                    _togglePanel.call(that, event, true);
                }, 300);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_keyDownHandler
         * @desc Handle keydown event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _keyDownHandler = function (event) {
            var that = (this.constructor === AccessibleMegaMenu) ? this : _getPlugin(this), // determine the AccessibleMegaMenu plugin instance
                settings = that.settings,
                target = $($(this).is('.' + settings.hoverClass + ':tabbable') ? this : event.target), // if the element is hovered the target is this, otherwise, its the focused element
                menu = that.menu,
                topnavitems = that.topnavitems,
                topli = target.closest('.' + settings.topNavItemClass),
                tabbables = menu.find(':tabbable'),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                panelGroups = panel.find('.' + settings.panelGroupClass),
                currentPanelGroup = target.closest('.' + settings.panelGroupClass),
                next,
                keycode = event.keyCode || event.which,
                start,
                i,
                o,
                label,
                found = false,
                newString = Keyboard.keyMap[event.keyCode] || '',
                regex,
                isTopNavItem = (topli.length === 1 && panel.length === 0);

            if (target.is("input:focus, select:focus, textarea:focus, button:focus")) {
                // if the event target is a form element we should handle keydown normally
                return;
            }

            if (target.is('.' + settings.hoverClass + ':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }

            switch (keycode) {
            case Keyboard.ESCAPE:
                this.mouseFocused = false;
                _togglePanel.call(that, event, true);
                break;
            case Keyboard.DOWN:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    _togglePanel.call(that, event);
                    found = (topli.find('.' + settings.panelClass + ' :tabbable:first').focus().length === 1);
                } else {
                    found = (tabbables.filter(':gt(' + tabbables.index(target) + '):first').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.UP:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = (next.find('[aria-expanded]')
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus() === 1);
                    }
                } else if (!isTopNavItem) {
                    found = (tabbables.filter(':lt(' + tabbables.index(target) + '):last').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.RIGHT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':gt(' + topnavitems.index(topli) + '):first').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the next panel group
                        found = (panelGroups.filter(':gt(' + panelGroups.index(currentPanelGroup) + '):first').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.LEFT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the previous panel group
                        found = (panelGroups.filter(':lt(' + panelGroups.index(currentPanelGroup) + '):last').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.TAB:
                this.mouseFocused = false;
                i = tabbables.index(target);
                if (event.shiftKey && isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = next.children()
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus();
                    }
                } else if (event.shiftKey && i > 0) {
                    found = (tabbables.filter(':lt(' + i + '):last').focus().length === 1);
                } else if (!event.shiftKey && i < tabbables.length - 1) {
                    found = (tabbables.filter(':gt(' + i + '):first').focus().length === 1);
                } else if (isOpera) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    if (event.shiftKey) {
                        found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):last').focus().length === 1);
                    } else {
                        found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                    }
                }

                if (found) {
                    event.preventDefault();
                }
                break;
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                if (isTopNavItem) {
                    event.preventDefault();
                    _clickHandler.call(that, event);
                } else {
                    return true;
                }
                break;
            default:
                // alphanumeric filter
                clearTimeout(this.keydownTimeoutID);

                keydownSearchString += newString !== keydownSearchString ? newString : '';

                if (keydownSearchString.length === 0) {
                    return;
                }

                this.keydownTimeoutID = setTimeout(function () {
                    keydownSearchString = '';
                }, keydownTimeoutDuration);

                if (isTopNavItem && !target.hasClass(settings.openClass)) {
                    tabbables = tabbables.filter(':not(.' + settings.panelClass + ' :tabbable)');
                } else {
                    tabbables = topli.find(':tabbable');
                }

                if (event.shiftKey) {
                    tabbables = $(tabbables.get()
                        .reverse());
                }

                for (i = 0; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    if (o.is(target)) {
                        start = (keydownSearchString.length === 1) ? i + 1 : i;
                        break;
                    }
                }

                regex = new RegExp('^' + keydownSearchString.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), 'i');

                for (i = start; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    label = $.trim(o.text());
                    if (regex.test(label)) {
                        found = true;
                        o.focus();
                        break;
                    }
                }
                if (!found) {
                    for (i = 0; i < start; i++) {
                        o = tabbables.eq(i);
                        label = $.trim(o.text());
                        if (regex.test(label)) {
                            o.focus();
                            break;
                        }
                    }
                }
                break;
            }
            that.justFocused = false;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseDownHandler
         * @desc Handle mousedown event on mega menu.
         * @param {event} Event object
         * @memberof accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseDownHandler = function (event) {
            if ($(event.target).closest(this.settings.panelClass) || $(event.target).closest(":focusable").length) {
                this.mouseFocused = true;
                if ($(event.target).closest(this.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }
            clearTimeout(this.mouseTimeoutID);
            this.mouseTimeoutID = setTimeout(function () {
                clearTimeout(this.focusTimeoutID);
            }, 1);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOverHandler
         * @desc Handle mouseover event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOverHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            this.mouseTimeoutID = setTimeout(function () {
                $(event.target).addClass(that.settings.hoverClass);
                _togglePanel.call(that, event);
                if ($(event.target).closest(that.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }, this.settings.openDelay);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOutHandler
         * @desc Handle mouseout event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOutHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            $(event.target)
                .removeClass(that.settings.hoverClass);

            that.mouseTimeoutID = setTimeout(function () {
                _togglePanel.call(that, event, true);
            }, this.settings.closeDelay);
            if ($(event.target).is(':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickToggleHandler
         * @desc Handle click event on menu toggle button.
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickToggleHandler = function () {
            var isExpanded = this.toggleButton.attr('aria-expanded') === 'true';
            this.toggleButton.attr({'aria-expanded': !isExpanded, 'aria-pressed': !isExpanded});
        };

        _toggleExpandedEventHandlers = function (hide) {
            var menu = this.menu;
            if (hide) {
                $('html').off('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu');

                menu.find('[aria-expanded].' + this.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
            } else {
                $('html').on('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu', $.proxy(_clickOutsideHandler, this));

                /* Narrator in Windows 8 automatically toggles the aria-expanded property on double tap or click.
                   To respond to the change to collapse the panel, we must add a listener for a DOMAttrModified event. */
                menu.find('[aria-expanded=true].' + this.settings.panelClass).on('DOMAttrModified.accessible-megamenu', $.proxy(_DOMAttrModifiedHandler, this));
            }
        };

        _addEventHandlers = function() {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.on("focusin.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusInHandler, this))
                .on("focusout.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusOutHandler, this))
                .on("keydown.accessible-megamenu", $.proxy(_keyDownHandler, this))
                .on("mouseover.accessible-megamenu", $.proxy(_mouseOverHandler, this))
                .on("mouseout.accessible-megamenu", $.proxy(_mouseOutHandler, this))
                .on("mousedown.accessible-megamenu", $.proxy(_mouseDownHandler, this))
                .on("click.accessible-megamenu", $.proxy(_clickHandler, this));

            toggleButton.on('click.accessible-megamenu', $.proxy(_clickToggleHandler, this));

            if (isTouch) {
                menu.on("touchmove.accessible-megamenu", $.proxy(_touchmoveHandler, this));
            }

            if ($(document.activeElement).closest(menu).length) {
              $(document.activeElement).trigger("focusin.accessible-megamenu");
            }
        };

        _removeEventHandlers = function () {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.off('.accessible-megamenu');
            if (menu.find('[aria-expanded=true].' + this.settings.panelClass).length) {
                _toggleExpandedEventHandlers.call(this, true);
            }

            toggleButton.off('.accessible-megamenu');
        };

        /* public attributes and methods ------------------------- */
        return {
            constructor: AccessibleMegaMenu,

            /**
             * @lends jQuery.fn.accessibleMegaMenu
             * @desc Initializes an instance of the accessibleMegaMenu plugins
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            init: function () {
                var settings = this.settings,
                    nav = $(this.element),
                    menu = nav.children('ol,ul').first(),
                    topnavitems = menu.children(),
                    toggleButton = nav.children('button').first();
                this.start(settings, nav, menu, topnavitems, toggleButton);
            },

            start: function(settings, nav, menu, topnavitems, toggleButton) {
                var that = this;
                this.settings = settings;
                this.menu = menu;
                this.topnavitems = topnavitems;
                this.toggleButton = toggleButton;

                nav.attr("role", "navigation");
                _addUniqueId.call(that, menu);
                menu.addClass(settings.menuClass);
                menu.addClass(['js', settings.menuClass].join('-'));
                topnavitems.each(function (i, topnavitem) {
                    var topnavitemlink, topnavitempanel;
                    topnavitem = $(topnavitem);
                    topnavitem.addClass(settings.topNavItemClass);
                    topnavitemlink = topnavitem.find(":tabbable:first");
                    topnavitempanel = topnavitem.children(":not(:tabbable):last");
                    _addUniqueId.call(that, topnavitemlink);
                    if (topnavitempanel.length) {
                        _addUniqueId.call(that, topnavitempanel);
                        topnavitemlink.attr({
                            "role": "button",
                            "aria-controls": topnavitempanel.attr("id"),
                            "aria-expanded": false,
                            "tabindex": 0
                        });

                        topnavitempanel.attr({
                            "role": "region",
                            "aria-expanded": false,
                            "aria-hidden": true
                        })
                            .addClass(settings.panelClass)
                            .not("[aria-labelledby]")
                            .attr("aria-labelledby", topnavitemlink.attr("id"));
                    }
                });

                this.panels = menu.find("." + settings.panelClass);

                menu.find("hr").attr("role", "separator");

                toggleButton.addClass(settings.toggleButtonClass);
                toggleButton.attr({'aria-expanded': false, 'aria-pressed': false, 'aria-controls': menu.attr('id')});

                _addEventHandlers.call(this);
            },

            /**
             * @desc Removes maga menu javascript behavior
             * @example $(selector).accessibleMegaMenu("destroy");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            destroy: function () {
                this.menu.removeClass(['js', this.settings.menuClass].join('-'));
                _removeEventHandlers.call(this, true);
            },

            /**
             * @desc Get default values
             * @example $(selector).accessibleMegaMenu("getDefaults");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getDefaults: function () {
                return this._defaults;
            },

            /**
             * @desc Get any option set to plugin using its name (as string)
             * @example $(selector).accessibleMegaMenu("getOption", some_option);
             * @param {string} opt
             * @return {string}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getOption: function (opt) {
                return this.settings[opt];
            },

            /**
             * @desc Get all options
             * @example $(selector).accessibleMegaMenu("getAllOptions");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getAllOptions: function () {
                return this.settings;
            },

            /**
             * @desc Set option
             * @example $(selector).accessibleMegaMenu("setOption", "option_name",  "option_value",  reinitialize);
             * @param {string} opt - Option name
             * @param {string} val - Option value
             * @param {boolean} [reinitialize] - boolean to re-initialize the menu.
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            setOption: function (opt, value, reinitialize) {
                this.settings[opt] = value;
                if (reinitialize) {
                    this.init();
                }
            }
        };
    }());

    /* lightweight plugin wrapper around the constructor,
       to prevent against multiple instantiations */

    /**
     * @class accessibleMegaMenu
     * @memberOf jQuery.fn
     * @classdesc Implements an accessible mega menu as a jQuery plugin.
     * <p>The mega-menu It is modeled after the mega menu on {@link http://adobe.com|adobe.com} but has been simplified for use by others. A brief description of the interaction design choices can be found in a blog post at {@link http://blogs.adobe.com/accessibility/2013/05/adobe-com.html|Mega menu accessibility on adobe.com}.</p>
     * <h3>Keyboard Accessibility</h3>
     * <p>The accessible mega menu supports keyboard interaction modeled after the behavior described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern}, however we also try to respect users' general expectations for the behavior of links in a global navigation. To this end, the accessible mega menu implementation permits tab focus on each of the six top-level menu items. When one of the menu items has focus, pressing the Enter key, Spacebar or Down arrow will open the submenu panel, and pressing the Left or Right arrow key will shift focus to the adjacent menu item. Links within the submenu panels are included in the tab order when the panel is open. They can also be navigated with the arrow keys or by typing the first character in the link name, which speeds up keyboard navigation considerably. Pressing the Escape key closes the submenu and restores focus to the parent menu item.</p>
     * <h3>Screen Reader Accessibility</h3>
     * <p>The accessible mega menu models its use of WAI-ARIA Roles, States, and Properties after those described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern} with some notable exceptions, so that it behaves better with screen reader user expectations for global navigation. We don't use <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menu"</span></code> for the menu container and <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menuitem"</span></code> for each of the links therein, because if we do, assistive technology will no longer interpret the links as links, but instead, as menu items, and the links in our global navigation will no longer show up when a screen reader user executes a shortcut command to bring up a list of links in the page.</p>
     * @example <h4>HTML</h4><hr/>
&lt;nav&gt;
    &lt;ul class=&quot;nav-menu&quot;&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?movie&quot;&gt;Movies&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=0&quot;&gt;Action &amp;amp; Adventure&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=2&quot;&gt;Children &amp;amp; Family&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=7&quot;&gt;Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=9&quot;&gt;Foreign&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=14&quot;&gt;Musicals&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=15&quot;&gt;Romance&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?tv&quot;&gt;TV Shows&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=20&quot;&gt;Classic TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=21&quot;&gt;Crime TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=27&quot;&gt;Reality TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=30&quot;&gt;TV Action&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=33&quot;&gt;TV Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=34&quot;&gt;TV Horror&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
    &lt;/ul&gt;
&lt;/nav&gt;
     * @example <h4>CSS</h4><hr/>
&#47;* Rudimentary mega menu CSS for demonstration *&#47;
&#47;* mega menu list *&#47;
.nav-menu {
    display: block;
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 15;
}
&#47;* a top level navigation item in the mega menu *&#47;
.nav-item {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
}
&#47;* first descendant link within a top level navigation item *&#47;
.nav-item &gt; a {
    position: relative;
    display: inline-block;
    padding: 0.5em 1em;
    margin: 0 0 -1px 0;
    border: 1px solid transparent;
}
&#47;* focus/open states of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a:focus,
.nav-item &gt; a.open {
    border: 1px solid #dedede;
}
&#47;* open state of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a.open {
    background-color: #fff;
    border-bottom: none;
    z-index: 1;
}
&#47;* sub-navigation panel *&#47;
.sub-nav {
    position: absolute;
    display: none;
    top: 2.2em;
    margin-top: -1px;
    padding: 0.5em 1em;
    border: 1px solid #dedede;
    background-color: #fff;
}
&#47;* sub-navigation panel open state *&#47;
.sub-nav.open {
    display: block;
}
&#47;* list of items within sub-navigation panel *&#47;
.sub-nav ul {
    display: inline-block;
    vertical-align: top;
    margin: 0 1em 0 0;
    padding: 0;
}
&#47;* list item within sub-navigation panel *&#47;
.sub-nav li {
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
     * @example <h4>JavaScript</h4><hr/>
&lt;!-- include jquery --&gt;
&lt;script src=&quot;http://code.jquery.com/jquery-1.10.1.min.js&quot;&gt;&lt;/script&gt;
&lt;!-- include the jquery-accessibleMegaMenu plugin script --&gt;
&lt;script src=&quot;js/jquery-accessibleMegaMenu.js&quot;&gt;&lt;/script&gt;
&lt;!-- initialize a selector as an accessibleMegaMenu --&gt;
&lt;script&gt;
    $(&quot;nav:first&quot;).accessibleMegaMenu({
        &#47;* prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby *&#47;
        uuidPrefix: &quot;accessible-megamenu&quot;,
        &#47;* css class used to define the megamenu styling *&#47;
        menuClass: &quot;nav-menu&quot;,
        &#47;* css class for a top-level navigation item in the megamenu *&#47;
        topNavItemClass: &quot;nav-item&quot;,
        &#47;* css class for a megamenu panel *&#47;
        panelClass: &quot;sub-nav&quot;,
        &#47;* css class for a group of items within a megamenu panel *&#47;
        panelGroupClass: &quot;sub-nav-group&quot;,
        &#47;* css class for the hover state *&#47;
        hoverClass: &quot;hover&quot;,
        &#47;* css class for the focus state *&#47;
        focusClass: &quot;focus&quot;,
        &#47;* css class for the open state *&#47;
        openClass: &quot;open&quot;
    });
&lt;/script&gt;
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @param {string} [options.openDelay=0] - Open delay when opening menu via mouseover
     * @param {string} [options.closeDelay=250] - Open delay when opening menu via mouseover
     * @param {boolean} [options.openOnMouseover=false] - Should menu open on mouseover
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            var pluginInstance = $.data(this, "plugin_" + pluginName);
            if (!pluginInstance) {
                $.data(this, "plugin_" + pluginName, new $.fn[pluginName].AccessibleMegaMenu(this, options));
            } else if (typeof pluginInstance[options] === 'function') {
                pluginInstance[options].apply(pluginInstance, Array.prototype.slice.call(arguments, 1));
            }
        });
    };

    $.fn[pluginName].AccessibleMegaMenu = AccessibleMegaMenu;

    /* :focusable and :tabbable selectors from
       https://raw.github.com/jquery/jquery-ui/master/ui/jquery.ui.core.js */

    /**
     * @private
     */
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
            return $.css(this, "visibility") === "hidden";
        }).length;
    }

    /**
     * @private
     */
    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img,
            nodeName = element.nodeName.toLowerCase();
        if ("area" === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
                return false;
            }
            img = $("img[usemap=#" + mapName + "]")[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled :
                "a" === nodeName ?
                        element.href || isTabIndexNotNaN :
                        isTabIndexNotNaN) &&
                            // the element and all of its ancestors must be visible
                            visible(element);
    }

    $.extend($.expr[":"], {
        data: $.expr.createPseudo ? $.expr.createPseudo(function (dataName) {
            return function (elem) {
                return !!$.data(elem, dataName);
            };
        }) : // support: jQuery <1.8
                function (elem, i, match) {
                    return !!$.data(elem, match[3]);
                },

        focusable: function (element) {
            return focusable(element, !isNaN($.attr(element, "tabindex")));
        },

        tabbable: function (element) {
            var tabIndex = $.attr(element, "tabindex"),
                isTabIndexNaN = isNaN(tabIndex);
            return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
        }
    });
}(jQuery, window, document));
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.5
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var l=new Error("Cannot find module '"+s+"'");throw l.code="MODULE_NOT_FOUND",l}var u=e[s]={exports:{}};t[s][0].call(u.exports,function(e){var n=t[s][1][e];return i(n?n:e)},u,u.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new h(16),this._normalQueue=new h(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var l;try{throw new Error}catch(u){l=u}var p=t("./schedule"),h=t("./queue"),f=t("./util");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},r.prototype.disableTrampolineIfNecessary=function(){f.hasDevTools&&(this._trampolineEnabled=!1)},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},f.hasDevTools?(r.prototype.invokeLater=function(t,e,n){this._trampolineEnabled?i.call(this,t,e,n):this._schedule(function(){setTimeout(function(){t.call(e,n)},100)})},r.prototype.invoke=function(t,e,n){this._trampolineEnabled?o.call(this,t,e,n):this._schedule(function(){t.call(e,n)})},r.prototype.settlePromises=function(t){this._trampolineEnabled?s.call(this,t):this._schedule(function(){t._settlePromises()})}):(r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s),r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=l},{"./queue":26,"./schedule":29,"./util":36}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var l=n(o),u=new t(e);u._propagateFrom(this,1);var p=this._target();if(u._setBoundTo(l),l instanceof t){var h={promiseRejectionQueued:!1,promise:u,target:p,bindingPromise:l};p._then(e,s,void 0,u,h),l._then(a,c,void 0,u,h),u._setOnCancel(l)}else u._resolveCallback(p);return u},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var l=a._boundValue();t:for(var u=0;u<t.length;++u){var p=t[u];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(l,c)}else if("function"==typeof p){var h=o(p).call(l,c);if(h===s)return h;if(h)return o(n).call(l,c)}else if(r.isObject(c)){for(var f=i(p),_=0;_<f.length;++_){var d=f[_];if(p[d]!=c[d])continue t}return o(n).call(l,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,e){return{promise:e}}function i(){return!1}function o(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+H.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function s(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?H.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function a(){return this._onCancelField}function c(t){this._onCancelField=t}function l(){this._cancellationParent=void 0,this._onCancelField=void 0}function u(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function p(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function f(){this._trace=new O(this._peekContext())}function _(t,e){if(U(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=E(t);H.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),H.notEnumerableProp(t,"__stackCleaned__",!0)}}}function d(){this._trace=void 0}function v(t,e,n,r,i){if(void 0===t&&null!==e&&J){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=C(a),l=c.length-1;l>=0;--l){var u=c[l];if(!q.test(u)){var p=u.match($);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var h=c[0],l=0;l<a.length;++l)if(a[l]===h){l>0&&(s="\n"+a[l-1]);break}}var f="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(f,!0,e)}}function y(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),m(n)}function m(t,n,r){if(at.warnings){var i,o=new N(t);if(n)r._attachExtraTrace(o);else if(at.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=E(o);o.stack=s.message+"\n"+s.stack.join("\n")}nt("warning",o)||k(o,"",!0)}}function g(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function b(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function w(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function C(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||Q.test(r),o=i&&it(r);i&&!o&&(z&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function j(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||Q.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function E(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?j(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:C(e)}}function k(t,e,n){if("undefined"!=typeof console){var r;if(H.isObject(t)){var i=t.stack;r=e+G(i,t)}else r=e+String(t);"function"==typeof V?V(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function F(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){L.throwLater(o)}"unhandledRejection"===t?nt(t,n,r)||i||k(n,"Unhandled rejection "):nt(t,r)}function T(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():H.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+x(e)+">, no stack trace)"}function x(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function P(){return"function"==typeof st}function S(t){var e=t.match(ot);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function R(t,e){if(P()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var l=S(i[c]);if(l){n=l.fileName,s=l.line;break}}for(var c=0;c<o.length;++c){var l=S(o[c]);if(l){r=l.fileName,a=l.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(it=function(t){if(M.test(t))return!0;var e=S(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function O(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);st(this,O),e>32&&this.uncycle()}var A,D,V,I=e._getDomain,L=e._async,N=t("./errors").Warning,H=t("./util"),B=t("./es5"),U=H.canAttachTrace,M=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,q=/\((?:timers\.js):\d+:\d+\)/,$=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,Q=null,G=null,z=!1,X=!(0==H.env("BLUEBIRD_DEBUG")||!H.env("BLUEBIRD_DEBUG")&&"development"!==H.env("NODE_ENV")),W=!(0==H.env("BLUEBIRD_WARNINGS")||!X&&!H.env("BLUEBIRD_WARNINGS")),K=!(0==H.env("BLUEBIRD_LONG_STACK_TRACES")||!X&&!H.env("BLUEBIRD_LONG_STACK_TRACES")),J=0!=H.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(W||!!H.env("BLUEBIRD_W_FORGOTTEN_RETURN"));e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){if(0===(524288&this._bitField)){this._setRejectionIsUnhandled();var t=this;setTimeout(function(){t._notifyUnhandledRejection()},1)}},e.prototype._notifyUnhandledRejectionIsHandled=function(){F("rejectionHandled",A,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),F("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return m(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var e=I();D="function"==typeof t?null===e?t:H.domainBind(e,t):void 0},e.onUnhandledRejectionHandled=function(t){var e=I();A="function"==typeof t?null===e?t:H.domainBind(e,t):void 0};var Y=function(){};e.longStackTraces=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!at.longStackTraces&&P()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;at.longStackTraces=!0,Y=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),L.enableTrampoline(),at.longStackTraces=!1},e.prototype._captureStackTrace=f,e.prototype._attachExtraTrace=_,e.prototype._dereferenceTrace=d,n.activateLongStackTraces(),L.disableTrampolineIfNecessary()}},e.hasLongStackTraces=function(){return at.longStackTraces&&P()};var Z=function(){try{if("function"==typeof CustomEvent){var t=new CustomEvent("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n={detail:e,cancelable:!0};B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason});var r=new CustomEvent(t.toLowerCase(),n);return!H.global.dispatchEvent(r)}}if("function"==typeof Event){var t=new Event("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n=new Event(t.toLowerCase(),{cancelable:!0});return n.detail=e,B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason}),!H.global.dispatchEvent(n)}}var t=document.createEvent("CustomEvent");return t.initCustomEvent("testingtheevent",!1,!0,{}),H.global.dispatchEvent(t),function(t,e){var n=document.createEvent("CustomEvent");return n.initCustomEvent(t.toLowerCase(),!1,!0,e),!H.global.dispatchEvent(n)}}catch(e){}return function(){return!1}}(),tt=function(){return H.isNode?function(){return process.emit.apply(process,arguments)}:H.global?function(t){var e="on"+t.toLowerCase(),n=H.global[e];return n?(n.apply(H.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),et={promiseCreated:r,promiseFulfilled:r,promiseRejected:r,promiseResolved:r,promiseCancelled:r,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:r},nt=function(t){var e=!1;try{e=tt.apply(null,arguments)}catch(n){L.throwLater(n),e=!0}var r=!1;try{r=Z(t,et[t].apply(null,arguments))}catch(n){L.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&Y()),"warnings"in t){var n=t.warnings;at.warnings=!!n,J=at.warnings,H.isObject(n)&&"wForgottenReturn"in n&&(J=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!at.cancellation){if(L.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=l,e.prototype._propagateFrom=u,e.prototype._onCancel=a,e.prototype._setOnCancel=c,e.prototype._attachCancellationCallback=s,e.prototype._execute=o,rt=u,at.cancellation=!0}return"monitoring"in t&&(t.monitoring&&!at.monitoring?(at.monitoring=!0,e.prototype._fireEvent=nt):!t.monitoring&&at.monitoring&&(at.monitoring=!1,e.prototype._fireEvent=i)),e},e.prototype._fireEvent=i,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var rt=p,it=function(){return!1},ot=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;H.inherits(O,Error),n.CapturedTrace=O,O.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var l=c._length+1,u=r-2;u>=0;--u)e[u]._length=l,l++;return}}}},O.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=E(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(C(i.stack.split("\n"))),i=i._parent;w(r),b(r),H.notEnumerableProp(t,"stack",g(n,r)),H.notEnumerableProp(t,"__stackCleaned__",!0)}};var st=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():T(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,Q=t,G=e;var n=Error.captureStackTrace;return it=function(t){return M.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return Q=/@/,G=e,z=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(G=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?T(e):e.toString()},null):(Q=t,G=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(V=function(t){console.warn(t)},H.isNode&&process.stderr.isTTY?V=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:H.isNode||"string"!=typeof(new Error).stack||(V=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var at={warnings:W,longStackTraces:!1,cancellation:!1,monitoring:!1};return K&&e.longStackTraces(),{longStackTraces:function(){return at.longStackTraces},warnings:function(){return at.warnings},cancellation:function(){return at.cancellation},monitoring:function(){return at.monitoring},propagateFromFunction:function(){return rt},boundValueFunction:function(){return h},checkForgottenReturns:v,setBounds:R,warn:m,deprecated:y,CapturedTrace:O,fireDomEvent:Z,fireGlobalEvent:tt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return u(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,l=t("./util"),u=l.inherits,p=l.notEnumerableProp,h=r("Warning","warning"),f=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),m=0;m<y.length;++m)"function"==typeof Array.prototype[y[m]]&&(d.prototype[y[m]]=Array.prototype[y[m]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var g=0;d.prototype.toString=function(){var t=Array(4*g+1).join(" "),e="\n"+t+"AggregateError of:\n";g++,t=Array(4*g+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return g--,e},u(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:f,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:h}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},l=function(t,e,n){return t[e]=n.value,t},u=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},h=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:h,keys:a,names:a,defineProperty:l,getDescriptor:c,freeze:u,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return l.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(h.e=t,h)}function l(t){var i=this.promise,l=this.handler;if(!this.called){this.called=!0;var u=this.isFinallyHandler()?l.call(i._boundValue()):l.call(i._boundValue(),t);if(u===r)return u;if(void 0!==u){i._setReturnedNonUndefined();var f=n(u,i);if(f instanceof e){if(null!=this.cancelPromise){if(f._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),h.e=_,h}f.isPending()&&f._attachCancellationCallback(new o(this))}return f._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),h.e=t,h):(s(this),t)}var u=t("./util"),p=e.CancellationError,h=u.errorObj,f=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,l,l)},e.prototype.tap=function(t){return this._passThrough(t,1,l)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,l);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!u.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+u.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(f(i,a,this),1,void 0,l)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=f(n[o])(t);if(r._popContext(),s===h){r._pushContext();var a=e.reject(h.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var l=this._promise=new e(r);l._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var l=t("./errors"),u=l.TypeError,p=t("./util"),h=p.errorObj,f=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=f(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=f(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=f(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=f(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===h)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),
null===o))return void this._promiseRejected(new u("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new u("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new u("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){var a=t("./util");a.canEvaluate,a.tryCatch,a.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,e,n,r){this.constructor$(t),this._promise._captureStackTrace();var i=l();this._callback=null===i?e:u.domainBind(i,e),this._preservedValues=r===o?new Array(this.length()):null,this._limit=n,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0)}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var l=e._getDomain,u=t("./util"),p=u.tryCatch,h=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var l=this._promise,u=this._callback,f=l._boundValue();l._pushContext();var _=p(u).call(f,t,n,o),d=l._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",l),_===h)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var m=++this._totalResolved;return m>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var l=arguments[1],u=arguments[2];c=s.isArray(l)?a(t).apply(u,l):a(t).call(u,l)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&u.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new l(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=u.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),l=c.OperationalError,u=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new m("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new m("expecting a function but got "+f.classString(e))}function i(t){t!==b&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(b);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c,l=function(){return new m("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},p=function(t){return i.reject(new m(t))},h={},f=t("./util");c=f.isNode?function(){var t=process.domain;return void 0===t&&(t=null),t}:function(){return null},f.notEnumerableProp(i,"_getDomain",c);var _=t("./es5"),d=t("./async"),v=new d;_.defineProperty(i,"_async",{value:v});var y=t("./errors"),m=i.TypeError=y.TypeError;i.RangeError=y.RangeError;var g=i.CancellationError=y.CancellationError;i.TimeoutError=y.TimeoutError,i.OperationalError=y.OperationalError,i.RejectionError=y.OperationalError,i.AggregateError=y.AggregateError;var b=function(){},w={},C={},j=t("./thenables")(i,b),E=t("./promise_array")(i,b,j,p,n),k=t("./context")(i),F=k.create,T=t("./debuggability")(i,k),x=(T.CapturedTrace,t("./finally")(i,j,C)),P=t("./catch_filter")(C),S=t("./nodeback"),R=f.errorObj,O=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return p("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new m("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,P(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(T.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?p("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,w,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new E(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(b);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=O(t)(S(e,n));return r===R&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new E(t).promise()},i.cast=function(t){var e=j(t);return e instanceof i||(e=new i(b),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(b);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));return v.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(b),l=this._target(),u=l._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():l===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var p=c();if(0!==(50397184&u)){var h,_,d=l._settlePromiseCtx;0!==(33554432&u)?(_=l._rejectionHandler0,h=t):0!==(16777216&u)?(_=l._fulfillmentHandler0,h=e,l._unsetRejectionIsUnhandled()):(d=l._settlePromiseLateCancellationObserver,_=new g("late cancellation observer"),l._attachExtraTrace(_),h=e),v.invoke(d,l,{handler:null===p?h:"function"==typeof h&&f.domainBind(p,h),promise:a,receiver:r,value:_})}else l._addCallbacks(t,e,a,r,p);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){v.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===h?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=h),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=h),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=null===i?e:f.domainBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this[s+1]=null===i?e:f.domainBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(l(),!1);var n=j(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(l());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var c=new g("late cancellation observer");r._attachExtraTrace(c),this._reject(c)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&T.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==b){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===w?n&&"number"==typeof n.length?o=O(t).apply(this._boundValue(),n):(o=R,o.e=new m("cannot .spread() a non-array: "+f.classString(n))):o=O(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===C?r._reject(n):o===R?r._rejectCallback(o.e,!1):(T.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof x&&r.isFinallyHandler()?(r.cancelPromise=t,O(e).call(r,o)===R&&t._reject(R.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof E?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=l();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():v.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?v.fatalError(t,f.isNode):void((65535&e)>0?v.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&_.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){T.deprecated("Promise.defer","new Promise");var t=new i(b);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",l),t("./method")(i,b,j,p,T),t("./bind")(i,b,j,T),t("./cancel")(i,E,p,T),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,E,j,b,v,c),i.Promise=i,i.version="3.5.5",t("./call_get.js")(i),t("./generators.js")(i,p,b,j,n,T),t("./map.js")(i,E,p,j,b,T),t("./nodeify.js")(i),t("./promisify.js")(i,b),t("./props.js")(i,E,j,p),t("./race.js")(i,b,j,p),t("./reduce.js")(i,E,p,j,b,T),t("./settle.js")(i,E,T),t("./some.js")(i,E,p),t("./timers.js")(i,b,T),t("./using.js")(i,p,j,F,b,T),t("./any.js")(i),t("./each.js")(i,b),t("./filter.js")(i,b),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(b)),T.setBounds(d.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&r._propagateFrom(t,3),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function l(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(l,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var u=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(u,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=f.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new m("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=f.inheritedDataKeys(t),c=[],l=0;l<a.length;++l){var u=a[l],p=t[u],h=r===j?!0:j(u,p,t);"function"!=typeof p||i(p)||o(t,u,e)||!r(u,p,t,h)||c.push(u,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===h&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof u&&this!==l?this[u]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var l=function(){return this}(),u=t;return"string"==typeof u&&(t=o),f.notEnumerableProp(c,"__isPromisified__",!0),c}function l(t,e,n,r,i){for(var o=new RegExp(E(e)+"$"),s=a(t,e,o,n),c=0,l=s.length;l>c;c+=2){var u=s[c],p=s[c+1],_=u+e;if(r===k)t[_]=k(u,h,u,p,e,i);else{var d=r(p,function(){return k(u,h,u,p,e,i)});f.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return f.toFastProperties(t),t}function u(t,e,n){return k(t,e,void 0,t,null,n)}var p,h={},f=t("./util"),_=t("./nodeback"),d=f.withAppended,v=f.maybeWrapAsError,y=f.canEvaluate,m=t("./errors").TypeError,g="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return f.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},E=function(t){return t.replace(/([$])/,"\\$")},k=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?h:e.context,o=!!e.multiArgs,s=u(t,n,o);return f.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new m("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=g);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=k),!f.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=f.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&f.isClass(c)&&(l(c.prototype,r,i,o,n),l(c,r,i,o,n))}return l(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=u.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return l(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),l=c.isObject,u=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),h=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=h(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var l=new e(n);void 0!==o&&l._propagateFrom(o,3);for(var u=l._fulfill,p=l._reject,h=0,f=t.length;f>h;++h){var _=t[h];(void 0!==_||h in t)&&e.cast(_)._then(u,p,void 0,l,null)}return l}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=h();this._fn=null===s?n:f.domainBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function l(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function u(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=_(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var h=e._getDomain,f=t("./util"),_=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;if(void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n,!n.isRejected())for(;i>r;++r){var o={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(u,void 0,void 0,o,void 0)}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return l(this,t,e,null)},e.reduce=function(t,e,n,r){return l(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){var l=s.resolve();r=function(t){l.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36
}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,l=s.isArray,u={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=l(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(u),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==u&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(u(t)){if(t instanceof e)return t;var i=o(t);if(i===l){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return l.e=e,l}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),u=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,h=c.tryCatch(r).call(t,o,s);return p=!1,a&&h===l&&(a._rejectCallback(h.e,!0,!0),a=null),u}var c=t("./util"),l=c.errorObj,u=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var l=function(t){return u(+this).thenReturn(t)},u=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(l,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return u(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function l(t,n){function i(){if(s>=l)return u._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,l=t.length,u=new e(o);return i(),u}function u(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function h(t){return u.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function f(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,m=_.tryCatch,g={};u.prototype.data=function(){return this._data},u.prototype.promise=function(){return this._promise},u.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():g},u.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==g?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},u.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,u),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},f.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new f(t),p=0;t>p;++p){var d=o[p];if(u.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var g=r(d);g instanceof e&&(d=g._then(h,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=m(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return l(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return x.e=e,x}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function l(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function u(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function h(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function f(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return D.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function m(t){try{u(t,"isOperational",!0)}catch(e){}}function g(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return H?process.env[t]:void 0}function E(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"==={}.toString.call(t))return Promise}catch(e){}}function k(t,e){return t.bind(e)}var F=t("./es5"),T="undefined"==typeof navigator,x={e:{}},P,S="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,R=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var l=Object.getOwnPropertyDescriptor(t,c);null!=l&&null==l.get&&null==l.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,D=/^[a-z$_][a-z$_0-9]*$/i,V=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),I=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var L="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};I=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?L(t):null}}var N="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),H="undefined"!=typeof process&&"undefined"!=typeof process.env,B={isClass:h,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:l,thrower:p,isArray:F.isArray,asArray:I,notEnumerableProp:u,isPrimitive:o,isObject:s,isError:y,canEvaluate:T,errorObj:x,tryCatch:i,inherits:R,withAppended:c,maybeWrapAsError:a,toFastProperties:f,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:V,originatesFromRejection:g,markAsOriginatingFromRejection:m,classString:w,copyDescriptors:C,hasDevTools:"undefined"!=typeof chrome&&chrome&&"function"==typeof chrome.loadTimes,isNode:N,hasEnvVariables:H,env:j,global:S,getNativePromise:E,domainBind:k};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(U){B.lastLineError=U}e.exports=B},{"./es5":13}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
/********************************************************************
*-------------------------------------------------------------------
* Licensed Materials - Property of IBM
*
* WebSphere Commerce
*
* (c) Copyright IBM Corp. 2000
*
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*-------------------------------------------------------------------*/

/** XBUtil **********************************************************
*
* Cross Browser API
*
*********************************************************************/

// Global browser flags
// isIE (Internet Explorer 5.5+)
// isNS (Netscape 6+)
// isDHTML (DHTML cross-browser support)
var isIE = (document.all) ? true : false;
var isNS = (document.getElementById && !isIE) ? true : false;
var isDHTML = (isIE || isNS) ? true : false;

/**********************************************************
* XBElement Class
*
* Read-Only Attributes:
* element       : The original DOM element.
* id            : ID of the element.
* type          : "XBElement"
* tagName       : Tag name of this element.
* class         : Currrent class applies to it. 
* style         : The style object of the DOM element.
* left          : The left position obtained from style.
* top           : The top position obtained from style.
* pageX         : Horizontal coordinate relative to the page.
* pageY         : Vertical coordinate relative to the page.
* offsetLeft    : Position relative to the left of the parent element.
* offsetTop     : Position relative to the top of the parent element.
* offsetWidth   : Width relative to the parent element.
* offsetHeight  : Height relative to the parent element.
* offsetParent  : A reference to the object in which the current element is offset.
*
* Methods:
* getAttribute          : Retrieves an attribute of the DOM element.
* setAttribute          : Sets an attribute value to the DOM element.
* getParentElement      : Returns the parent element in XBElement type.
* getFirstChild         : Returns the first child element in XBElement type.
* getLastChild          : Returns the last child element in XBElement type.
* getPreviousSibling    : Returns the previous sibling element in XBElement type.
* getNextSibling        : Returns the next sibling element in XBElement type.
* getChildElements      : Returns an array of children elemtns in XBElement types.
* getStyleClass         : Returns the current style class name.
* setStyleClass         : Sets the style class name.
* getStylePropertyValue : Returns a style property value.
* setStylePropertyValue : Sets a style property value.
* getInnerHTML          : Returns the innerHTML of the element.
* setInnerHTML          : Sets the innerHTML of the element.
* addEventListener      : Attaches an event to the element.
* removeEventListener   : Detaches an event to the element.
**********************************************************/
function XBElement(obj) {
	if (typeof(obj) == "string")
		obj = document.getElementById(obj);

	if (obj == document)
		return;

	this.element = obj;
	this.id = obj.id;
	this.type = "XBElement";
	this.tagName = obj.tagName;
	this.className = obj.className;
	this.style = obj.style;
	this.left = getObjStylePropertyValue(obj, "left");	
	this.top = getObjStylePropertyValue(obj, "top");
	this.pageX = getObjPageX(obj);
	this.pageY = getObjPageY(obj);
	this.offsetLeft = obj.offsetLeft;
	this.offsetTop = obj.offsetTop;
	this.offsetWidth = obj.offsetWidth;
	this.offsetHeight = obj.offsetHeight;
	this.offsetParent = obj.offsetParent;
	this.setAttribute = function(attr, val) { eval("this." + attr + " = val"); }
	this.getAttribute = function(attr) { return eval("this." + attr); }
	this.getParentElement = function() { return (obj.parentNode != null)?(new XBElement(obj.parentNode)):(null); }
	this.getFirstChild = function() { return (obj.firstChild != null)?(new XBElement(obj.firstChild)):(null); }
	this.getLastChild = function() { return (obj.lastChild != null)?(new XBElement(obj.lastChild)):(null); }
	this.getPreviousSibling = function() { return (obj.previousSibling != null)?(new XBElement(obj.previousSibling)):(null); }
	this.getNextSibling = function() { return (obj.nextSibling != null)?(new XBElement(obj.nextSibling)):(null); }
	this.getChildElements = function() {
		var childrenElements = new Array();

		for (var i = 0; i < obj.childNodes.length; i++) {
			childrenElements[i] = new XBElement(obj.childNodes[i]);
		}

		return childrenElements;
	}
	this.getStyleClass = function() { return obj.className; }
	this.setStyleClass = function(newClass) { obj.className = newClass; }
	this.getStylePropertyValue = function(property) {
		return getObjStylePropertyValue(this.element, property);
	}
	this.setStylePropertyValue = function(property, value) {
		setObjStylePropertyValue(this.element, property, value);
	}
	this.getInnerHTML = function() { return obj.innerHTML; }
	this.setInnerHTML = function(html) { obj.innerHTML = html; }
	this.addEventListener = function(eventType, eventListener) {
		addObjEventListener(this.element, eventType, eventListener);
	}
	this.removeEventListener = function(eventType, eventListener) {
		removeObjEventListener(this.element, eventType, eventListener);
	}
}

/**********************************************************
* XBEvent Class
*
* Read-Only Attributes:
* event         : The original event object.
* type          : The event type.
* target        : A reference to the target object to which the event was originally dispatched.
* currentTarget : A reference to the currently registered target element.
* relatedTarget : A reference to indentify a secondary target element.
* eventPhase    : Indicates the current event phase.
* bubbles       : Boolean value to indicate if the event is bubbling.
* cancelable    : Boolean value to indicate if the default action can be prevented.
* timeStamp     : Timstamp at which the event was created.
* screenX       : Horizontal coordinate relative to the screen.
* screenY       : Vertical coordinate relative to the screen.
* clientX       : Horizontal coordinate relative to the client/browser visible area.
* clientY       : Vertical coordinate relative to the client/browser visible area.
* pageX         : Horizontal coordinate relative to the page.
* pageY         : Vertical coordinate relative to the page.
* ctrlKey       : Boolean value to indicate if <ctrl> key was pressed.
* shiftKey      : Boolean value to indicate if <shift> key was pressed.
* altKey        : Boolean value to indicate if <alt> key was pressed.
* metaKey       : Boolean value to indicate if meta key was pressed.
* keyCode       : A numeric value to represent the key tha was pressed.
*
* Methods:
* button          : Indicates which mouse button was pressed during the event.
* stopPropagation : Stops the event from propagating along the DOM.
* preventDefault  : Cancels the default action of the event, only if it is cancelable.
**********************************************************/
function XBEvent(e) {
	this.AT_TARGET = 1;
	this.BUBBLING_PHASE = 2;
	this.CAPTURING_PHASE = 3;
	this.LEFT = 0;
	this.MIDDLE = 1;
	this.RIGHT = 2;
	this.event = e;

	// DOM2 InterfaceEvent
	this.type = (isIE)?(e.type):(e.type);
	this.target = XBEvent_getTarget(e);
	this.currentTarget = XBEvent_getCurrentTarget(e);
	this.eventPhase = (isIE)?(0):(e.eventPhase);
	this.bubbles = (isIE)?(e.cancelBubble):(e.bubbles);
	this.cancelable = (isIE)?((e.returnValue)?(e.returnValue):(false)):(e.cancelable);
	this.timeStamp = (isIE)?(new Date().getTime()):(e.timeStamp);
	this.stopPropagation = function() {
		if (isIE)
			e.cancelBubble = true;
		else
			e.stopPropagation();
	}
	this.preventCapture = function() {
		if (isIE)
			e.returnValue = false;
		else
			e.preventCapture();
	}
	this.preventDefault = function() {
		if (this.cancelable) {
			if (isIE)
				e.returnValue = false;
			else
				e.preventDefault();
		}
	}

	// DOM2 MouseEvent
	this.screenX = e.screenX;
	this.screenY = e.screenY;
	this.clientX = e.clientX;
	this.clientY = e.clientY;
	this.pageX = e.clientX + getPageXOffset();
	this.pageY = e.clientY + getPageYOffset();
	this.ctrlKey = e.ctrlKey;
	this.shiftKey = e.shiftKey;
 	this.altKey = e.altKey;
 	this.metaKey = (isIE)?(0):(e.metaKey);
 	if (this.type.indexOf("mouse") != -1) {
 		this.button = function() {
 			if (isIE) {
 				switch(e.button) {
 					case 1:
 						return this.LEFT;
 					case 2:
 						return this.RIGHT;
 					case 4:
 						return this.MIDDLE;
 					default:
 						return -1;
 				}
 			}
 			else {
				return e.button;
 			}
 		}
 	}
 	else if (this.type.indexOf("click") != -1) {
 		this.button = function() { return this.LEFT; }
 	}
 	this.relatedTarget = XBEvent_getRelatedTarget(e);

 	// IE Specific AddOn
 	this.keyCode = (isIE)?(parseInt(e.keyCode)):(parseInt(e.which));
}

function XBEvent_getTarget(e) {
	var result = null;

	if (isIE) {
		result = e.srcElement;
	}
	else {
		var node = e.target;
		if (node) {
		    while (node.nodeType != 1)
		        node = node.parentNode;
		    result = node;
	    }
	}

	if (result != null)
		return result;
	else
		return null;
}

function XBEvent_getCurrentTarget(e) {
	var result = null;

	if (isIE) {
		if (e.type.indexOf("mouseover") != -1)
			result = e.toElement;
		else if (e.type.indexOf("mouseout") != -1)
			result = e.fromElement;
	}
	else {
		result = e.currentTarget;
	}

	if (result != null)
		return result;
	else
		return null;

}

function XBEvent_getRelatedTarget(e) {
	var result = null;

	if (isIE) {
		if (e.type.indexOf("mouseover") != -1)
			result = e.fromElement;
		else if (e.type.indexOf("mouseout") != -1)
			result = e.toElement;
	}
	else {
		result = e.relatedTarget;
	}

	if (result != null)
		return result;
	else
		return null;
}

/**********************************************************
* Event Utils
**********************************************************/

function addObjEventListener(obj, eventType, eventListener) {
	// Disable event capturing, since IE doesn't support event capture
	var useCapture = false;
	var eventStart = "obj.on" + eventType.toLowerCase() + " = eventListener";

	if (obj.addEventListener) {
		obj.addEventListener(eventType, eventListener, useCapture);
	}
	else if (obj.attachEvent) {
		obj.attachEvent("on" + eventType, eventListener);
	}
	else {
		eval(eventStart);
	}
}

function removeObjEventListener(obj, eventType, eventListener) {
	// Disable event capturing, since IE doesn't support event capture
	var useCapture = false;
	var eventStop = "obj.on" + eventType.toLowerCase() + " = null";

	if (obj.removeEventListener) {
		obj.removeEventListener(eventType, eventListener, useCapture);
	}
	else if (obj.detachEvent) {
		obj.detachEvent(eventType, eventListener);
  	}
	else {
		eval(eventStop);
	}
}

/**********************************************************
* CSS Style Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Given a DOM element and one of its style properties,
// returns the current style property value.
///////////////////////////////////////////////////////////
function getObjStylePropertyValue(obj, property) {
	var result = null;

	if (obj != null && obj != document) {
		if (isIE) {
			property = toJSPropertyName(property);
			result = obj.currentStyle.getAttribute(property);
		}
		else if (isNS) {
			if (obj.nodeName.indexOf("text") == -1) {
				result = obj.ownerDocument.defaultView.getComputedStyle(obj, "").getPropertyValue(property);
			}
		}
	}

	return result;
}

///////////////////////////////////////////////////////////
// Sets a style property value to a given DOM element.
///////////////////////////////////////////////////////////
function setObjStylePropertyValue(obj, property, value) {
	property = toJSPropertyName(property);
	eval("obj.style." + property + " = value");
}

///////////////////////////////////////////////////////////
// Returns the horizontal position of a given DOM element 
// relative to the page.
///////////////////////////////////////////////////////////
function getObjPageX(obj) {
	var num = 0;

	if (obj != document) {
		for (var p = obj; p && p.tagName != "BODY"; p = p.offsetParent)
			num += p.offsetLeft;
	}

	return num;
}

///////////////////////////////////////////////////////////
// Returns the vertical position of a given DOM element 
// relative to the page.
///////////////////////////////////////////////////////////
function getObjPageY(obj) {
	var num = 0;

	if (obj != document) {
		for (var p = obj; p && p.tagName != "BODY"; p = p.offsetParent)
			num += p.offsetTop;
	}
	return num;
}

///////////////////////////////////////////////////////////
// Returns the client/browser visible width in pixels.
///////////////////////////////////////////////////////////
function getClientWidth(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var width = 0;

	if (isIE)
		width = doc.documentElement.clientWidth;
	else if (isNS)
		width = winRef.innerWidth;

	return width;
}

///////////////////////////////////////////////////////////
// Returns the client/browser visible height in pixels.
///////////////////////////////////////////////////////////
function getClientHeight(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var height = 0;

	if (isIE)
		height = doc.documentElement.clientHeight;
	else if (isNS)
		height = winRef.innerHeight;

	return height;
}

///////////////////////////////////////////////////////////
// Returns the page width in pixels.
///////////////////////////////////////////////////////////
function getPageWidth(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var width = 0;

	if (isIE)
		width = doc.body.scrollWidth;
	else if (isNS)
		width = doc.width;

	return width;
}

///////////////////////////////////////////////////////////
// Returns the page height in pixels.
///////////////////////////////////////////////////////////
function getPageHeight(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var height = 0;

	if (isIE)
		height = doc.body.scrollHeight;
	else if (isNS)
		height = doc.height;

	return height;
}

///////////////////////////////////////////////////////////
// Returns the amount of content that has been hidden 
// by scrolling to the right.
///////////////////////////////////////////////////////////
function getPageXOffset(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var offset = 0;

	if (isIE)
		offset = doc.documentElement.scrollLeft;
	else if (isNS)
		offset = winRef.pageXOffset;

	return offset;
}

///////////////////////////////////////////////////////////
// Returns the amount of content that has been hidden 
// by scrolling down.
///////////////////////////////////////////////////////////
function getPageYOffset(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var offset = 0;

	if (isIE)
		offset = doc.documentElement.scrollTop;
	else if (isNS)
		offset = winRef.pageYOffset;

	return offset;
}

///////////////////////////////////////////////////////////
// Converts a style property in CSS format to JavaScript
// format. (e.g. background-color  --> backgroundColor)
///////////////////////////////////////////////////////////
function toJSPropertyName(property) {
	while (property.lastIndexOf("-") != -1) {
		var dashPos = property.lastIndexOf("-");
		var upChar = property.charAt(dashPos + 1).toUpperCase();
		property = property.substring(0, dashPos) + upChar + property.substring(dashPos + 2);
	}
	return property;
}

/**********************************************************
* IFrame Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Returns the window reference of an IFRAME by its ID.
// IE handles the content in an IFRAME in a special 
// attribute called "contentWindow".
///////////////////////////////////////////////////////////
function getIFrameById(iframeID, winRef) {
	if (arguments.length == 1)
		winRef = window;

	var doc = winRef.document;	
	var iframeElement = doc.getElementById(iframeID);

	if (iframeElement != null && iframeElement.contentWindow)
		return iframeElement.contentWindow;
	else
		return iframeElement;
}

///////////////////////////////////////////////////////////
// Returns the document reference of an IFRAME by its ID.
// IE handles the document in an IFRAME in a special 
// attribute called "contentDocument".
///////////////////////////////////////////////////////////
function getIFrameDocumentById(iframeID, winRef) {
	if (arguments.length == 1)
		winRef = window;
	
	var iframeDoc = null;
	var iframeObj = getIFrameById(iframeID, winRef);

	if (iframeObj != null && iframeObj.contentDocument) {
		iframeDoc = iframeObj.contentDocument;
	}
	else if (iframeObj != null && iframeObj.document) {
		iframeDoc = iframeObj.document;
	}

	return iframeDoc;
}

/**********************************************************
* Debug Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Given any object, output its content in the following
// format:
//    attribute:::value<end>
///////////////////////////////////////////////////////////
function inspect(obj) {
	var output = "";

	if (obj == null) {
		return null;
	}
	else if (typeof(obj) == "string") {
		return obj;	
	}
	else {
		for (var i in obj) {
			if (typeof(obj[i]) != "unknown" && typeof(obj[i]) != "undefined")
				output += i + " ::: " + obj[i] + "<end>\n";
			else if (typeof(obj[i]) == "unknown")
				output += i + " ::: unknown<end>\n";
			else
				output += i + " ::: undefined<end>\n";
		}
		return output;
	}
}

///////////////////////////////////////////////////////////
// Given a DOM element, output its style properties and
// values in the following format:
//    attribute:::value<end>
// Can be used in conjunction with debugDialog:
//    debugDialog(insepect(obj));
///////////////////////////////////////////////////////////
function inspectStyle(obj) {
	var output = "";

	if (obj.style) {
		for (var i in obj.style) {
			if (typeof(obj.style[i]) != "unknown" && typeof(obj.style[i]) != "undefined")
				output += i + " ::: " + obj.style[i] + "<end>\n";
			else if (typeof(obj[i]) == "unknown")
				output += i + " ::: unknown<end>\n";
			else
				output += i + " ::: undefined<end>\n";
		}
	}
	else {
		output += "Error: style is undefined in this object.";
	}

	return output;
}

///////////////////////////////////////////////////////////
// Shows the mouse status information in window status bar.
///////////////////////////////////////////////////////////
function showMouseMoveStatus(isEnable) {
	if (isEnable) {
		addObjEventListener(document, "mousemove", XBDebug_mouseMoveListener);
	}
	else {
		removeObjEventListener(document, "mousemove", XBDebug_mouseMoveListener);
	}
}

///////////////////////////////////////////////////////////
// Event handler of showMouseMoveStatus.
// For internal use only.
///////////////////////////////////////////////////////////
function XBDebug_mouseMoveListener(evt) {
	var e = new XBEvent(evt);
	var mouseStatus = "Mouse Status:";
	mouseStatus += " ClientX: " + e.clientX;
	mouseStatus += " ClientY: " + e.clientY;
	mouseStatus += " PageX: " + e.pageX;
	mouseStatus += " PageY: " + e.pageY;
	mouseStatus += " ScreenX: " + e.screenX;
	mouseStatus += " ScreenY: " + e.screenY;
	window.status = mouseStatus;
}

/**********************************************************
* Modal Dialog Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Open an UTF-8 modal dialog
///////////////////////////////////////////////////////////
function openModalDialog(url, width, height, scrolling, args) {
	var features = "";
	var dialogName = (new Date()).getMilliseconds().toString();
	var dialogWidth = width;
	var dialogHeight = height;
	var dialogArgs = new Object();
	var returnValue = null;

	for (i in args) {
		dialogArgs[i] = args[i];
	}

	dialogArgs.timeout = false;
	if (isIE) {
		features = "dialogWidth: " + dialogWidth + "px; dialogHeight: " + dialogHeight + "px; center; status: no; help: no;";
		features += (scrolling)?(" scroll: yes;"):(" scroll: no;");
		returnValue = window.showModalDialog(url, dialogArgs, features);
		if (dialogArgs.timeout == true) {
			top.close();
		}
		return returnValue;
	}
	else {
		dialogWidth = (dialogWidth - 20 <= 0)?(dialogWidth):(dialogWidth - 20);
		dialogHeight = (dialogHeight - 20 <= 0)?(dialogHeight):(dialogHeight - 20);
		var posX = window.screenX + ((window.outerWidth - parseInt(dialogWidth)) / 2);
		var posY = window.screenY + ((window.outerHeight - parseInt(dialogHeight)) / 2);
		window.dialogArguments = dialogArgs;
		features = "screenX=" + posX + ", screenY=" + posY + ", width=" + dialogWidth + "px, height=" + dialogHeight + "px, modal=yes, sidebars=no, menubars=no";
		features += (scrolling)?(", scrollbars=yes"):(", scrollbars=no");
		window.returnValue = null;
		window.open(url, dialogName, features);

		if (window.returnValue != null)
			return window.returnValue;
	}
}

///////////////////////////////////////////////////////////
// Adjusts the size of the modal dialog to fit the content.
///////////////////////////////////////////////////////////
function autoResizeModalDialog() {
	var hiddenWidth = getPageWidth() - getClientWidth();
	var hiddenHeight = getPageHeight() - getClientHeight();

	if (isIE) {
		window.dialogWidth = parseInt(window.dialogWidth) + hiddenWidth + 18 + "px";
		window.dialogHeight = parseInt(window.dialogHeight) + hiddenHeight + 18 + "px";
	}
	else if (isNS) {
		window.sizeToContent();
	}
}

/** END OF XBUtil **********************************************************/


/****************************************************************************
* Open a new window.
*
* url - The URL of the help file.
* windowName - The title of the window.
* offset     - The offset in pixels from the parent window
* features   - The various attributes of the window to be created.
*
* Returns the opened window
****************************************************************************/
function openWindow(url, windowName, offset, features)
{
  if (features == null)
    features = "resizable=yes,scrollbars=yes,menubar=yes, copyhistory=no";

  if (offset == null)
    offset = 0;

  offset += 20;

  if(navigator.appName == "Netscape")
  {
    if(parseInt(navigator.appVersion) > 3)
    {
      // set width and height
      if (features.indexOf(",width=") < 0)
        features += ",width=" + top.innerWidth + ",height=" + top.innerHeight;

      // set window position
      features += ",screenX=" + (top.screenX+offset) + ",screenY=" + (top.screenY+offset);
    }
    else
    {
      // set width and height
      if (features.indexOf(",width=") < 0)
        features += ",width=" + top.width + ",height=" + top.height;

      // set window position not available in version 3 and less
    }
  }// END if

  else
  {
    // set width and height
    if (features.indexOf(",width=") < 0)
    {
      var width=",width=", height=",height=";

      if (screen.width < 750)
        width += screen.availWidth;
      else
        width += "750";

      if (screen.height < 500)
        height += screen.availHeight;
      else
        height += "500";
      features += width + height;
    }

    // No way to query current window position in IE...
    // features += ",left=" + (screen.availLeft+offset) + ",top=" + (screen.availTop+offset);
    features += ",screenLeft=" + (screen.availLeft+offset) + ",screenTop=" + (screen.availTop+offset);

  }// END else

  var target = window.open( "", windowName, features);

  target.location.href = url;
  // focus function is not working under IE4 with Service pack 2
  // it will crash, we need to detect the specific IE version 'MSIE 4.01' - d48999
  // we only use focus() function for all browser except IE 4.01
  var navVersion = navigator.appVersion
  if ( navVersion.indexOf("MSIE 4.01") == -1 )
  {
    target.focus();
  }

  return target;

}// END openWindow

/****************************************************************************
* Determines whether an object has been assigned a value.
*
* Returns TRUE if it has been assigned a value; FALSE otherwise
****************************************************************************/
function defined(obj)
{
  var str = typeof obj;

  if((str == "undefined") || (obj == null))
    return false;
  else
    return true;
}// END defined

/****************************************************************************
* Returns the type of object.
****************************************************************************/
function objectType(obj)
{
 //
 // alert( "The function Util::objectType() is deprecated!"
 //      + "It fails in IE and thus must not be used.\n\n"
 //      + "If you see this message open a defect immediately.");

  var constructor = (String)(obj.constructor);
  var tokens = constructor.split(" ");

  for(var i=0; i<tokens.length; i++)
  {
    if(tokens[i].indexOf("function") != -1)
    {
      var end = tokens[i+1].indexOf("(");

      if(end == -1)
        return(tokens[i+1]);
      else
        return(tokens[i+1].substring(0, end));
    }
  }

}// END objectType

/****************************************************************************
* Trim the leading and trailing blank of the input string 'word'
*
* Returns a string
****************************************************************************/
function trim(inword)
{
   word = inword.toString();
   var i=0;
   var j=word.length-1;
   while(word.charAt(i) == " ") i++;
   while(word.charAt(j) == " ") j--;
   if (i > j) {
		return word.substring(i,i);
	} else {
		return word.substring(i,j+1);
	}
}

/****************************************************************************
* Check if the input string 'id' is empty
*
* Returns true or false
****************************************************************************/
function isInputStringEmpty(id)
{
  return !id.match(/[^\s]/);
}


/****************************************************************************
* This will alert the user with the error/warning message 'message' and
* highlight the text field 'field'.
*
*
****************************************************************************/
function reprompt(field, message) {
    window.status = "";
    alertDialog(message);
    field.focus();
    field.select();

}

/****************************************************************************
* This will remove the Return \r \n chars from a string and
* replace them by " " char.
*
*
****************************************************************************/
function removeReturnChar(word)
{
   var i=0;
   var j=word.length;
   var result="";

   for (i=0; i<j; ++i) {
      if((word.charAt(i) == "\r") || (word.charAt(i) == "\n" )) {
         result += " ";
      } else {
         result += word.charAt(i);
      }
   }

   return result;
}


/**************************************************************************
* This will return the index position that a char in a given string
* return "false" if couldn't found, otherwise it returns the first invalid
* character.
*
***************************************************************************/
function find(givenString, searchChars)
{
  for ( var i=0; i< searchChars.length; i++)
  {
   var achar = searchChars.substring(i, i+1);

   if ( givenString.indexOf(achar) != -1 )
     return achar;
  }
   return "false";
}

/*********************************************************************
* Return the number of occurrence of a given char
**********************************************************************/
function numOfOccur(givenString, searchChars)
{
  var count = 0;

  for (var i=0; i< givenString.length; i++)
  {
     if ( givenString.charAt(i) == searchChars.charAt(0) )
       count ++;
  }

  return count;
}


function convertFromTextToHTML(obj)
{
   var string = new String(obj);
   var result = "";

   for (var i=0; i < string.length; i++ ) {
      if (string.charAt(i) == "<")       result += "&lt;";
      else if (string.charAt(i) == ">")  result += "&gt;";
      else result += string.charAt(i);
   }
   return result;
}

function convertFromHTMLToText(obj)
{
   /* add some padding to the string so we don't
      require bounds checking */
   var string = new String(obj + "_____");
   var result = "";

   for (var i=0; i < string.length; ) {
      if (string.charAt(i) == "&") {
         if (string.substring(i, i+4) == "&lt;") {
            result += "<";
            i += 4;
         }
         else if (string.substring(i, i+4) == "&gt;") {
            result += ">";
            i += 4;
         }
         else {
            result += string.charAt(i);
            i++;
         }
      }
      else {
         result += string.charAt(i);
         i++;
      }
   }
   return result.substring(0, result.length-5);
}


function isEmpty(id) {
	if (typeof(id) == "string") {
		return !id.match(/[^\s]/);
	}
	else {
		return (id)?(false):(true);
	}
}


//////////////////////////////////////////////////////////
// This function will check whether or not the time has
// a valid format. hh:mm
//
// by Tony Mao
// Input: time
// Return code = "true", time has a right format
// Return code = "false", time format is wrong
//
//////////////////////////////////////////////////////////
function validTime(time1) {
   var delimiter = ":";
   var hh, mm;
   var time1Length;
   var hhlength;
   var mmlength;

   time1Length = time1.length;

   if (time1 == "" || time1.indexOf(delimiter) == -1 ||  time1Length > 5 ) return false;

   hh = time1.substring(0,time1.indexOf(delimiter));
   mm = time1.substring(time1.indexOf(delimiter) + 1);

   hhlength = hh.length;
   mmlength = mm.length;

   if (hhlength <1 || hhlength >2 || mmlength <1 || mmlength >2) return false;
   if (hh=="" || mm == "" ) return false;
   if (isNaN(hh) || isNaN(mm) ) return false;

   if ( parseInt(hh) > 23 || parseInt(hh) < 0 ) return false;
   if ( parseInt(mm) > 59 || parseInt(mm) < 0 ) return false;

   return true;
}


//////////////////////////////////////////////////////////
// This function will limit a text area input box to a
// specified size.  just use the onKeyUp and onKeyDown events
// with the text area box.
// call with ::
//    arg1=this.form.<myTextAreaName>
//    arg2=<maximumSizeForTextArea>
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function limitTextArea(field, maxlimit) {
    if (field.value.length > maxlimit) {
       //  field is too long... chop it down
       field.value = field.value.substring(0, maxlimit);
    }
}


//////////////////////////////////////////////////////////
// This function will validate a typical name field
// and restrict it to pretty much alphanumerics.
// All special characters are invalid with some exceptions
// " ", "-", "_", and "." are all valid
// The string can also not start with a leading number
// The string can also not be empty
// call with ::
//    arg1=<myInputString>
//
// return true is name is valid, false otherwise
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function isValidName(myString) {
    var invalidChars = "~!@#$%^&*()+=[]{};:,<>?/|`"; // invalid chars
    invalidChars += "\t\'\"\\"; // escape sequences
    var invalidStartChars = "0123456789";

    // if the string is empty it is not a valid name
    if (isEmpty(myString)) return false;

    // look for presence of invalid characters.  if one is
    // found return false.  otherwise return true
    for (var i=0; i<myString.length; i++) {
      if (invalidChars.indexOf(myString.substring(i, i+1)) >= 0) {
        return false;
      }
    }

    // look for a leading number... and disallow it.
    var startChar = myString.substring(0,1);
    for (var i=0; i<invalidStartChars.length; i++) {
      if (invalidStartChars.indexOf(startChar) >= 0) {
        return false;
      }
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will dump out the content of a javascript object
// This is useful for debugging purposes.
// In your code you can do this:
// alert(dumpObject(myBigFatObject));
//
// This will dump out the objects contents
// arg1 = the object you want info on...
// return a string which you can send to alert()
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function dumpObject(what) {
   var output = '';
   for (i in what) {
       if (typeof what[i] == 'object') {
           output += dumpObject(what[i]);
       }
       else
           output += i + ' = ' + what[i] + '\n';
   }
   return output;
}

// function to clone a javascript object
function cloneObject(what) {
    for (i in what) {
       if (typeof i == 'object') {
          this[i] = new cloneObject(what[i]);
       }
       else {
          this[i] = what[i];
       }
    }
}

//////////////////////////////////////////////////////////
// This function will validate a positive integer quantity (including 0)
//
// arg1 = the object you want info on...
// Return true is this input arg is a valid positive int,
// otherwise return false...
//
//////////////////////////////////////////////////////////
function isValidPositiveInteger(myString) {
    var validChars = "0123456789";

    // if the string is empty it is not a valid integer
    if (isEmpty(myString)) return false;

    // look for non numeric characters in the input string
    for (var i=0; i<myString.length; i++) {
      if (validChars.indexOf(myString.substring(i, i+1)) == "-1") {
        return false;
      }
    }
    // look for bad leading zeroes in the input string
    if (myString.length > 1 && myString.substring(0,1) == "0") {
       return false;
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will validate a positive integer quantity (excluding 0)
//
// arg1 = the object you want info on...
// Return true is this input arg is a valid positive int,
// otherwise return false...
//
//////////////////////////////////////////////////////////
function isValidNZPosInt(myString) {
    var validChars = "0123456789";

    // if the string is empty it is not a valid integer
    if (isEmpty(myString)) return false;

    // look for non numeric characters in the input string
    for (var i=0; i<myString.length; i++) {
      if (validChars.indexOf(myString.substring(i, i+1)) == "-1") {
        return false;
      }
    }
    // look for bad leading zeroes in the input string
    if (myString.substring(0,1) == "0") {
       return false;
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will count the number of bytes
// represented in a UTF-8 string
//
// arg1 = the UTF-8 string
// arg2 = the maximum number of bytes allowed in your input field
// Return false is this UTF-8 string is larger then arg2
// Otherwise return true...
//////////////////////////////////////////////////////////
function isValidUTF8length(UTF8String, maxlength) {
    // alert('UTF8String='+UTF8String+'\nUTF-8 length='+utf8StringByteLength(UTF8String)+'\nmaxlength='+maxlength);
    if (utf8StringByteLength(UTF8String) > maxlength) return false;
    else return true;
}

//////////////////////////////////////////////////////////
// This function will count the number of bytes
// represented in a UTF-8 string
//
// arg1 = the UTF-8 string you want a byte count of...
// Return the integer number of bytes represented by the string
//////////////////////////////////////////////////////////
function utf8StringByteLength(UTF8String) {
  if (UTF8String === null) return 0;
  var str = String(UTF8String);
  var oneByteMax = 0x007F;
  var twoByteMax = 0x07FF;
  var byteSize = str.length;

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    if (chr > oneByteMax) byteSize = byteSize + 1;
    if (chr > twoByteMax) byteSize = byteSize + 1;
  }
  return byteSize;
}

/**********************************************************
* Globalized Modal Dialogs
**********************************************************/
function debugDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";
	
	if (top.webappPath)
		openWindow(top.webappPath + 'tools/common/Debug.jsp', "Debug", 5);
	else
		openWindow('tools/common/Debug.jsp', "Debug", 5);

	window.debugMessage = sMsg;
}

function alertDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";

	var dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		openModalDialog(top.webappPath + 'AlertDialogView', 500, 145, true, dialogArgs);
	else
		openModalDialog('AlertDialogView', 480, 150, true, dialogArgs);		
}

function confirmDialog(sMsg)
{
	if (sMsg == null)
		sMsg = "";

	dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		returnValue = openModalDialog(top.webappPath + 'ConfirmDialogView', 500, 145, true, dialogArgs);
	else
		returnValue = openModalDialog('ConfirmDialogView', 500, 145, true, dialogArgs);

	if (returnValue == null)
		returnValue = false;

	return returnValue;
}

function promptDialog(sMsg, sDefaultValue, iLength, bPasswordInput)
{
	if (sMsg == null)
		sMsg = "";

	dialogArgs = new Array();
	dialogArgs.message = sMsg;
	dialogArgs.defaultValue = (sDefaultValue != null)?(sDefaultValue):("");

	if (iLength == null)
		dialogArgs.iLength = 256;   // default length
	else
		dialogArgs.iLength = iLength;

	if (bPasswordInput == null)
		dialogArgs.passwordInput = false;
	else
		dialogArgs.passwordInput = bPasswordInput;

	if (top.webappPath)
		returnValue = openModalDialog(top.webappPath + 'PromptDialogView', 500, 145, true, dialogArgs);
	else
		returnValue = openModalDialog('PromptDialogView', 500, 150, true, dialogArgs);

	if (typeof(returnValue) == "undefined")
		returnValue = null;

	return returnValue;
}

function infoDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";

	var dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		openModalDialog(top.webappPath + 'tools/common/Information.jsp', 500, 145, true, dialogArgs);
	else
		openModalDialog('tools/common/Information.jsp', 480, 150, true, dialogArgs);		
}

(function defineMustache(global,factory){if(typeof exports==="object"&&exports&&typeof exports.nodeName!=="string"){factory(exports)}else if(typeof define==="function"&&define.amd){define(["exports"],factory)}else{global.Mustache={};factory(global.Mustache)}})(this,function mustacheFactory(mustache){var objectToString=Object.prototype.toString;var isArray=Array.isArray||function isArrayPolyfill(object){return objectToString.call(object)==="[object Array]"};function isFunction(object){return typeof object==="function"}function typeStr(obj){return isArray(obj)?"array":typeof obj}function escapeRegExp(string){return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}function hasProperty(obj,propName){return obj!=null&&typeof obj==="object"&&propName in obj}function primitiveHasOwnProperty(primitive,propName){return primitive!=null&&typeof primitive!=="object"&&primitive.hasOwnProperty&&primitive.hasOwnProperty(propName)}var regExpTest=RegExp.prototype.test;function testRegExp(re,string){return regExpTest.call(re,string)}var nonSpaceRe=/\S/;function isWhitespace(string){return!testRegExp(nonSpaceRe,string)}var entityMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};function escapeHtml(string){return String(string).replace(/[&<>"'`=\/]/g,function fromEntityMap(s){return entityMap[s]})}var whiteRe=/\s*/;var spaceRe=/\s+/;var equalsRe=/\s*=/;var curlyRe=/\s*\}/;var tagRe=/#|\^|\/|>|\{|&|=|!/;function parseTemplate(template,tags){if(!template)return[];var lineHasNonSpace=false;var sections=[];var tokens=[];var spaces=[];var hasTag=false;var nonSpace=false;var indentation="";var tagIndex=0;function stripSpace(){if(hasTag&&!nonSpace){while(spaces.length)delete tokens[spaces.pop()]}else{spaces=[]}hasTag=false;nonSpace=false}var openingTagRe,closingTagRe,closingCurlyRe;function compileTags(tagsToCompile){if(typeof tagsToCompile==="string")tagsToCompile=tagsToCompile.split(spaceRe,2);if(!isArray(tagsToCompile)||tagsToCompile.length!==2)throw new Error("Invalid tags: "+tagsToCompile);openingTagRe=new RegExp(escapeRegExp(tagsToCompile[0])+"\\s*");closingTagRe=new RegExp("\\s*"+escapeRegExp(tagsToCompile[1]));closingCurlyRe=new RegExp("\\s*"+escapeRegExp("}"+tagsToCompile[1]))}compileTags(tags||mustache.tags);var scanner=new Scanner(template);var start,type,value,chr,token,openSection;while(!scanner.eos()){start=scanner.pos;value=scanner.scanUntil(openingTagRe);if(value){for(var i=0,valueLength=value.length;i<valueLength;++i){chr=value.charAt(i);if(isWhitespace(chr)){spaces.push(tokens.length);indentation+=chr}else{nonSpace=true;lineHasNonSpace=true;indentation+=" "}tokens.push(["text",chr,start,start+1]);start+=1;if(chr==="\n"){stripSpace();indentation="";tagIndex=0;lineHasNonSpace=false}}}if(!scanner.scan(openingTagRe))break;hasTag=true;type=scanner.scan(tagRe)||"name";scanner.scan(whiteRe);if(type==="="){value=scanner.scanUntil(equalsRe);scanner.scan(equalsRe);scanner.scanUntil(closingTagRe)}else if(type==="{"){value=scanner.scanUntil(closingCurlyRe);scanner.scan(curlyRe);scanner.scanUntil(closingTagRe);type="&"}else{value=scanner.scanUntil(closingTagRe)}if(!scanner.scan(closingTagRe))throw new Error("Unclosed tag at "+scanner.pos);if(type==">"){token=[type,value,start,scanner.pos,indentation,tagIndex,lineHasNonSpace]}else{token=[type,value,start,scanner.pos]}tagIndex++;tokens.push(token);if(type==="#"||type==="^"){sections.push(token)}else if(type==="/"){openSection=sections.pop();if(!openSection)throw new Error('Unopened section "'+value+'" at '+start);if(openSection[1]!==value)throw new Error('Unclosed section "'+openSection[1]+'" at '+start)}else if(type==="name"||type==="{"||type==="&"){nonSpace=true}else if(type==="="){compileTags(value)}}stripSpace();openSection=sections.pop();if(openSection)throw new Error('Unclosed section "'+openSection[1]+'" at '+scanner.pos);return nestTokens(squashTokens(tokens))}function squashTokens(tokens){var squashedTokens=[];var token,lastToken;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];if(token){if(token[0]==="text"&&lastToken&&lastToken[0]==="text"){lastToken[1]+=token[1];lastToken[3]=token[3]}else{squashedTokens.push(token);lastToken=token}}}return squashedTokens}function nestTokens(tokens){var nestedTokens=[];var collector=nestedTokens;var sections=[];var token,section;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];switch(token[0]){case"#":case"^":collector.push(token);sections.push(token);collector=token[4]=[];break;case"/":section=sections.pop();section[5]=token[2];collector=sections.length>0?sections[sections.length-1][4]:nestedTokens;break;default:collector.push(token)}}return nestedTokens}function Scanner(string){this.string=string;this.tail=string;this.pos=0}Scanner.prototype.eos=function eos(){return this.tail===""};Scanner.prototype.scan=function scan(re){var match=this.tail.match(re);if(!match||match.index!==0)return"";var string=match[0];this.tail=this.tail.substring(string.length);this.pos+=string.length;return string};Scanner.prototype.scanUntil=function scanUntil(re){var index=this.tail.search(re),match;switch(index){case-1:match=this.tail;this.tail="";break;case 0:match="";break;default:match=this.tail.substring(0,index);this.tail=this.tail.substring(index)}this.pos+=match.length;return match};function Context(view,parentContext){this.view=view;this.cache={".":this.view};this.parent=parentContext}Context.prototype.push=function push(view){return new Context(view,this)};Context.prototype.lookup=function lookup(name){var cache=this.cache;var value;if(cache.hasOwnProperty(name)){value=cache[name]}else{var context=this,intermediateValue,names,index,lookupHit=false;while(context){if(name.indexOf(".")>0){intermediateValue=context.view;names=name.split(".");index=0;while(intermediateValue!=null&&index<names.length){if(index===names.length-1)lookupHit=hasProperty(intermediateValue,names[index])||primitiveHasOwnProperty(intermediateValue,names[index]);intermediateValue=intermediateValue[names[index++]]}}else{intermediateValue=context.view[name];lookupHit=hasProperty(context.view,name)}if(lookupHit){value=intermediateValue;break}context=context.parent}cache[name]=value}if(isFunction(value))value=value.call(this.view);return value};function Writer(){this.cache={}}Writer.prototype.clearCache=function clearCache(){this.cache={}};Writer.prototype.parse=function parse(template,tags){var cache=this.cache;var cacheKey=template+":"+(tags||mustache.tags).join(":");var tokens=cache[cacheKey];if(tokens==null)tokens=cache[cacheKey]=parseTemplate(template,tags);return tokens};Writer.prototype.render=function render(template,view,partials,tags){var tokens=this.parse(template,tags);var context=view instanceof Context?view:new Context(view);return this.renderTokens(tokens,context,partials,template,tags)};Writer.prototype.renderTokens=function renderTokens(tokens,context,partials,originalTemplate,tags){var buffer="";var token,symbol,value;for(var i=0,numTokens=tokens.length;i<numTokens;++i){value=undefined;token=tokens[i];symbol=token[0];if(symbol==="#")value=this.renderSection(token,context,partials,originalTemplate);else if(symbol==="^")value=this.renderInverted(token,context,partials,originalTemplate);else if(symbol===">")value=this.renderPartial(token,context,partials,tags);else if(symbol==="&")value=this.unescapedValue(token,context);else if(symbol==="name")value=this.escapedValue(token,context);else if(symbol==="text")value=this.rawValue(token);if(value!==undefined)buffer+=value}return buffer};Writer.prototype.renderSection=function renderSection(token,context,partials,originalTemplate){var self=this;var buffer="";var value=context.lookup(token[1]);function subRender(template){return self.render(template,context,partials)}if(!value)return;if(isArray(value)){for(var j=0,valueLength=value.length;j<valueLength;++j){buffer+=this.renderTokens(token[4],context.push(value[j]),partials,originalTemplate)}}else if(typeof value==="object"||typeof value==="string"||typeof value==="number"){buffer+=this.renderTokens(token[4],context.push(value),partials,originalTemplate)}else if(isFunction(value)){if(typeof originalTemplate!=="string")throw new Error("Cannot use higher-order sections without the original template");value=value.call(context.view,originalTemplate.slice(token[3],token[5]),subRender);if(value!=null)buffer+=value}else{buffer+=this.renderTokens(token[4],context,partials,originalTemplate)}return buffer};Writer.prototype.renderInverted=function renderInverted(token,context,partials,originalTemplate){var value=context.lookup(token[1]);if(!value||isArray(value)&&value.length===0)return this.renderTokens(token[4],context,partials,originalTemplate)};Writer.prototype.indentPartial=function indentPartial(partial,indentation,lineHasNonSpace){var filteredIndentation=indentation.replace(/[^ \t]/g,"");var partialByNl=partial.split("\n");for(var i=0;i<partialByNl.length;i++){if(partialByNl[i].length&&(i>0||!lineHasNonSpace)){partialByNl[i]=filteredIndentation+partialByNl[i]}}return partialByNl.join("\n")};Writer.prototype.renderPartial=function renderPartial(token,context,partials,tags){if(!partials)return;var value=isFunction(partials)?partials(token[1]):partials[token[1]];if(value!=null){var lineHasNonSpace=token[6];var tagIndex=token[5];var indentation=token[4];var indentedValue=value;if(tagIndex==0&&indentation){indentedValue=this.indentPartial(value,indentation,lineHasNonSpace)}return this.renderTokens(this.parse(indentedValue,tags),context,partials,indentedValue)}};Writer.prototype.unescapedValue=function unescapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return value};Writer.prototype.escapedValue=function escapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return mustache.escape(value)};Writer.prototype.rawValue=function rawValue(token){return token[1]};mustache.name="mustache.js";mustache.version="3.1.0";mustache.tags=["{{","}}"];var defaultWriter=new Writer;mustache.clearCache=function clearCache(){return defaultWriter.clearCache()};mustache.parse=function parse(template,tags){return defaultWriter.parse(template,tags)};mustache.render=function render(template,view,partials,tags){if(typeof template!=="string"){throw new TypeError('Invalid template! Template should be a "string" '+'but "'+typeStr(template)+'" was given as the first '+"argument for mustache#render(template, view, partials)")}return defaultWriter.render(template,view,partials,tags)};mustache.to_html=function to_html(template,view,partials,send){var result=mustache.render(template,view,partials);if(isFunction(send)){send(result)}else{return result}};mustache.escape=escapeHtml;mustache.Scanner=Scanner;mustache.Context=Context;mustache.Writer=Writer;return mustache});

/*
 *  jQuery screen skeleton - scheletrone - v1.0.6
 *  A jQuery plugin to make a skeleton loading of your html elements.
 *
 *  GitHub: https://github.com/enbifa/jquery.skeleton.loader
 *  Copyright (c) 2017 - Vincenzo Bifano
 */


;(function ( $, window, document ) {
'use strict';

    var debugLog = false;
    var IdElement = "";
    var Name = 'scheletrone';
    var ReplaceText;
    var Words = [
        "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "ut", "aliquam,", "purus", "sit", "amet", "luctus", "venenatis,", "lectus", "magna", "fringilla", "urna,", "porttitor", "rhoncus", "dolor", "purus", "non", "enim", "praesent", "elementum", "facilisis", "leo,", "vel", "fringilla", "est", "ullamcorper", "eget", "nulla", "facilisi", "etiam", "dignissim", "diam", "quis", "enim", "lobortis", "scelerisque", "fermentum", "dui", "faucibus", "in", "ornare", "quam", "viverra", "orci", "sagittis", "eu", "volutpat", "odio", "facilisis", "mauris", "sit", "amet", "massa", "vitae", "tortor", "condimentum", "lacinia", "quis", "vel", "eros", "donec", "ac", "odio", "tempor", "orci", "dapibus", "ultrices", "in", "iaculis", "nunc", "sed", "augue", "lacus,", "viverra", "vitae", "congue", "eu,", "consequat", "ac", "felis", "donec", "et", "odio", "pellentesque", "diam", "volutpat", "commodo", "sed", "egestas", "egestas", "fringilla", "phasellus", "faucibus", "scelerisque", "eleifend", "donec", "pretium", "vulputate", "sapien", "nec", "sagittis", "aliquam", "malesuada", "bibendum", "arcu", "vitae", "elementum",
        "curabitur", "vitae", "nunc", "sed", "velit", "dignissim", "sodales", "ut", "eu", "sem", "integer", "vitae", "justo", "eget", "magna", "fermentum", "iaculis", "eu", "non", "diam", "phasellus", "vestibulum", "lorem", "sed", "risus", "ultricies", "tristique", "nulla", "aliquet", "enim", "tortor,", "at", "auctor", "urna", "nunc", "id", "cursus", "metus", "aliquam", "eleifend", "mi", "in", "nulla", "posuere", "sollicitudin", "aliquam", "ultrices", "sagittis", "orci,", "a", "scelerisque", "purus", "semper", "eget", "duis", "at", "tellus", "at", "urna", "condimentum", "mattis", "pellentesque", "id", "nibh", "tortor,", "id", "aliquet", "lectus", "proin", "nibh", "nisl,", "condimentum", "id", "venenatis", "a,", "condimentum", "vitae", "sapien", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "sed", "tempus,", "urna", "et", "pharetra", "pharetra,", "massa", "massa", "ultricies", "mi,", "quis", "hendrerit", "dolor", "magna", "eget", "est", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "integer", "eget", "aliquet", "nibh", "praesent", "tristique", "magna", "sit", "amet", "purus", "gravida", "quis", "blandit", "turpis", "cursus", "in", "hac", "habitasse", "platea", "dictumst", "quisque", "sagittis,", "purus", "sit", "amet", "volutpat", "consequat,", "mauris", "nunc", "congue", "nisi,", "vitae", "suscipit", "tellus", "mauris", "a", "diam",
        "maecenas", "sed", "enim", "ut", "sem", "viverra", "aliquet", "eget", "sit", "amet", "tellus", "cras", "adipiscing", "enim", "eu", "turpis", "egestas", "pretium", "aenean", "pharetra,", "magna", "ac", "placerat", "vestibulum,", "lectus", "mauris", "ultrices", "eros,", "in", "cursus", "turpis", "massa", "tincidunt", "dui", "ut", "ornare", "lectus", "sit", "amet", "est", "placerat", "in", "egestas", "erat", "imperdiet", "sed", "euismod", "nisi", "porta", "lorem", "mollis", "aliquam", "ut", "porttitor", "leo", "a", "diam", "sollicitudin", "tempor", "id", "eu", "nisl", "nunc", "mi", "ipsum,", "faucibus", "vitae", "aliquet", "nec,", "ullamcorper", "sit", "amet", "risus", "nullam", "eget", "felis", "eget", "nunc", "lobortis", "mattis", "aliquam", "faucibus", "purus", "in", "massa", "tempor", "nec", "feugiat", "nisl", "pretium", "fusce", "id", "velit", "ut", "tortor", "pretium", "viverra", "suspendisse", "potenti", "nullam", "ac", "tortor", "vitae", "purus", "faucibus", "ornare", "suspendisse", "sed", "nisi", "lacus,", "sed", "viverra", "tellus", "in", "hac", "habitasse", "platea", "dictumst", "vestibulum", "rhoncus", "est", "pellentesque", "elit", "ullamcorper", "dignissim", "cras", "tincidunt", "lobortis", "feugiat", "vivamus", "at", "augue", "eget", "arcu", "dictum", "varius", "duis", "at", "consectetur", "lorem",
        "donec", "massa", "sapien,", "faucibus", "et", "molestie", "ac,", "feugiat", "sed", "lectus", "vestibulum", "mattis", "ullamcorper", "velit", "sed", "ullamcorper", "morbi", "tincidunt", "ornare", "massa,", "eget", "egestas", "purus", "viverra", "accumsan", "in", "nisl", "nisi,", "scelerisque", "eu", "ultrices", "vitae,", "auctor", "eu", "augue", "ut", "lectus", "arcu,", "bibendum", "at", "varius", "vel,", "pharetra", "vel", "turpis", "nunc", "eget", "lorem", "dolor,", "sed", "viverra", "ipsum", "nunc", "aliquet", "bibendum", "enim,", "facilisis", "gravida", "neque", "convallis", "a", "cras", "semper", "auctor", "neque,", "vitae", "tempus", "quam", "pellentesque", "nec", "nam", "aliquam", "sem", "et", "tortor", "consequat", "id", "porta", "nibh", "venenatis", "cras", "sed", "felis", "eget", "velit", "aliquet", "sagittis", "id", "consectetur", "purus", "ut", "faucibus", "pulvinar", "elementum", "integer", "enim", "neque,", "volutpat", "ac", "tincidunt", "vitae,", "semper", "quis", "lectus", "nulla", "at", "volutpat", "diam", "ut", "venenatis", "tellus", "in", "metus", "vulputate", "eu", "scelerisque", "felis", "imperdiet", "proin", "fermentum", "leo", "vel", "orci", "porta", "non", "pulvinar", "neque", "laoreet", "suspendisse", "interdum", "consectetur", "libero,", "id", "faucibus", "nisl", "tincidunt", "eget", "nullam", "non", "nisi", "est,", "sit", "amet", "facilisis", "magna",
        "etiam", "tempor,", "orci", "eu", "lobortis", "elementum,", "nibh", "tellus", "molestie", "nunc,", "non", "blandit", "massa", "enim", "nec", "dui", "nunc", "mattis", "enim", "ut", "tellus", "elementum", "sagittis", "vitae", "et", "leo", "duis", "ut", "diam", "quam", "nulla", "porttitor", "massa", "id", "neque", "aliquam", "vestibulum", "morbi", "blandit", "cursus", "risus,", "at", "ultrices", "mi", "tempus", "imperdiet", "nulla", "malesuada", "pellentesque", "elit", "eget", "gravida", "cum", "sociis", "natoque", "penatibus", "et", "magnis", "dis", "parturient", "montes,", "nascetur", "ridiculus", "mus", "mauris", "vitae", "ultricies", "leo", "integer", "malesuada", "nunc", "vel", "risus", "commodo", "viverra", "maecenas", "accumsan,", "lacus", "vel", "facilisis", "volutpat,", "est", "velit", "egestas", "dui,", "id", "ornare", "arcu", "odio", "ut", "sem", "nulla", "pharetra", "diam", "sit", "amet", "nisl", "suscipit", "adipiscing", "bibendum", "est", "ultricies", "integer", "quis", "auctor", "elit",
        "sed", "vulputate", "mi", "sit", "amet", "mauris", "commodo", "quis", "imperdiet", "massa", "tincidunt", "nunc", "pulvinar", "sapien", "et", "ligula", "ullamcorper", "malesuada", "proin", "libero", "nunc,", "consequat", "interdum", "varius", "sit", "amet,", "mattis", "vulputate", "enim", "nulla", "aliquet", "porttitor", "lacus,", "luctus", "accumsan", "tortor", "posuere", "ac", "ut", "consequat", "semper", "viverra", "nam", "libero", "justo,", "laoreet", "sit", "amet", "cursus", "sit", "amet,", "dictum", "sit", "amet", "justo", "donec", "enim", "diam,", "vulputate", "ut", "pharetra", "sit", "amet,", "aliquam", "id", "diam", "maecenas", "ultricies", "mi", "eget", "mauris", "pharetra", "et", "ultrices", "neque", "ornare", "aenean", "euismod", "elementum", "nisi,", "quis", "eleifend", "quam", "adipiscing", "vitae", "proin", "sagittis,", "nisl", "rhoncus", "mattis", "rhoncus,", "urna", "neque", "viverra", "justo,", "nec", "ultrices", "dui", "sapien", "eget", "mi", "proin", "sed", "libero", "enim,", "sed", "faucibus", "turpis", "in", "eu", "mi", "bibendum", "neque", "egestas", "congue", "quisque", "egestas", "diam", "in", "arcu", "cursus", "euismod", "quis", "viverra", "nibh", "cras", "pulvinar", "mattis", "nunc,", "sed", "blandit", "libero", "volutpat", "sed", "cras", "ornare", "arcu", "dui", "vivamus", "arcu", "felis,", "bibendum", "ut", "tristique", "et,", "egestas", "quis", "ipsum", "suspendisse", "ultrices", "gravida", "dictum",
        "fusce", "ut", "placerat", "orci", "nulla", "pellentesque", "dignissim", "enim,", "sit", "amet", "venenatis", "urna", "cursus", "eget", "nunc", "scelerisque", "viverra", "mauris,", "in", "aliquam", "sem", "fringilla", "ut", "morbi", "tincidunt", "augue", "interdum", "velit", "euismod", "in", "pellentesque", "massa", "placerat", "duis", "ultricies", "lacus", "sed", "turpis", "tincidunt", "id", "aliquet", "risus", "feugiat", "in", "ante", "metus,", "dictum", "at", "tempor", "commodo,", "ullamcorper", "a", "lacus", "vestibulum", "sed", "arcu", "non", "odio", "euismod", "lacinia", "at", "quis", "risus", "sed", "vulputate", "odio", "ut", "enim", "blandit", "volutpat", "maecenas", "volutpat", "blandit", "aliquam", "etiam", "erat", "velit,", "scelerisque", "in", "dictum", "non,", "consectetur", "a", "erat", "nam", "at", "lectus", "urna", "duis", "convallis", "convallis", "tellus,", "id", "interdum", "velit", "laoreet", "id", "donec", "ultrices", "tincidunt", "arcu,", "non", "sodales", "neque", "sodales", "ut", "etiam", "sit", "amet", "nisl", "purus,", "in", "mollis", "nunc",
        "sed", "id", "semper", "risus", "in", "hendrerit", "gravida", "rutrum", "quisque", "non", "tellus", "orci,", "ac", "auctor", "augue", "mauris", "augue", "neque,", "gravida", "in", "fermentum", "et,", "sollicitudin", "ac", "orci", "phasellus", "egestas", "tellus", "rutrum", "tellus", "pellentesque", "eu", "tincidunt", "tortor", "aliquam", "nulla", "facilisi", "cras", "fermentum,", "odio", "eu", "feugiat", "pretium,", "nibh", "ipsum", "consequat", "nisl,", "vel", "pretium", "lectus", "quam", "id", "leo", "in", "vitae", "turpis", "massa", "sed", "elementum", "tempus", "egestas", "sed", "sed", "risus", "pretium", "quam", "vulputate", "dignissim", "suspendisse", "in", "est", "ante", "in", "nibh", "mauris,", "cursus", "mattis", "molestie", "a,", "iaculis", "at", "erat",
        "pellentesque", "adipiscing", "commodo", "elit,", "at", "imperdiet", "dui", "accumsan", "sit", "amet", "nulla", "facilisi", "morbi", "tempus", "iaculis", "urna,", "id", "volutpat", "lacus", "laoreet", "non", "curabitur", "gravida", "arcu", "ac", "tortor", "dignissim", "convallis", "aenean", "et", "tortor", "at", "risus", "viverra", "adipiscing", "at", "in", "tellus", "integer", "feugiat", "scelerisque", "varius", "morbi", "enim", "nunc,", "faucibus", "a", "pellentesque", "sit", "amet,", "porttitor", "eget", "dolor", "morbi", "non", "arcu", "risus,", "quis", "varius", "quam", "quisque", "id", "diam", "vel", "quam", "elementum", "pulvinar", "etiam", "non", "quam", "lacus", "suspendisse", "faucibus", "interdum", "posuere", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "duis", "tristique", "sollicitudin", "nibh", "sit", "amet", "commodo", "nulla", "facilisi",
        "nullam", "vehicula", "ipsum", "a", "arcu", "cursus", "vitae", "congue", "mauris", "rhoncus", "aenean", "vel", "elit", "scelerisque", "mauris", "pellentesque", "pulvinar", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "maecenas", "pharetra", "convallis", "posuere", "morbi", "leo", "urna,", "molestie", "at", "elementum", "eu,", "facilisis", "sed", "odio", "morbi", "quis", "commodo", "odio", "aenean", "sed", "adipiscing", "diam", "donec", "adipiscing", "tristique", "risus", "nec", "feugiat", "in", "fermentum", "posuere", "urna", "nec", "tincidunt", "praesent", "semper", "feugiat", "nibh", "sed", "pulvinar", "proin", "gravida", "hendrerit", "lectus", "a", "molestie"
    ];
        
    var  dataPlugin = 'plugin_' + Name,

            // default options, used for instantion, if not explicitly set
            defaults = {
			url         : '',
            ajaxData    : {},
            debug        : {
                log: false,
                latency: 0
            },
            maskText: false,
            skelParentText: false,
            removeIframe: false,
            backgroundImage: true,
            replaceImageWith: '',
            selector: '',
            incache : false,
            onComplete     : function() {
                _logger('default onComplete() event');
            }
		};


    /**
     *  jQuery screen skeleton - scheletrone
     *
     *  @alias scheletrone
     *  @constructor
     *
     *  @author   Vincenzo Bifano
     *
     *  @requires jquery.js
     *
     *  @param   {Object}        [options]                 - a set of options, to override the defaults
     *  @param   {Function}      [options.onComplete]      - the event is triggered after plugin is complete
     *
     *  @example 
     // minimal setup
        var instance = $('#element').square();

     // customized setup
        var instance = $('#skeleton').skeleton({
                url   : "index2.html",
                debug		: {
                    latency: 3000
                },
                incache: false,
                onComplete	: function() { _logger('plugin complete!'); }
           });

     */



    var Scheletrone  = function(element, options) {
        
        IdElement = $(element).attr('id');

        // This is the plugin's constructor
        // It is instantiated for each matched DOM element
        // The huge comment block above is JSDoc syntax, for generated documentation
        // The name of the constructor is used ONLY internally
        // As a general best-practise, constructors should be Capitalized

        // store the element element
        this.element = $(element);

        // override default options
        // create a new object, with all default settings, overridden only by the init options
        this.options = $.extend( {}, defaults, options );
        debugLog = this.options.debug.log;

        //element to skeletrize
        this.element    = element;
	    this.$container = $( element );


        //this.init();
        this.init();



    };
    /////////////////////////////////////
    //         Private methods         //
    /////////////////////////////////////
    /**
     *  Make the skeleton of a passed element 
     *
     *  @param   {Object}  objToSkeletrize  the element
     */
    var _makeitSkeleton = function (objToSkeletrize) {

                objToSkeletrize.addClass("pending_el ");

    }
    /**
     *  Make a text log 
     *
     *  @param   {string}  message text to log
     */
    var _logger = function (message) {
             
             if (debugLog)
             {
               console.log(message);
             }
    }

    var _replaceBackgroundImage = function (replaceImageWith,element)
    {
        _logger("*** _replaceBackgroundImage ***");
        var bgimage_url = $( element ).css('background-image');
        
        // ^ Either "none" or url("...urlhere..")
        bgimage_url = /^url\((['"]?)(.*)\1\)$/.exec(bgimage_url);
        bgimage_url = bgimage_url ? bgimage_url[2] : ""; // If matched, retrieve url, otherwise ""
        
        var bg_url = $( element ).css('background');
      
        // ^ Either "none" or url("...urlhere..")
        bg_url = /^url\((['"]?)(.*)\1\)$/.exec(bg_url);
        bg_url = bg_url ? bg_url[2] : ""; // If matched, retrieve url, otherwise ""
            

        

  

        if ((bgimage_url != '') || (bg_url != '') ) {
          
            $( element ).replaceWith("<div class='pending_el "+replaceImageWith+"' style='width:"+$( element ).width()+"px;height:"+$( element ).height()+"px;'></div>")
        
        }
        _logger("*** End _replaceBackgroundImage ***");
    }

    var _getAllStyles = function (elem) {
        if (!elem) return []; // Element does not exist, empty list.
        var win = document.defaultView || window, style, styleNode = [];
        if (win.getComputedStyle) { /* Modern browsers */
            
            style = win.getComputedStyle(elem, '');
            for (var i=0; i<style.length; i++) {
                styleNode.push( style[i] + ':' + style.getPropertyValue(style[i]) );
                //               ^name ^           ^ value ^
            }
        } else if (elem.currentStyle) { /* IE */
            style = elem.currentStyle;
            for (var name in style) {
                styleNode.push( name + ':' + style[name] );
            }
        } else { /* Ancient browser..*/
            style = elem.style;
            for (var i=0; i<style.length; i++) {
                styleNode.push( style[i] + ':' + style[style[i]] );
            }
        }
        return styleNode;
    }



    /**
     *  Delete node without data attribute
     *
     *  @param   {Object}  objToSkeletrize  the element
     *  @return  {Object}
     */

    var _retrieveOnlyToCache = function(data)
    {
        _logger("_retrieveOnlyToCache");
        _logger(data);
        var div = document.createElement('div');
        div.innerHTML = data;
        $( div ).children().each(function( index ) {
             _logger('a');
             _logger($(this).data("scheletrone") );
            if ( $(this).data("scheletrone") ) 
            {

            }
            else
            {
                 $( this ).remove();
                //IE11 compatibility issue #2
                //A small Element.remove() polyfill for IE 
                //https://stackoverflow.com/questions/20428877/javascript-remove-doesnt-work-in-ie
                //
                if (!('remove' in Element.prototype)) {
                    Element.prototype['remove'] = function () {
                    if (this.parentNode) {
                        this.parentNode.removeChild(this);
                    }
                    };
                }
            }
         });
        
         _logger("*** Cache Data ***");
         _logger(div.innerHTML);
         return div.innerHTML;
    }

    /**
     *  For an integer randomly
     *
     *  @param   {integer}  min  minimum
     *  @param   {integer}  max  maximum
     *  @return  {integer}
     */
    var _randomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /**
     *  Count number of words in a text
     *
     *  @param   {string}  s  Text
     *  @return  {integer}
     */

    var _countWords =  function(s){
        s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
        s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
        s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
        return s.split(' ').length; 
    }


    /**
     *  Create text with Lore Ipsum words
     *
     *  @param   {integer}  count  number of words
     *  @param   {integer}  lenght  maximum lenght of the sentence
     *  @return  {string}
     */
    //text creator method with parameters: how many, what
    var _createText = function(count, length) {
        
          var wordIndex = _randomInt(0, Words.length - count - 1);
          var newWord = Words.slice(wordIndex, wordIndex + count).join(' ').replace(/[\.\,]/g,'');

         while (length - newWord.length > 0){
            newWord = _addWord(newWord  );
        }
        return newWord;
    
          
        
    }

    var _addWord = function(string) {
          
          var wordIndex = _randomInt(0, Words.length - 1);
          return string + " " +  Words[wordIndex];
    }



    ////////////////////////////////////
    //         Public methods         //
    ////////////////////////////////////
    Scheletrone.prototype = {

        /**
         *  Initializes the scheletrone.
         *  This is automatically called when the plugin is called.
         *
         *  @private
         */
        init: function () {
            var _this  = this.element;
            var __this = this;


            _logger(this);
            // iterate all children in element to make a skeleton
            
            if(this.options.removeIframe)
                jQuery('html').find('iframe').remove();


            if (this.options.incache)
            {
                _logger(this.getCache());
                 
                    this.element.innerHTML = this.getCache();
                   
            }

            

            $( _this ).find('*').each(function( index ) {
              
               

                $( this )
                .contents()
                    .filter(function() {
                        
                        return this.nodeType === 3;
                    })
                    .each(function(  ) {
                       if(typeof this.nodeValue != 'undefined'){ 
                        if(this.nodeValue.trim() != '')
                        {
                            _logger(this,"-- " + this.nodeValue.trim() + '--');

                            if (__this.options.maskText)
                            {
                                var numberOfWords = _countWords(this.nodeValue.trim());
                                var newText = _createText(numberOfWords,this.nodeValue.trim().length);
                                
                                this.nodeValue = newText;
                            }
                            if (__this.options.skelParentText)
                            {
                               var color = $( this ).parent().css( {"background-color" : "#ccc"} );
                             _logger(this,color);
                            }
                            return this
                        }
                       }
                        else
                        {
                            this.remove();
                              //IE11 compatibility issue #2
                            //A small Element.remove() polyfill for IE 
                            //https://stackoverflow.com/questions/20428877/javascript-remove-doesnt-work-in-ie
                            //
                            if (!('remove' in Element.prototype)) {
                                Element.prototype['remove'] = function () {
                                if (this.parentNode) {
                                    this.parentNode.removeChild(this);
                                }
                                };
                            }
                        }
                            
                    })
                    .wrap( "<div class='nodeType3' ></div>" )
                    .end()
                   
            });

             $( _this ).find('*').each(function( index ) {
                    var skeletizza = true;
                    //search for children
 
                    if (!__this.options.backgroundImage)
                         _replaceBackgroundImage(__this.options.replaceImageWith,this);

                    $( this ).css('color', '#ccc');

                    
                    
                    if($( this ).children().length == 0)
                    {
                                
                                if($( this ).is("BR"))
                                {
                                    skeletizza = false;
                                }

                                if($( this ).is("IMG"))
                                {
                                   
                                    var width = this.width;
                                    var height = this.height;
                                    var tempThis = this;
                                    var replaced = "<div class='pending_el " + __this.options.replaceImageWith + " ' style='width:"+width+"px;height:"+height+"px;)'></div>"
                                    $( this ).replaceWith(replaced);
                          
                                   
                                 
                                    skeletizza = false;
                                }

                                if (skeletizza)
                                {
                                    
                                    _makeitSkeleton($( this ));
                                
                                }
                    }
             });

            
            
     



            if (this.options.url != '')
            {
                _logger('prova');
                this.retrieveData();
            }
            // trigger onComplete callback
            if (this.options.onComplete && typeof(this.options.onComplete) == "function")
                this.options.onComplete();
        },
        retrieveData: function () {
        var obj = this;
 
       
                if (this.options.debug.latency > 0)
                {
                    
                setTimeout(function(){
                 
                            $.ajax({
                                url: obj.options.url,
                                dataType: "html",
                                data: obj.options.ajaxData,
                                success: function(data) {
                                    
                                    _logger(obj.options.debug.log,"obj.element " + obj.element);
                                   
                                      
                                        if (obj.options.selector != '')
                                        {
                                            var parsedResponse = $.parseHTML(data);
                                      
                                            var result = $(parsedResponse).filter(obj.options.selector);
                                            _logger("*** Selector *** ");
                                            _logger(obj.options.selector);
                                            _logger(result.html());
                                            _logger("*** End Selector *** ");
                                            $( obj.element ).html('').append((result));
                                        }
                                        else
                                        {
                                            $( obj.element ).html('').append((data));
                                        }



                                        if (obj.options.incache)
                                        {
                                            _logger(obj.options.debug.log,'setcache');
                                            var cacheData = _retrieveOnlyToCache(data);
                                            obj.setCache(cacheData);
                                        }
                                }
                            });
                    }, obj.options.debug.latency);
                }
                else{
                    
                    $.ajax({
                                url: obj.options.url,
                                dataType: "html",
                                data: obj.options.ajaxData,
                                success: function(data) {
                                    
                                    _logger(obj.options.debug.log,obj);
                                  
                                    if (obj.options.selector != '')
                                    {
                                        //Populate with only a specific content Issue #4
                                        var parsedResponse = $.parseHTML(data);
                                        var result = $(parsedResponse).filter(obj.options.selector);
                                        _logger("*** Selector *** ");
                                        _logger(obj.options.selector);
                                        _logger(result.html());
                                        _logger("*** End Selector *** ");
                                        $( obj.element ).html('').append((result));
                                    }
                                    else
                                    {
                                        $( obj.element ).html('').append((data));
                                    }


                                }
                            });
                }

        },
        /**
         *  Stop loading on div - pass it on construction
         *
         * @example this.stopLoader();
         */
        stopLoader: function () {
            var obj = this;
            $(obj.element).html('');
            
        },
        /**
         *  Store the asynchronus data in localstorage
         *
         *  @example this.setCache(data);
         */
        setCache : function ( result_data ) {
            // Cache data
           
            if ( window.localStorage ) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/')+1);


                window.localStorage.setItem( filename + "-" + "div-"+IdElement+"-skeleton:" ,  result_data  );
            }
        },
        /**
         *  Retrieve stored scheletrone in localstorage
         *
         *  @example this.getCache();
         */
        getCache : function() {

            if ( window.localStorage ) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/')+1);
                return window.localStorage.getItem( filename + "-" + "div-"+IdElement+"-skeleton:" );
            }
            else {
                return false;
            }
        },
        
    };



  
    







   //////////////////////////////////////////////////
    //         Plugin wrapper                       //
    //////////////////////////////////////////////////


    // A plugin wrapper around the constructor, preventing against multiple instantiations
    $.fn[Name] = function ( options ) {
        var instance;

        // If the first parameter is an object (options), or was omitted,
        // call Plugin.init()
        if ( typeof options === 'undefined' || typeof options === 'object' ) {
            return this.each(function () {
                // prevent multiple instantiations
                if ( !$.data(this, dataPlugin )) {
                    $.data(
                        this, 
                        dataPlugin, 
                        new Scheletrone( this, options )
                    );
                }

                instance = $(this).data( dataPlugin );

                if ( typeof instance['init'] === 'function' ) {
                    instance.init();
                }
            });

        // checks that the requested public method exists
        } else if ( typeof options === 'string' ) {
            var methodName = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                returnVal;

            this.each(function() {
                var instance = $(this).data( dataPlugin );

                // Check that the element has a plugin instance, and that
                // the requested public method exists.
                if ( $.data(this, dataPlugin) && typeof $.data(this, dataPlugin)[methodName] === 'function' ) {
                    // Call the method of the Plugin instance, and Pass it
                    // the supplied arguments.
                    returnVal = $.data(this, dataPlugin)[methodName].apply(instance, args);
                } else {
                    console.info('Method ' + options + ' does not exist on jQuery.' + Name);
                }
            });

            if ( typeof returnVal !== 'undefined' ){
                // If the method returned a value, return the value
                return returnVal;
            } else {
                // Otherwise, returning 'this' preserves chainability
                return this;
            }
        } else {
            console.info('Method ' + options + ' does not exist on jQuery.' + Name);
        }
    };
})( jQuery, window, document );
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});

var OPStoriesOwlData;

$(document).ready(function(){
    var op_stories_owl = $("#owl-op-stories");
    op_stories_owl.owlCarousel({
        items : 4, //4 items above 1000px browser width
        itemsDesktop : [1000,5], //5 items between 1000px and 901px
        itemsDesktopSmall : [900,3], // betweem 900px and 601px
        itemsTablet: [600,2], //2 items between 600 and 0
        itemsMobile : false, // itemsMobile disabled - inherit from itemsTablet option
        addClassActive: true,
        lazyLoad: true,
        //navigation: true,
        //navigationText : [$('.header__nav-menu__opstories__arrow.left'),$('.header__nav-menu__opstories__arrow.right')]
    });
    OPStoriesOwlData = $("#owl-op-stories").data('owlCarousel');

    $(".header__nav-menu__opstories__arrow.left").click(function() {
        op_stories_owl.trigger('owl.next');

        if ($('#owl-op-stories .owl-item').first().hasClass('active')) {
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", true);
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);
        } else {
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", false);
        }
    });
    $(".header__nav-menu__opstories__arrow.right").click(function() {
        op_stories_owl.trigger('owl.prev');

        if ($('#owl-op-stories .owl-item').last().hasClass('active')) {
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", true);
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", false);
        } else {
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);
        }
    });
     
});


function destroyCarousel() {
    OPStoriesOwlData.destroyControls();
}

function buildCarousel() {
    OPStoriesOwlData.buildControls();
}

function goToCarouselCard(cardNumber) {
    OPStoriesOwlData.goTo(cardNumber);
}


var badgeVisible = true;

if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(target, firstSource) {
        'use strict';
        if (target === undefined || target === null) {
          throw new TypeError('Cannot convert first argument to object');
        }

        var to = Object(target);
        for (var i = 1; i < arguments.length; i++) {
          var nextSource = arguments[i];
          if (nextSource === undefined || nextSource === null) {
            continue;
          }
          nextSource = Object(nextSource);

          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
        return to;
      }
    });
  }

// Global variables
var defaultSearchProfile = getUrlParameter('searchTerm') ? 'LUX_findProductsBySearchTerm' : 'LUX_findProductsByCategory_group';
var countSelectedFacets = 0, defaultOrderBy, selectedFacetsData = {}, selectedFacets = {}, originalHrefApply = '', previousFilter = {}, originalSelectedSort = "";
var tileIndex = 0;
var indexSearchPanel = 0;

//Filter & OrderBy variables
var queryFilters = [],
    queryOrderBy = [],
    emptyFilters = true,
    emptyOrderBy = true,
    numMaxofPages,
    index,
    isFacetApplied = false;

queryParams = {
    storeId: WCParamJS.storeId,
    catalogId: WCParamJS.catalogId,
    responseFormat: 'json',
    langId: WCParamJS.langId,
    currency: WCParamJS.commandContextCurrency,
    profileName: defaultSearchProfile,
    searchSource: 'E',
    isForPLP: true
};

var featuredProductHtml = "";

/* BEGIN - Workarounds for IE */
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position)
          || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}
(function() {
	  function remove() { this.parentNode && this.parentNode.removeChild(this); }
	  if (!Element.prototype.remove) Element.prototype.remove = remove;
	  if (Text && !Text.prototype.remove) Text.prototype.remove = remove;
	})();
/* END - Workarounds for IE */
columnsToShow = 4
//	Skeleton Loader variables
var $plpSearchObj = {};
$plpSearchObj.itemsPerPage = 0;		// infinite scroll page(group) size
$plpSearchObj.itemsFromServer = 0;	// how many to get from API
$plpSearchObj.viewIndex = 0;		// index of items to show in view
$plpSearchObj.lastIndex = 0;
$plpSearchObj.resultCount = 0;
$plpSearchObj.viewMoreClicked = false;
$plpSearchObj.viewMoreSearchCount = 0;
$plpSearchObj.viewMoreSearchStartIndex = 0;
$plpSearchObj.productsServiceUrl = function(searchedWord) {
	if(storeDirectory === 'PersolGR' && host !== 'localhost'){
        WCParamJS.homePageURL = "https://"+ host + "/greece";
    }
	var baseSearchURL = (isInToolkit ? '' : WCParamJS.homePageURL)+'/search/resources/store/'+WCParamJS.storeId+'/productview/';
	var searchTerm = getUrlParameter('searchTerm');
    /* START Early Access */
    if (isPersol) {
        if (window.customerSegment != undefined && window.customerSegment != ""){
            queryParams.customerSegment = window.customerSegment;
        }
    }
    /* END Early Access */
	if (searchTerm || searchedWord) {
		return baseSearchURL+'bySearchTerm/' + (searchedWord ? searchedWord : searchTerm); // Search Obtimization
	}
	return baseSearchURL+'byCategory/'+ document.querySelector('meta[name="pageId"]').getAttribute('content');
}
$plpSearchObj.lastIndexbkp = 0;

function fn_plpFirstTiles(productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch) {
	// # Load Espot contents (TOP e MIDDLE creati durante il render delle tile)
	if (typeof isWishlist == "undefined"){
        var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
    }

    if (!isWishlist){
        selectedFacetsData = {
            storeId : WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            fromPage: 'catalogEntryList',
            beginIndex: '0',
            responseFormat: 'json',
            orderBy: defaultOrderBy,
            categoryId: ""
        };
    } else {
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObjCount = Object.keys(JSON.parse(sessionStorage.wishlistObj)).length;
            var countString = "(" + wishlistObjCount + ")";
            $(".title-wishlist_count").html(countString);
            if (wishlistObjCount == 0){
                $("#box.wishlist").addClass("emptyWishlist");
                $("#empty-wishlist-container").removeClass("hidden");
                if (isOliver && $("#wishlistAppointmentEspot").length > 0) $("#wishlistAppointmentEspot").remove();
            } else {
                $("#box.wishlist").removeClass("emptyWishlist");
                $("#empty-wishlist-container").addClass("hidden");
            }
        }
    }

 
	$plpSearchObj.itemsPerPage = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 && sessionStorage.backItemsPerPage) ? parseInt(sessionStorage.backItemsPerPage) : columnsToShow*parseInt($("#rowsPerPage").val());			// infinite scroll page(group) size
	$plpSearchObj.itemsFromServer = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 & sessionStorage.itemsToLoad) ? parseInt(sessionStorage.itemsToLoad) : parseInt($("#itemsFromServer").val());					// how many to get from API
	//facet search page e plp credo
    
    if(document.querySelector('.plp') || document.querySelector('.search') || document.querySelector('.searchPanel') ) {
        // Get facets to show in filter by if it's not the Persol search
        /**
        // facets are excluded by search in Persol 
        if (!isWishlist){
            if (isOliver || isPersol) {
                $plpSearchObj.facetsForFilterBy = {};
                if ($('input#facetsForFilterBy').length){
                var facetsForFilterByArr = $('input#facetsForFilterBy').val().split(';');
                    for (var i=0;i<facetsForFilterByArr.length; i++) {
                        var facetArr = facetsForFilterByArr[i].split(':');
                        if (facetArr.length == 2) {
                            $plpSearchObj.facetsForFilterBy[facetArr[0]] = facetArr[1];
                            //queryParams['f.'+facetArr[1].substring(0,facetArr[1].indexOf('%3A'))+'.facet.mincount'] = 0;
                        }
                    }
                // Get facets to be ignored
                $plpSearchObj.facetsToBeIgnored = $('input#facetsToBeIgnored').val().split(';');
                }
            }
        }
        */

        setDefaultSortBy(defaultOrderBy, false, productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch);
        var pageElem = document.getElementById('page');
        var blockFilter = document.querySelector('.block-filter');
        var originalFilterParentElem = "";
        var facetButtonElem = document.querySelector('.plp-filter-button');

        //Different views buttons - By default, on mobile show 2 columns view; on desktop show 3 columns view
        if(!searchedWord){
            if (window.tabletPortraitCheck() || window.mobilecheck()){
                if (!isWishlist) {
                    $('.button-views.two-col-icon').addClass("active");
                    $('.grid_mode').addClass('grid_mode-two-cols');
                }
            }

            // ex --Apply facets when you click the apply button
            

            if(document.querySelector('.search-page')) {
                originalFilterParentElem = document.querySelector('#content > .search-page');
            } else {
                originalFilterParentElem = document.querySelector('#content > .plp');
            }

            if (document.querySelector(".facet__apply")) {
                originalHrefApply = document.querySelector(".facet__apply").getAttribute('data-href');
            }

            //show description before offset calculation: description can born displayed?
            if (isOliver){
                $('.description.descriptionDefault').css('display','flex');
                if (window.tabletPortraitCheck() || window.mobilecheck()) {
                    var espotHeight= $( "#contentRecommendationWidget_X_PLP_HeroBanner_X_PLP_HeroBanner").height();
                    //var textHeight =$(".descriptionDefault").height();
                    //var marginButtons= espotHeight - textHeight
                    //$('.plp-filter-view-button').css("margin-top","-"+$('.grid.product-list').css('margin-top'));
                }
            }

            // Change DOM facet button position to make it FIXED
                if (!isWishlist){
                    var class_startscroll = ".plp-filter-button_wrapper";
                    if (isPersol && document.querySelector('.search')) {
                        class_startscroll = ".searchSummaryWidget";
                    }
                    
                    var offset = $(class_startscroll).offset().top;
                    var totalOffset = offset;
                    if(window.mobilecheck() || window.tabletPortraitCheck()) {
                        totalOffset = offset + $(class_startscroll + ' .espot-plp-beans').outerHeight() + 56;
                    }
                } else {
                    if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex) {                    
                        //clean up the grid
                        $('.plp-grid-skeleton').remove();
                    }

                    //Remove extra empty <li> tags in wishlist page
                    if (isWishlist) {
                        if (typeof sessionStorage.wishlistObj != "undefined"){
                            var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                            var productsLength = Object.keys(wishlistProducts).length;

                            if (productsLength == 0){
                                if ($("#wishlist_grid li").length > 0) {
                                    $("#wishlist_grid li").remove();
                                }
                            } else {
                                for (var i=0 ;i<productsLength; i++){
                                    var wishlistLi = $("#wishlist_grid li")[i];
                                    if ($(wishlistLi).html() == ""){
                                        $(wishlistLi).remove();
                                    }
                                }
                            }
                        }
                    }
                }
                window.addEventListener('scroll', function() {
                    if (!isWishlist){
                    /** Sticky submenu in plp */
                        if (isPersol) {
                            if(window.mobilecheck() || window.tabletPortraitCheck()) {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() + $('#ci_espot__X_Header_GlobalBanner').height();
                                } else {
                                    var checkPersol = $(this).scrollTop() +1;
                                }
                            } else {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height() + $('#ci_espot__X_Header_GlobalBanner').height();
                                }
                                else {
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height();
                                }
                            }

                            var getBannerTopHeight = function () {
                                if($('#bannerTop').length && $('#bannerTop').is(":visible")) {
                                    return $('#bannerTop').height();
                                } else {
                                    return 0;
                                }
                            }

                            var offset2 = 0;
                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                offset2 = $(class_startscroll + " .espot-plp-beans").outerHeight() + 10;
                            }

                            if(checkPersol >= (offset + offset2)){
                                if(window.innerWidth >= 1024 && window.innerWidth < 1300 && window.matchMedia("(orientation: landscape)").matches){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else {
                                    $(class_startscroll).css('top', $('#header').height() + getBannerTopHeight()-1);
                                }

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).addClass('plp-filter-button_wrapper--sticky');
                                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", $(".plp-filter-button_wrapper").outerHeight() );
                                        $('.plp-wrapper-title').show();
                                        $('.plp-filter-button_wrapper--sticky').css("top",$('.ct-promo-banner').height());
                                    }else {
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", "168.8px" );
                                        var stripHeight = $('.ct-promo-banner').height();
                                        var headerHeight = $('#header').outerHeight();
                                        $('.plp-filter-button_wrapper--sticky').css("top",parseInt(stripHeight)+parseInt(headerHeight));
                                    }
                                }
                            }else{
                                $(class_startscroll).css('top', 'auto');

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).removeClass('plp-filter-button_wrapper--sticky');
                                    $('.plp-wrapper-title').hide();
                                    $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", 0 );
                                }
                            }
                        }
                    }
                    
                    var documentBottom = $(window).scrollTop()+$(window).outerHeight();
                    
                    if($(".plp-grid-skeleton").length > 0) {
                        var skeletonTop =  $(".plp-grid-skeleton").offset().top;
                        //retiver info origina plp 
                        
                        
                        if (skeletonTop <= documentBottom
                                && $plpSearchObj.viewIndex < $plpSearchObj.lastIndex
                                && !$plpSearchObj.busy) {
                            $plpSearchObj.viewMoreTiles($plpSearchObj.itemsPerPage);
                        }

                        if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex && $plpSearchObj.viewIndex!=0) {                    
                            //clean up the grid
                            $('.plp-grid-skeleton').remove();

                            //Remove extra empty <li> tags in wishlist page
                            if (isWishlist) {
                                if (typeof sessionStorage.wishlistObj != "undefined"){
                                    var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                                    var productsLength = Object.keys(wishlistProducts).length;

                                    if (productsLength == 0){
                                        if ($("#wishlist_grid li").length > 0) {
                                            $("#wishlist_grid li").remove();
                                        }
                                    } else {
                                        for (var i=0 ;i<productsLength; i++){
                                            var wishlistLi = $("#wishlist_grid li")[i];
                                            if ($(wishlistLi).html() == ""){
                                                $(wishlistLi).remove();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });

                //  Begin Change DOM filter position to make it FIXED
                if (!isWishlist){
                    if (isOliver){
                        document.querySelector('body').appendChild(blockFilter);
                    }
                }

                window.addEventListener('resize', function() {
                    if(!isWishlist){
                        if(window.innerWidth >= 1024 && blockFilter.parentNode !== originalFilterParentElem) {
                            facetButtonElem.classList.remove('scroll');
                        }
                        else if (window.innerWidth < 1024 && blockFilter.parentNode !== pageElem) {
                            document.querySelector('body').appendChild(blockFilter);
                        }
                    }
                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                        if(isOliver) {
                            if (isWishlist){
                                $('#wishlist_grid .grid-item:not(.product-espot)').outerHeight("100%");
                            } else {
                                $('.grid-item:not(.product-espot)').outerHeight("100%");
                            }
                        } else if(isPersol) {
                            if(isWishlist){
                                $('.grid-item:not(.product-espot):not(.grid-item-search)').outerHeight("100%");

                            }else{
                                $('.grid-item:not(.product-espot)').height("100%");
                            }
                            
                        }
                    }
                    if(!isWishlist){
                        if(blockFilter.classList.contains('opend') && window.innerWidth >= 1024) {
                            document.querySelector('html').removeAttribute("style");
                            document.querySelector('body').removeAttribute("style");
                        } else if(blockFilter.classList.contains('opend') && window.innerWidth < 1024) {
                            document.querySelector('html').setAttribute("style", "overflow: hidden;");
                            document.querySelector('body').setAttribute("style", "position: static; overflow: hidden");
                        }
                    }
                }, true);
                //  End Change DOM filter position

                //Add classes to Persol if on mobile
                if (isPersol) {
                    if (window.tabletPortraitCheck() || window.mobilecheck()){
                        $('.sale_badge').addClass('submenu__subheader');
                        $('.sale_badge').addClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
                    } else {
                        $('.sale_badge').removeClass('submenu__subheader');
                        $('.sale_badge').removeClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
                    }
                }

                // deleted function --- see //START FILTER SECTION in non critical js 

        
          
        }
    }

        initButtonViewOnClick();

		



    // # X_PLP_SalesBeans
    if ($('#ci_espot__X_PLP_SalesBeans').length > 0) {

    	// Change event for select
    	$('select.select-bean').change(function(e) {
        	document.location.href = $(e.target).val();
        });

    	// Active/Select current dash button page
		var urlPage= window.location.href;
	    var splitUrl = urlPage.split("/");
	    var salesCategory = splitUrl[splitUrl.length - 1];
	    $('.nav-beans #' + decodeURI(salesCategory.split('?')[0])).addClass("active");
	    $("select option[value='"+salesCategory.split('?')[0]+"']").prop("selected",true);
	}
}

function initButtonViewOnClick(){
    // Change view when clicking on different buttons
    $('.button-views.one-col-icon').click(function() {
        columnsToShow = 1;
        $('.button-views').removeClass("active");
        $('.button-views.one-col-icon').addClass("active");
        $('.grid_mode').addClass('grid_mode-one-col');
        $('.grid_mode').removeClass('grid_mode-two-cols');
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").addClass("-one-col");
    });

    $('.button-views.two-col-icon').click(function() {
        columnsToShow = 2;
        $('.button-views').removeClass("active");
        $('.button-views.two-col-icon').addClass("active");
        $('#plp_grid.grid_mode').addClass('grid_mode-two-cols');
        $('#plp_grid.grid_mode').removeClass('grid_mode-one-col');
        $('#plp_grid.grid-item').removeAttr('style')
        $('.product--wrapper__container').removeAttr('style')
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").removeClass("-one-col");
    });
}

/**
 * @function setDefaultSortBy
 * @desc This function select the default sort by inside facet section
 *
 * @param {*} num
 */
function setDefaultSortBy(num, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    var sortElems = document.querySelectorAll('.facet__sortBy .facet__filter-button');
    for(var sortElem = 0; sortElem < sortElems.length; sortElem++) {
        if(sortElems[sortElem].getAttribute('data-facet') == num){
            sortElems[sortElem].parentElement.classList.add('selected');
            break;
        }
    }
    originalSelectedSort = document.querySelector('#facet__sortBy .facet__filter-noimg.selected');
    ajaxCallFacet(callbackSortBy, null, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch);
}

function ajaxCallFacet(callback, elem, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    
    if(typeof firstSearch != undefined){
        $plpSearchObj.firstSearch = firstSearch;
    }else{
        $plpSearchObj.firstSearch = undefined;
    }
    $plpSearchObj.viewIndex = 0;
    $plpSearchObj.lastIndex = 0;
    $plpSearchObj.resultCount = 0;
    $plpSearchObj.getData(isViewMore, function() {
        $plpSearchObj.attrValIdentifierObject = [];//object use to retrive indetifier value of attribute value
    	$plpSearchObj.busy = false;
    	createNewTileProducts(0,$plpSearchObj.itemsPerPage,searchedWord,isWishlist,false,wishlistToDeleteData);
        $plpSearchObj.itemsPerPage = columnsToShow*parseInt($("#rowsPerPage").val());
        $plpSearchObj.itemsFromServer = parseInt($("#itemsFromServer").val());
    	callback(elem);
    }, productData,searchedWord, isWishlist);
    if (typeof productData === 'undefined') {
        $plpSearchObj.busy = true;
    }
}

//function to load plp data 
$plpSearchObj.getData = function(isViewMore,callback,productData,searchedWord,isWishlist) {
	if (!isViewMore) {
		$plpSearchObj.items = {};
		$plpSearchObj.currentPage = 1;
		$plpSearchObj.viewIndex = 0;
		$plpSearchObj.lastIndex = 0;
        
        /*if (document.querySelector('.search')) {
            $("span[id^=searchTotalCount]").html($("span[id^=searchTotalCount]").html().replace(/\d/g, ''));
        }*/
		window.scrollTo(0,0);
	} else {
        $plpSearchObj.viewMoreClicked = true;
		$plpSearchObj.currentPage = Math.floor(($plpSearchObj.lastIndex||0)/$plpSearchObj.itemsFromServer)+1;
        
        var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
        
        for(var i = 0; i  < $plpSearchObj.itemsFromServer; i++) {
            var createDOMLi = document.createElement('li');
            if(isOliver) createDOMLi.classList.add('product');
            createDOMLi.classList.add('plp-grid-skeleton');
            ulGrid.appendChild(createDOMLi);
        }
        // 	$('.product--wrapper').height($('.product').width());
        // }
    } 
	
    if (isPersol) {
    	$('.skeleton .product--wrapper').height($('.skeleton .product-container').width() * (400/360));
    }

    $plpSearchObj.queryParams = queryParams;
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['categoryId'] = '';
    }else{
        $plpSearchObj.queryParams['categoryId'] = document.querySelector('meta[name="pageId"]').getAttribute('content');
    }
	if (selectedFacetsData["orderBy"]) {
		$plpSearchObj.queryParams['orderBy'] = selectedFacetsData["orderBy"];
	    if (isPriceOrdering()) {
	    	queryParams['profileName'] = 'LUX_findProductsByCategory';
	    } else if (isNewArrivalsOrdering() && getUrlParameter('searchTerm') == null) {
	    	queryParams['profileName'] = defaultSearchProfile+'_new_first';
	    } else {
	    	queryParams['profileName'] = defaultSearchProfile;
	    }
	} else {
		delete $plpSearchObj.queryParams['orderBy'];
    	queryParams['profileName'] = defaultSearchProfile;
	}
	if (!categoryToGroupTile()) {
		queryParams['profileName'] = 'LUX_findProductsByCategory';
	}
	$plpSearchObj.queryParams['pageNumber'] = $plpSearchObj.currentPage;
	$plpSearchObj.queryParams['pageSize'] = $plpSearchObj.itemsFromServer;
    var facetArr = [];
    var queryString = window.location.search.substr(1);
    if (queryString.trim() != "") {
        var parameters = queryString.split('&');
        $.each(parameters, function(i,el){
       	 	var facetKey = el.split('=')[0];
       	 	if (facetKey.startsWith('facet')) {
       	 		var facetValue = el.split('=')[1];
       	 		facetArr.push(facetValue);
       	 	}
        });
    }
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['facet'] = [];
    }else{
        $plpSearchObj.queryParams['facet'] = facetArr;
    }
    

    var ajaxPLPSuccess = function(data) {
    	
    	   if(location.href.includes("facet") && !$plpSearchObj.viewMoreClicked){
           	tileIndex = 0;
           }

        $plpSearchObj.resultCount = !isWishlist ? data.recordSetTotal : Object.keys(data).length;
        var dataRecordCount = !isWishlist ? data.recordSetCount : Object.keys(data).length;
        if (dataRecordCount === 0) {
        	var dataSpellCheck = '';
        	if ($('.suggestions_container .suggestion').length > 0){
        		dataSpellCheck = $('.suggestions_container .suggestion')[0].text;
        	} else if (data.metaData){
        		dataSpellCheck = data.metaData.spellcheck[0];
        	}
        	if (dataSpellCheck){
        		$.ajax({
                    url: $plpSearchObj.productsServiceUrl(dataSpellCheck),
                    type: 'GET',
                    async: true,
                    data: $.param($plpSearchObj.queryParams,true),
                    success: ajaxPLPSuccess,
                    error: function(error) {
                    	return error;
                    }
                });
        	} else {
                if(searchedWord && typeof $plpSearchObj.firstSearch == undefined){//no result in search panel 
                    searchError(true);
                    resetSearchTile(true);//resetFeature
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(searchedWord && $plpSearchObj.firstSearch ){//no result in search panel firstsearch
                    searchError(true);
                    resetSearchTile(true);
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(isWishlist){
                    $("#wishlist_grid li .grid-item").remove(); //wishlist is empty
                }else {
                    //	Hide View More button
                    //populateUtagDataAfterAjax();
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                    if (isOliver && getUrlParameter('searchTerm') === null){
                        $('#noProducts').css('display','block');
                        //add default empty element in plp_grid for wcag
                        var createDOMProduct = document.createElement('li');
                        createDOMProduct.classList.add('grid-item');
                        createDOMProduct.setAttribute('id','dummyElement');
                        ulGrid.appendChild(createDOMProduct);
                    }

                }
                
            }
        }
        
        else if (dataRecordCount > 0) {
        	if(($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm' && $('.suggestions_container .suggestion').length > 0 && $('.suggestions_container .suggestion')[0].text.toLowerCase() != (data.catalogEntryView[0].name).toLowerCase())){
        		for (var i = 0; i < dataRecordCount; i++) {
        			if($('.suggestions_container .suggestion')[0].text.toLowerCase() == (data.catalogEntryView[i].name).toLowerCase()){
        				var shortDescription = (data.catalogEntryView[i].shortDescription);
        				$.ajax({
                            url: $plpSearchObj.productsServiceUrl(shortDescription),
                            type: 'GET',
                            async: true,
                            data: $.param($plpSearchObj.queryParams,true),
                            success: ajaxPLPSuccess,
                            error: function(error) {
                            	return error;
                            }
                        });
        				break;
        			}
        		}
        	}
            var results = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord ? data.catalogEntryView : (isWishlist ? data : data.catalogEntryGroupView); 
             // Display message when no products are shown
            $('#noProducts').css('display','none');
            //delete dummyElement in plp_grid for WCAG
            $('#dummyElement').remove();
            if(searchedWord){
                searchError(false);
                $(".title_result").hide();
                $(".redirect_result_container").css("display","flex");
                $(".redirect_result_container .redirect_result_link").show()
                $(".redirect_result_link #serched_word").html($('input:text[name=searchInput]').val());
                
            }
            /* populate items */
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord) {
                $.each(results, function(key,value) {
                    $plpSearchObj.items[(parseInt(key)+($plpSearchObj.itemsFromServer*($plpSearchObj.currentPage-1)))] = value;
                    
                });
                if(!searchedWord){
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            } else {
                //  START - Email me sorting by inventory
                function fn_sortByInventory(p) {
                    var r = 0;
                    if (p['inventory']
                            && p['inventory']['ranking']
                            && p['inventory']['flComingSoon']) {
                        r = p['inventory']['ranking'] + (p['inventory']['flComingSoon'] == 'true' ? 0.5 : 0);
                    }
                    return r; 
                }
                if (!isWishlist){
                    $.each(results,function(group,products) {
                        products.sort(function(a, b){
                            var sortedResults = fn_sortByInventory(b) - fn_sortByInventory(a);
                            return sortedResults;
                        });
                    });
                }
                //  END - Email me sorting by inventory
                Object.assign($plpSearchObj.items,results);
                if(!searchedWord){
                    //search Optimization save PLP items info 
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            }

            //  LCP
            /*
            let count = 0;
            $.each($plpSearchObj.items,function (key,value) {
                if (count == 0
                        && value[0] != undefined) {
                    var lcp = new Image();
                    if (isOliver){
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else if (isPersol) {
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail,'sclw=0.25&sclh=0.25','small');
                    }
                    return false;
                }
            });
            */

            /*populate tealiumProducts HB-5614*/
            var status = 'undefined';
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) {
                if(typeof tealiumProducts === 'undefined'){
                     tealiumProducts = {};
                }
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        var category = "";
                        if(pageType=='Wishlist'){
                        	category = getAttributeValue(value.attributes,"PRODUCTTYPE");
                        	category = category.toLowerCase();
                        	
                        	if(category.includes("sun")){
                        		category = "SUN";
                        	}
                        	if(category.includes("optical")){
                        		category = "OPTICS";
                        	}
                        	
                        	if(category.includes("accessories")){
                        		category = "ACCESSORIES"; 
                        	}
                        }else{
                        	category = getCategoryName(key ,"_")
                        }
                        
                        tealiumProduct['Category'] = category; 
                        tealiumProduct['Price'] = parseFloat(value['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value.inventory);
                        $(addProductsToTealium(value.partNumber,tealiumProduct)); // fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(e);
                    }
                });
            }
            else {
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        tealiumProduct['Category'] = getCategoryName(key ,"_");
                        tealiumProduct['Price'] = parseFloat(value[0]['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value[0]['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value[0].inventory);
                        $(addProductsToTealium(value[0].partNumber,tealiumProduct));// fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(value[0]);
                    }
                });
            }
            
            
            if(pageType=='Search'){
               var obj = {};
               obj['Search_Keyword'] = getUrlParameter('searchTerm');
               obj['Search_ResultItemsQnt'] = $plpSearchObj.resultCount;
               obj['Search_View'] = 'SERP';
               obj['Event_Source'] = 'SERP'
               pushDataToTealium(obj)
            } 
            
            if (typeof monetateQ !== 'undefined'){
                  monetateTrackPlp();
            }

            /*END 5614*/
    
            if(!searchedWord){
                if($plpSearchObj.lastIndexbkp > 0 && !$plpSearchObj.isFilterPanel){ // search Optimization  if is after search and not use filter
                    $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp
                    $plpSearchObj.lastIndex += Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex;
                }else{
                    //if apply filter 
                    $plpSearchObj.lastIndex = Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex
                    $plpSearchObj.isFilterPanel = false;
                }
 
                
            }
            
            $plpSearchObj.loading = false;
            if (typeof callback == 'function') {
            	if($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm'){
            		resetSearchTile(false,false,false);
            	}
            	callback();
            }

            /* facets are included only in PLP */
            if (!isWishlist){
                if(!searchedWord){
                    closeFilterMenu();
                    isFacetApplied = true;
                    originalSelectedSort = $('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en");
                    if(countSelectedFacets == 0) {
                        $(".facet__apply").removeClass('show');
                        document.querySelector('.facet__widget').classList.remove('active');
                        isFacetApplied = false;
                    }
                }
            }

            //	View More button
            if (!isWishlist){
                if ($plpSearchObj.resultCount-$plpSearchObj.lastIndex <= 0) {
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                } else {
                    $('.plp__view-more.button.secondary').show();
                }
            }

            if (!isViewMore) {
                /* facets are excluded by search in Persol */
                if (!searchedWord) { // SearchOptimiztion ! (isPersol && getUrlParameter('searchTerm'))
                    //	Inner function used to handle filters drawing and toggle
                    if (!isWishlist){

                        var filtersHandling = function(dataPartial,dataAll) {
                        // $plpSearchObj.attrValIdentifierObject =  createAttrValIdentifierObject(dataAll.catalogEntryGroupView);
                            drawFilters(dataAll.facetView,facetArr,parameters,$('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en"));
                            $('.facet__apply-number').text($plpSearchObj.resultCount);
                            $('.numframe').html($plpSearchObj.resultCount + ' ' + $('#frameTranslate').val());
                            $("#productsFacets li.facet__list-item li").each(function(i,e) {
                                toggleFilter(e,dataPartial);
                            });
                        };
                        //	If there are no GET parameters, then use the normal flow
                        if (facetArr.length == 0) {
                            filtersHandling(data,data);
                        } else {
                            new Promise((resolve, reject) => {
                                // else do an AJAX call to get the full facets list
                                var queryParamsAllFilters = $.extend({},$plpSearchObj.queryParams);
                                queryParamsAllFilters['facet'] = [];
                                delete queryParamsAllFilters['isForPLP'];
                                queryParamsAllFilters['isForPLPFilters'] = true;
                                $.ajax({
                                    url: $plpSearchObj.productsServiceUrl(),
                                    type: 'GET',
                                    async: true,
                                    data: $.param(queryParamsAllFilters,true),
                                    success: function(dataAll) {
                                        filtersHandling(data,dataAll);
                                        resolve(dataAll);
                                    },
                                    error: function(error) {
                                        reject(all);
                                        return error;
                                    },
                                    beforeSend: function(jqXHR, settings) {
                                        //  Security check, if true then stop the request and show 0 results
                                        if (settings.url.indexOf('TopCategoriesDisplay') > -1) {
                                            return false;
                                        }
                                    }
                                });
                            });
                        }
                    }
                }

                if (!isWishlist){
                    if(!searchedWord){
                        if(originalSelectedSort != undefined){
                            if(!(isPersol && getUrlParameter('searchTerm')) && facetArr.length == 0 && originalSelectedSort.innerText!==''){
                                setUTagData(parameters,originalSelectedSort);
                            }
                        }
                    }
                }

                if (document.querySelector('.search') ) {
                    $("span[id^=searchTotalCount] #totalCount").html("("+ $plpSearchObj.resultCount + ") " );
                }
            }
        }

        // Remove top and middle espot skeleton
        $('#plp_top_espot_skeleton').remove();
        $('#plp_middle_espot_skeleton').remove();

        //  CLS
        $('.plp-hide').show();
    };
    if (!isWishlist && typeof productData === 'undefined') {

        if(searchedWord || getUrlParameter('searchTerm') ){
            $plpSearchObj.queryParams.profileName = "LUX_findProductsBySearchTerm"
            if(isPersol){
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688668_3074457345616688669_3074457345616718183_3074457345616718182)'"; // catgoria LEnti + categorie servizi
            }else{
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688676_3074457345616714198_3074457345616714199_3074457345616688675)'"; // catgoria LEnti + categorie servizi
            }
             
            
        }else{
            $plpSearchObj.queryParams.profileName = $plpSearchObj.queryParams.profileName;
            delete $plpSearchObj.queryParams.filterQuery 
        }
        if(!isWishlist && !(searchedWord || getUrlParameter('searchTerm'))){}else{
        	$.ajax({
                url: $plpSearchObj.productsServiceUrl(searchedWord),
                type: 'GET',
                async: true,
                data: $.param($plpSearchObj.queryParams,true),
                success: ajaxPLPSuccess,
                error: function(error) {
                    return error;
                },
                beforeSend: function(jqXHR, settings) {
                    //  Security check, if true then stop the request and show 0 results
                    if (settings.url.indexOf('TopCategoriesDisplay') > -1) {

                        $plpSearchObj.resultCount = 0;

                        //	Hide View More button
                        $('.plp__view-more.button.secondary').attr('style','display:none !important');
                        if (isOliver && getUrlParameter('searchTerm') === null){
                            $('#noProducts').css('display','block');
                            //add default empty element in plp_gid for wcag
                            var createDOMProduct = document.createElement('li');
                            createDOMProduct.classList.add('grid-item');
                            createDOMProduct.setAttribute('id','dummyElement');
                            ulGrid.appendChild(createDOMProduct);
                            
                        }

                        return false;
                    }
                }
            });
        }
        
    } else {
        ajaxPLPSuccess(productData);
    }

};

/**
 * @funtion createNewTileProducts
 * @desc This function creates the new tile products with a template html
 */
function createNewTileProducts(startAt,count,searchedWord,isWishlist,isWishlistViewMoreTiles,wishlistToDeleteData,firstSearch) {
	// TEMPORARY FIX FOR HB-9977
	if(pageSection_1 == 'Accessories' && (window.tabletPortraitCheck() || window.mobilecheck())){
		count = 6;
	}
	$plpSearchObj.viewIndex = startAt+count;
    if(!searchedWord){
        //search Optimization -- save viewIndex 
        $plpSearchObj.viewIndexbkp = $plpSearchObj.viewIndex
    }
	//	Remove extra skeleton tiles
	var toShow = $plpSearchObj.lastIndex-$plpSearchObj.viewIndex;
	var toRemove = $plpSearchObj.itemsFromServer-toShow;
	
    var products = {}, i = 0;

    if (getUrlParameter('searchTerm') && $plpSearchObj.viewMoreClicked && !searchedWord) {
        var stopAt = $plpSearchObj.viewMoreSearchStartIndex+count;
        i = $plpSearchObj.viewMoreSearchStartIndex;
        if (toShow < 0) {
            // check for the end on products
            stopAt += toShow;
        }
        for (m in $plpSearchObj.items) {
            if (i>=$plpSearchObj.viewMoreSearchStartIndex && i < stopAt) {
                products[m] = $plpSearchObj.items[parseInt(m)+startAt];
            }
            i++;
        }
        $plpSearchObj.viewMoreSearchCount++;
        $plpSearchObj.viewMoreSearchStartIndex = count * $plpSearchObj.viewMoreSearchCount;
    } else {
        for (m in $plpSearchObj.items) {
            if (startAt<=i && i<startAt+count) {
                if(searchedWord){
                    if(isPersol && i <= 2){
                        products[m] = $plpSearchObj.items[m];
                    }else if(isOliver && i <= 1){
                        products[m] = $plpSearchObj.items[m];
                    }
                }else{
                    products[m] = $plpSearchObj.items[m];
                }
                
            }
            i++;
        }
    }

    // Show number of selected facets in the filter button
    if (countSelectedFacets >= 1) {
        $('.plp-filter-button').addClass('active');
    	$('.filter__button-number').text(countSelectedFacets);
    } else {
        $('.plp-filter-button').removeClass('active'); 
    }

    var tileCount = Object.keys($plpSearchObj.items).length;

    
    renderTileProducts(products, startAt, count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData);
}

/**
 * @funtion manageWishlistGuestEspot
 * @desc This function adds the sign in/register espot in the wishlist page as last tile of first grid row. This only happens when user is guest
 * */
function manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData) {
    var parentElement = ulGridChilds[0].parentNode;
    if (isPersol){
        if (productsLength > 0 && productsLength < 4) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(3).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[3]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    } else {
        if (productsLength > 0 && productsLength < 3) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(2).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[2]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    }
    if (typeof setWishlistEspotCtaClick == "function"){
        setWishlistEspotCtaClick();
    }
}

/**
 * @funtion renderTileProducts
 * @desc This function creates the new tile products with a template html
 * @param {products} products
 * @param {inventory} inventory
 */
function renderTileProducts(products,startAt,count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData) {

    var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
    var productArray = [];

  
    
    const ulGridChilds = searchedWord ? document.querySelectorAll('.search-grid-skeleton') : ((isWishlist && $('.plp-grid-skeleton').length == 0) ? document.querySelectorAll('#wishlist_grid li') : document.querySelectorAll('.plp-grid-skeleton')); //search optimization

    var productIndex = 0;
   
    var productsLength = Object.keys(products).length;

    for(var product in products) {

        if (typeof wishlistToDeleteData == "undefined" || !wishlistToDeleteData.isWishlistProductToDelete){
            var createDOMProduct = document.createElement('div');
            createDOMProduct.classList.add('grid-item');
            if(searchedWord){
                createDOMProduct.classList.add('grid-item-search');
                if(searchedWord == "X_Search_FeaturedProducts"){
                    $(".grid-item-search").parent().addClass("featured-products");
                }
            }

            var isLCPTile = startAt == 0 && productIndex == 0;
           

            if(searchedWord == "X_Search_FeaturedProducts"){
                var html = getSingleTileHtml(product, products[product].productModel, true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }else{
                var html = getSingleTileHtml(product, products[product], true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }
            
            
            $(createDOMProduct).html(html);
            ulGridChilds[productIndex].replaceChildren(createDOMProduct);
        }
        
        if (isWishlist){
            //If there is at least one product and user is guest, display sign in/register espot at last position of first grid row
            if (userType == "G" && productsLength > 0){
                if (!isWishlistViewMoreTiles || typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                    if (productIndex == productsLength - 1) {
                        if (typeof wishlistContentEspotHTML == 'undefined'){
                            returnEspotContent("X_Wishlist_Login");
                            var wishlistContentEspotHTML = $("#guestWishlistEspotContent").val();
                        }
                        if (typeof wishlistContentEspotHTML != "undefined" && wishlistContentEspotHTML != ""){
                            var espotLi = document.createElement('li');
                            espotLi.classList.add("wishlist-li");
                            var createDOMEspot = document.createElement('div');
                            createDOMEspot.classList.add('grid-item', 'wishlist-espot');
                            $(createDOMEspot).html(wishlistContentEspotHTML);
                            espotLi.appendChild(createDOMEspot);
                            if ($(".wishlist-espot").length == 0){
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            } else {
                                $(".wishlist-espot").parent().addClass("wishlist-li");
                                if ($(".wishlist-li").length > 0) {
                                    $(".wishlist-li").remove();
                                }
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            }
                        }
                    }
                }
            }


            if(typeof checkIsInWishlist === 'function'){ 
                if(checkIsInWishlist(product)){ // WISHLIST -- check if current product is in wishist
                    $("[data-id=" + product + "] .wishlist-icon-container").addClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }else{
                    $("[data-id=" + product + "] .wishlist-icon-container").removeClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }
            }
            wishlistAvailabilityCheckCTA(products, product);
        }

        if(searchedWord){
           ulGridChilds[productIndex].classList.remove("search-grid-skeleton");
           //$(".search-grid-skeleton").eq(productIndex).hide()
        }else {
            ulGridChilds[productIndex].classList.remove("plp-grid-skeleton");
            
        }

        ulGridChilds[productIndex].classList.remove("product");
        ulGridChilds[productIndex].querySelector('.square-container').classList.remove("skeleton-element");
        ulGridChilds[productIndex].querySelector('.product__wrapper-info').classList.remove("skeleton-element");
        
        
        productArray.push(createDOMProduct);
       
        removeLoader();


        
        productIndex++;
        tileIndex++;
    }


    if(searchedWord && $("#search_grid .search-grid-skeleton").length > 0){ //hide skeleton if result <3 /2
        $("#search_grid .search-grid-skeleton").hide();
    }

    if (!isWishlist){
        if(searchedWord != 'X_Search_FeaturedProducts' && searchedWord){
            var resultItemsQnt = $("#search_grid li:not(.search-grid-skeleton)").length;
            tealiumPushSearchPageReady(searchedWord,resultItemsQnt);
        }
    } else {
        init_wishlist_tooltip();
    }


  

    // Show images in IE, as Yall does not work properly
    if (!('IntersectionObserver' in window)) {
        if (typeof mokeupLazyLoad === "function") {
            mokeupLazyLoad();
        }
    }
    if(window.location.href.includes("?facet=")){
    	$('#X_PLP_TopBanner').hide();
    	$('#X_PLP_BottomBanner').hide();
    	$('#X_PLP_MiddleBanner').hide();
    	$('#X_PLP_PromoBanner').hide();
        $('#X_PLP_BottomGridBanner').hide();
        $('#X_PLP_GridBannerTop').hide();
        $('#X_PLP_GridBannerBottom').hide();
    }

    if(isEdgeOrIExplorer()){
        $('.grid.product-list').css("width","auto");
    }
    
    /**
     * Handle back button : scroll to the last product clicked by user 
    * */
    if(sessionStorage.plpTitle == pageSection_1 && sessionStorage.pageY) {
            if($plpSearchObj.viewIndex  > 16) { //middle espot non renderizzato
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY - sessionStorage.middleEspotHeight
                },0);
            }
            else {
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY
                },0);
            }
            sessionStorage.removeItem('pageY');
            sessionStorage.removeItem('plpTitle');
            sessionStorage.removeItem('itemsToLoad');
            sessionStorage.removeItem('backItemsPerPage');
            sessionStorage.removeItem('middleEspotHeight');
    }
    if(searchedWord == "X_Search_FeaturedProducts"){ // save Feautured 
        $('#search_grid li').each(function() {
            if(!$(this).hasClass("search-grid-skeleton")){
                featuredProductHtml += this.outerHTML
            }
        })
    }
    
}
/**
 * @funtion getSingleTileHtml
 * @desc This function creates a single product tile with a template html
 * @param {model} model
 * @param {product} product
*/
function getSingleTileHtml(product, model, insideGrid,productIndex=0,isLCPTile, tileIndex,searchedWord,isWishlist,isEspot) {

    var html = '';

    try {

        var listPrice = '';
        var offerPrice = '';
        var percentage = '';

        var polarized = '';
        var isPhotocromic = false;
        var isRox = false;
        var modelNameValue = "";
        var group2BadgeValue = '';
        var wishlistAddedSize = "";
        var wishlistAddedSizeNumber = "";
        var productMoco = "";
        var isPolar = false;
        var catentryIdDefaultSize = [];

        if (typeof isWishlist == "undefined"){
            var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
        }

        //var model = products[product];
        var showedProduct = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0];
        if (showedProduct.thumbnail === undefined) {
            showedProduct.thumbnail = '';
        }
        $(model).each(function (ind) {
            var currProduct = $(this)[0];
            if (isOliver) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
            } else if (isPersol) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }

            try {
                if(WCParamJS.countryCode == 'US' || WCParamJS.countryCode == 'CA'){
                    catentryIdDefaultSize[ind]= currProduct.mostSoldSize['NA'].uniqueID;
                }else if(WCParamJS.countryCode == 'JP'){
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['JP'].uniqueID;
                }else{
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['EMEA'].uniqueID;
                }
            } catch (e) {
                console.error('Error in finding default size for wishlist');
            }
        });

        if(showedProduct != undefined
                && showedProduct.attributes != undefined) {
            for(var i=0; showedProduct.attributes.length>i; i++) {
                if(showedProduct.attributes[i].identifier === 'MODELNAME' && showedProduct.attributes[i].usage === 'Descriptive' ) modelNameValue = showedProduct.attributes[i].values[0].value;
                if(showedProduct.attributes[i].identifier === 'POLARIZED' && showedProduct.attributes[i].usage === 'Descriptive' ){
                    for(var k=0; showedProduct.attributes[i].values.length > k; k++ ){
                        if(showedProduct.attributes[i].values[k].value == true || showedProduct.attributes[i].values[k].value.toLowerCase() === 'yes'){
                            polarized = showedProduct.attributes[i].name;
                        }
                    }
                }
                if(showedProduct.attributes[i].identifier === 'MOCO' && showedProduct.attributes[i].usage === 'Descriptive' ) {
                    productMoco = showedProduct.attributes[i].values[0].value;
                }

            }
            if (isWishlist){
                for(var i=0; showedProduct.attributes.length>i; i++) {
                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE" && showedProduct.attributes[i].usage === "Descriptive" ) {
                        if (typeof wishlistAddedSizeNumber == "undefined" || wishlistAddedSizeNumber == ""){
                            wishlistAddedSizeNumber = showedProduct.attributes[i].values[0].value;
                        }
                    }

                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE_DISPLAY" && showedProduct.attributes[i].usage === "Defining" ) {
                        if (typeof wishlistAddedSize == "undefined" || wishlistAddedSize == ""){
                            wishlistAddedSize = showedProduct.attributes[i].values[0].value;
                        }
                    }
                }
            }
        }

        

        var indexOtherColors = 0;
        var eachLensColor = "";
        var eachFrontColor = "";
        var isClipon = modelNameValue.toLowerCase().includes('clip');
        /*if (isClipon) {
            showedProduct.thumbnail = showedProduct.thumbnail.replace('/is/image/OliverPeoples','/extra/image/OliverPeoples/clipon').replace('_shad_fr','_shad_fr_clipon');
        }*/

        var inventoryStatus = false;
        var cbsCounter = 0;
        var csCounter = 0;
        var soCounter = 0;
        //prova
        var colorProp = "Color"
        var colorsProp = "Colors"
        //prova
        if (!(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile()|| searchedWord || isWishlist)){
            $(model).each(function (ind) {
                if (!(typeof model[ind]['inventory'] === 'undefined')){
                    if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'true'){
                        csCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '0'){
                        soCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'false'){
                        cbsCounter++;
                    }
                } else return false;

                if (csCounter == model.length || cbsCounter == model.length || soCounter == model.length) {
                    inventoryStatus = true;
                    return inventoryStatus;
                }
            });
         }//else{
        //     $(model).each(function (ind) {
        //         if (!(typeof model['inventory'] === 'undefined')){
        //             if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'true'){
        //                 csCounter++;
        //             } else if (model['inventory']['ranking'] == '0'){
        //                 soCounter++;
        //             } else if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'false'){
        //                 cbsCounter++;
        //             }
        //         } else return false;

        //         if (csCounter == 1 || cbsCounter == 1 || soCounter == 1) {
        //             inventoryStatus = true;
        //             return inventoryStatus;
        //         }
        //     });
        // }

        var mustacheObj = {
            modelName: modelNameValue != undefined ? modelNameValue : '',
            inventoryStatus: inventoryStatus,
            //indexPlp:productIndex+1,
            indexPlp:tileIndex+1,
            indexSearchPanel: indexSearchPanel+1,
            isSearchPanel: function () {
                if(searchedWord != undefined) {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchFeturedProduct: function () {
                if(searchedWord == "X_Search_FeaturedProducts") {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchPageResult: function(){
                if(searchedWord == undefined && getUrlParameter('searchTerm')){
                    return true;
                }else{
                    return false;
                }
            },
            isWishlistPage: function(){
                if (isWishlist){
                    return true;
                } else {
                    return false;
                }
            },
            catentryIdDefaultSize : function(){
                return catentryIdDefaultSize[indexOtherColors];
            },
            catentryIsPresentInWishlist: function(){
                if(typeof checkIsInWishlist === 'function'){
                    return checkIsInWishlist(catentryIdDefaultSize[indexOtherColors]);
                }
            },
            image: function () {
            	var stringOfThumbnail = null;
                var backgroundColor = "";
                if (isOliver){
                    backgroundColor = "";
                    // OP: using of OV_OpPlp
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1000');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                	}
                } else  {
                    // PO: scaling of 45% on desktop
                    backgroundColor = "&bgcolor=%23f7f7f7";
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1500');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','small');
                	}
                }
                return stringOfThumbnail + backgroundColor;
            },
            imageScaled: function () {
                var backgroundColor = "";
                if (isOliver){
                    // OP: scaling of 25% on mobile
                    var backgroundColor = "";
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                } else  {
                    // PO: scaling of 25% on mobile
                    var backgroundColor = "&bgcolor=%23f7f7f7";
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                }
            },
            thumbnail: function () {
                if (isOliver){
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                } else {
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
                }
            },
            uniqueID: showedProduct != undefined ? showedProduct.uniqueID : '',
            partNumber: (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[indexOtherColors]).partNumber,
            partNumberAlt: function () {
                if (!isWishlist){
                    return this.partNumber.replaceAll('_','-').replaceAll('/', '-');
                } else {
                    return productMoco.toUpperCase();
                }
            },
            colorProperty: !(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) && model.length > 1 ? colorsProp : colorProp,
            offerPrice: offerPrice ? WCCurrencyJS.format(offerPrice) : '',
            listPrice: listPrice ? WCCurrencyJS.format(listPrice) : '',
            percentage: percentage,
            baseURL: WCParamJS.homePageURL,
            group2BadgeValue: group2BadgeValue,
            otherColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? [ model ] : model,
            replaceImageUrl: function () {
            	var replaceImage = null;
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        backgroundColor = "";
                        // OP: using of OV_OpPlp
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('OV_OpPlp','OV_parameters&WID').replace('WID','wid=1000');
                            }else{
                            	replaceImage = this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID').replace('WID','wid=1000');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                            }else{
                            	replaceImage = replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                            }
                    	}
                    } else {
                        var backgroundColor = "&bgcolor=%23f7f7f7";
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }else{
                            	replaceImage = this.thumbnail2.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                            }else{
    	                        // PO: scaling of 45% on desktop
    	                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
    	                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
    	                        replaceImage = replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                            }
                    	}
                    }
                }else{
                	replaceImage = this.thumbnail;
                }
                return replaceImage ;
            },
            replaceImageUrlScaled: function () {
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        
                        backgroundColor = "";
                        // OP: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                        }
                        return replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') +  backgroundColor;
                    } else {
                        backgroundColor = "&bgcolor=%23f7f7f7";
                        // PO: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                        }
                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
                        return replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                    }
                }
                return this.thumbnail;
            },
            replaceImageUrl1Tile: function () {
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else
                        //return this.thumbnail;
                        return replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','big');
                }
                return this.thumbnail;
            },
            index: function() {
                indexOtherColors++;
            },
            // Show color names under image
            printColorsName: function(){
                $(this.attributes).each(function (){
                    if ((this.identifier) === "FRONT_COLOR"){
                        eachFrontColor = ((this).values[0].identifier);
                    }
                    if ((this.identifier) === "LENS_COLOR"){
                        eachLensColor = ((this).values[0].identifier);
                    }
                })
                if ($("#categoryName").val() === 'OV_Sun') {
                    return (eachFrontColor + '/' + eachLensColor);
                } else {
                    return (eachFrontColor);
                }
            },
            printListPrice: function() {
                var product = this;
                var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
                return listPrice != '' ? WCCurrencyJS.format(listPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            printOfferPrice: function() {
                var product = this;
                offerPrice = getPriceByCustomerSegment(product["price"]);
                return offerPrice != '' ? WCCurrencyJS.format(offerPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            showListPrice: function() {
            	var product = this;
            	var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
            	var offerPrice = getPriceByCustomerSegment(product["price"]);
            	if(offerPrice != '' && listPrice != ''){
	            	if(offerPrice < listPrice) {
	            		return 'showListPrice';
	            	}
            	}
            	return '';
            },
            printStatus: function() {
                return printStatus(this);
            },
            printWishlistSize: function() {
                return wishlistAddedSize;
            },
            printWishlistSizeNumber: function() {
                return wishlistAddedSizeNumber;
            },
            isWishlistSizeEmpty: function() {
                if (wishlistAddedSize == "" || typeof wishlistAddedSize == "undefined"){
                    return true;
                } else {
                    return false;
                }
            },
            printPolarBadge: function() {
                return getPolarized(this.attributes);
            },
            printTransitionBadge : function () {
                return getTransitionBadge(this.attributes);
            },
            printTopBadge: function() {
                /**
                 * Group 1 Badges Hierarchy
                 * PO Transition > Polar
                 * OP Polar
                 */
                var isPolar = getPolarized(this.attributes);
                var isTransition =  getTransitionBadge(this.attributes);
             
                if(isTransition && isPersol){
                    return isTransition;
                }
                else if(isPolar){
                    if(isOliver){
                        return "— "+isPolar+" —";
                    }else{
                        return isPolar;
                    }
                }
            },
            printBottomBadge : function(){
               return  printBadges(this.attributes);
            },
            isPreOrder : function() {
                return getPreOrderBadge(this.attributes) != undefined ;
            },
            isPrescription: function(){
                return isPrescription(this.attributes);
            },
            printSeparator: function(){
                if((printBadges(this.attributes) != "" || getPreOrderBadge(this.attributes) != undefined) && isPrescription(this.attributes,searchedWord) == true){
                    return true;
                }else{
                    return false;
                }
            },
            isFastLoadImg: function() {
                return this.indexPlp < 4
            },
            isLCPTile: isLCPTile
          }

        if(searchedWord) {
            indexSearchPanel++;
        }

        if (insideGrid && !searchedWord) {
            if(typeof tealiumProducts === 'undefined'){
                var tealiumProducts = {};
            }

            //	Tealium
            var tealiumProduct = {};
            var myPartNumber = (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0]).partNumber;
            if (isPersol){
                tealiumProduct['Sku'] = myPartNumber.replaceAll('RX_','');
            } else {
                tealiumProduct['Sku'] = myPartNumber;
            }
            tealiumProduct['ModelName'] = (modelNameValue != undefined ? modelNameValue : '').toUpperCase();
            tealiumProduct['Category'] = !isWishlist ? getSunOpticalCategoryName($("#categoryName").val()) : '';
            tealiumProduct['Price'] = offerPrice;
            tealiumProduct['PriceFull'] = listPrice;
            tealiumProduct['Brand'] = currentBrand;
            tealiumProducts[myPartNumber] = tealiumProduct;
            if(typeof pushWkndSkuInPLP == 'function' && window.wunderkind && window.wunderkind.category !== undefined)
                pushWkndSkuInPLP(tealiumProduct['Sku']);
        }

        var templateHtml = $('#plpTemplate2024').html();
        html = Mustache.to_html(templateHtml, mustacheObj);
        

    } catch (error) {
        console.error('Error in tile creation',error);
    }

    return html;
}



/**
* Opens the search bar when the search icon is clicked.
* Change the tabindex value to every focusable element into the search.
*/
function openSearchBar(element){
    //hideHeaderTimeout.cancel();
    var searchPanel = $('.header__search-wrapper');
    changeTabIndex($('.header__search-wrapper'));
    searchPanel.hasClass("opend") ? searchPanel.removeClass('opend') : searchPanel.addClass('opend');
    searchPanel.removeClass("hidden-panel");
    $('.search--fade').show();
    history.pushState({}, '') // added state in chronology To close the panel when the back button is clicked
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","hidden");
    }
    
    $("body").css("overflow","hidden");
    $("#page").css("overflow","hidden");
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        loadHeaderEspot("X_Search_FeaturedProducts"); // load Feature Products
    }

    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").addClass("searchPanelIsOpen");

    if(isOliver){
        tealium_data2track.push({
            'id':'Click', 
            'data_element_id': 'MainNav_Search_Open',
            'Click_FocusElement' : element
        });
    }
 
    
};

function closeSearchBar() {
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        if($(".searchPanel .search_panel_container").hasClass("active")){
            $(".searchPanel .search_panel_container").removeClass("active");
            $(".searchPanel .search_panel_container").focusout();
            window.history.go(-1);
            if(isPersol){
            	$('.header_wishlist').show(); 
                $("#logo").hide();
            }
        }

    }else{
        $('.header__search-wrapper').removeClass('opend');
        $('.search--fade').hide();
        window.history.go(-1);// delete the state added at opening
        if($plpSearchObj.itemsbkp != undefined){
            //search Optimization --retrieve info on the plp that was being navigated
            $plpSearchObj.items =  $plpSearchObj.itemsbkp;
            $plpSearchObj.busy = false;
            $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp;
            $plpSearchObj.viewIndex = $plpSearchObj.viewIndexbkp ;
        }
    }
    
   
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","auto");
    }
    $("body").css("overflow","auto");
    $("#page").css("overflow","auto");

    resetSearchTile(true,true,false);
    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").removeClass("searchPanelIsOpen");

    if(isOliver){
        setTimeout(function() {
            $('.header__search-wrapper').addClass("hidden-panel"); //HB-12925 Overlay fade effect when close panel
        }, 600);
    }
};


window.onpopstate = function() { //interface is fired when the active history entry changes while the user navigates the session history.
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        var searchPanel = $(".searchPanel .search_panel_container");
        if(searchPanel.hasClass("active")){
            closeSearchBar();
        }
    }else{
        var searchPanel = $('.header__search-wrapper');
        if(searchPanel.hasClass("opend")){
            closeSearchBar();
        }
    }     
  };






function getUrlParameter(paramName) {
    var results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    } else {
       return decodeURI(results[1]) || 0;
    }
}

/**
 * @function callbackSortBy
 * @desc callback function for default sort by
 */
function callbackSortBy(elem){
    if(elem) {
        checkFacetsAndSearch($(elem));
    }
    $('.facet__apply-number').text($plpSearchObj.resultCount);

}

function isNewArrivalsOrdering() {
	return selectedFacetsData["orderBy"] === '8';
}

function isPriceOrdering() {
	return selectedFacetsData["orderBy"] === '3' || selectedFacetsData["orderBy"] === '4';
}

function categoryToGroupTile() {
	if ($('input#notGroupTile').val() == 1)
		return false;

	return true;
}





function resetSearchTile(reloadFeaturedProducts,resetInputButton,resetSuggestion){
    if(reloadFeaturedProducts){
        if( !(window.tabletPortraitCheck() || window.mobilecheck()) && $(".searchPanel .featured-products").length == 0 ){
            $("#search_grid").html(featuredProductHtml);
        } 
        $(".title_result").show();
        $(".redirect_result_container").css("display","none");
    }else{
        $("#search_grid .search-grid-skeleton").show();
        $('#search_grid li').each(function() {
            $(".redirect_result_container .redirect_result_link").css("display","none");
            if(!$(this).hasClass("search-grid-skeleton")){
                 $(this).empty(); // elimina il contenuto 
                 $(this).append('<div class="grid-item">' +
                                    '<div class="product">' +
                                        '<div class="product--wrapper">' +
                                            '<div class="product--wrapper__container">' +
                                                '<div class="plp__other-product-carousel new-plp">' +
                                                    '<div class="square-container skeleton-element">' +
                                                        '<div class="square-content">' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="product__wrapper-info skeleton-element">' +
                                                        '<a class="lower-tile-container ">' +
                                                        '</a>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
                 $(this).addClass("search-grid-skeleton");
                 $(this).removeClass("featured-products");
                
                 
            }
         });
    }
    if(resetInputButton){
        $('input:text[name=searchInput]').val("");
        $(".searchPanel .delete-input-icon").hide();
    }
    if(resetSuggestion){
        $("#search_UsefulLinks").show();
        $("#search_popular").show();
        $(".searchPanel .suggestions_container").empty();
        $(".searchPanel .suggestions_container").hide();
        searchError(false);
    }

    removeLoader();
    
}

function updateSearchTermHistoryCookieAndRedirect(updatedSearchTerm, redirectURL){
	
	this.updateSearchTermHistoryCookie(updatedSearchTerm);
    if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {document.location.href = appendWcCommonRequestParameters(redirectURL);}
    
}

function fn_startSearch() {
    var searchTimeout;
    indexSearchPanel = 0;
    var dInput = $('input:text[name=searchInput]').val().toLowerCase();
    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
        if(dInput.length >= 2){
        	$plpSearchObj.search = true;
            resetSearchTile();
            const promise2 = Promise.resolve(printAutoSuggestions(dInput));
            const promise3 = new Promise((resolve, reject) => {
                setTimeout(resolve, 500, 'Success');
            });
            const promise1 = Promise.resolve(fn_plpFirstTiles(undefined,dInput,undefined,undefined,true));
            Promise.all([promise1,promise2, promise3]).then((values) => {
                if(values[1].suggestionView[0].entry.length > 0 && ($(".error_search_message").is(":visible") || $('.title_result').is(":visible") || $('#search_grid .square-container.skeleton-element').is(":visible")) ){
                    searchError(false);
                    resetSearchTile(false,false,false);
                    fn_plpFirstTiles(undefined,values[1].suggestionView[0].entry[0].name);
                }else if( (!$(".error_search_message").is(":visible") || !$('.title_result').is(":visible")) ){
                    searchError(false);
                }else{
                    searchError(true);
                    resetSearchTile(true,false,false); 
                }
            });
        }
    }else{
        if(dInput.length >= 2){
            printAutoSuggestions(dInput);
        } 
    }
    if(dInput.length > 0){
        if(dInput.length < 2){
            resetSearchTile(true,false,true);
        }
       // $(".searchPanel .delete-input-icon").show();
    }else if(dInput == 0){
        resetSearchTile(true,true,true);
    }
}

function tealiumPushSearchPageReady(dInput,resultItemsQnt) {
    console.log("TEALIUM::tealiumPushSearchPageReady function invoked");
    if(typeof tealium_data2track !== 'undefined' && !mobilecheck()) {
        var trackData = {};
        trackData['id'] = 'SearchPageReady';
        trackData['Search_Keyword'] = dInput.toLowerCase();
        trackData['Search_KeywordActual'] = '';
        trackData['Search_Type'] = 'text';
        trackData['Search_ResultItemsQnt'] = resultItemsQnt; 
        trackData['Search_FacetValues_String'] = "";
        trackData['Search_View'] = "SERB"
        tealium_data2track.push(trackData);
    }
}


function goToSearchPage(input){
    var searchType = ""
    if(input != undefined){
        var dInput = input  
        searchType = "suggested"
       
    }else {
        var dInput = $('input:text[name=searchInput]').val();
        searchType = "text"
        
    }
    var typeResult = checkTileEditorialProduct(numItems,numEditorials);
    if(dInput.length > 0){
        updateSearchTermHistoryCookie(dInput);
        var baseSearchPage = (isInToolkit ? '' : WCParamJS.homePageURL +"/")+'SearchDisplay?storeId='+WCParamJS.storeId+'&catalogId='+ WCParamJS.catalogId + '&langId='+ WCParamJS.langId + '&design=' + typeResult + '&searchTerm=' + dInput +'&Search_Type='+ searchType;   
        location.href = baseSearchPage;
    }
   
}

/**
function printAutoSuggestions(dInput){
    dInput = dInput.replaceAll("’","'");
    $(".searchPanel .suggestions_container").empty();//clean suggestion div 
    var searchHistory = getSearchTermsCookie();
    var limit = 10 - searchHistory.length; //total suggestions + history search = 10

    if(searchHistory.length > 0){ //check for research already done
        searchHistory.forEach(function (term) { 
            historySearchDiv = '<div><a class="search-history" onclick=" goToSearchPage(\''+ term.replace("-","").replace(" ","") +'\')" data-element-id="SearchPanel_Results_query">' + term.replace("%27","'")+ '</a></div>';
            $(".searchPanel .suggestions_container").append(historySearchDiv);//print the latest research
        }) 
    }
    queryAutoSuggestions = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        responseFormat: 'json',
        langId: WCParamJS.langId,
        categoryId: WCParamJS.categoryId,
        limit: limit
    };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: (isInToolkit ? '' : WCParamJS.homePageURL) +"/search/resources/store/" + WCParamJS.storeId  + "/sitecontent/productSuggestionsBySearchTerm/"+ dInput ,
            type: 'GET',
            async: true,
            data: queryAutoSuggestions,
            success: function(data){
                var suggestionDiv = "";
                if(data.suggestionView && data.suggestionView[0].entry.length > 0){
                    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#search_UsefulLinks").hide();
                        $("#search_popular").hide();
                        
                    }else{
                        tealiumPushSearchPageReady(dInput,limit);
                    }
                    searchError(false);
                    $(".searchPanel .suggestions_container").show();
                    var searchTerms = [];
                    for (var i = 0; i < data.suggestionView[0].entry.length; i++) {
                    	var isPresent = false;
                    	var temporaryTerm = data.suggestionView[0].entry[i].name;
                		for (var j = 0; j < searchTerms.length; j++) {
                		//check if the result name has been already shown
                    		if (temporaryTerm === searchTerms[j]){
                    			isPresent = true;
                    		}
                    	}
                    	if(!isPresent){
                    		var spanTerm = data.suggestionView[0].entry[i].name.replace(dInput.toLowerCase(),"<span class='serched-word'>" + dInput.toLowerCase() +"</span>" );
                            suggestionDiv = '<div><a class="suggestion" onclick="goToSearchPage(\'' + data.suggestionView[0].entry[i].name.replace("'","%27") + '\')">' + spanTerm.toLowerCase() + '</a></div>';
                            $(".searchPanel .suggestions_container").append(suggestionDiv);//print suggestions
                    	}
                    	searchTerms.push(data.suggestionView[0].entry[i].name);
                    }
                }
                else if (data.metaData){
                	dInput = data.metaData.spellcheck[0];
                	printAutoSuggestions(dInput);
                }
                else if(!(searchHistory.length > 0 && data.suggestionView && data.suggestionView[0].entry.length > 0)){
                    if((window.tabletPortraitCheck() || window.mobilecheck())){
                        searchError(true);
                        tealiumPushSearchPageReady(dInput,'0');
                    }
                    $(".suggestions_container").hide();
                    $("#search_UsefulLinks").show();
                    $("#search_popular").show();
                    
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);  
                reject(error);
            }
        });
    });

    

}
*/ 

var inputTimer = null;

function loadHeaderEspot(espotName) {

    // If espot div is not present, skip the loading
    if ($("#" + espotName).length == 0) return;
  
    // Get product, if present
    let products = {};
    let contents = [];
  
    // Compose service url
    var espotServiceUrl =
      WCParamJS.urlPrefixForHTTPS +
      "/wcs/resources/store/" +
      WCParamJS.storeId +
      "/espot/" +
      espotName +
      "?langId=" +
      WCParamJS.langId;
  
    return new Promise((resolve, reject) => {
  
      $.getJSON(espotServiceUrl, function (data) {
        products = {};
        contents = [];
        //con la risposta del servizio mi creo due array di oggetti di prodotti e contenuti
        data["MarketingSpotData"].forEach(function (msd, index) {
          if (msd["baseMarketingSpotActivityData"]) {
            var savedActivityPriority;
            msd["baseMarketingSpotActivityData"].every(function (bmspd, index) {
              if (
                typeof savedActivityPriority != "undefined" &&
                savedActivityPriority != bmspd["activityPriority"]
              ) {
                return false;
              }
              savedActivityPriority = bmspd["activityPriority"];
              if (bmspd["baseMarketingSpotDataType"] === "CatalogEntry") {
                // controllo che sia un prodotto
                var productsobj = {
                  product: bmspd["baseMarketingSpotActivityName"],
                  productId: bmspd["productId"]
                };
                //prendo le info sul modello
                var isProductPresent =
                  productsobj["product"].length > 0 &&
                  productsobj["productId"].length > 0;
                  if (isProductPresent) {
                    products[productsobj["productId"]] = productsobj;
                }
              } else if (
                bmspd["baseMarketingSpotDataType"] === "MarketingContent"
              ) {
                // controllo che sia un contenuto
                bmspd["marketingContentDescription"].forEach(function (mkd, index) {
                  if(typeof mkd["marketingText"] != 'undefined'){
                    contents.push(
                        mkd["marketingText"].replaceAll(
                          "[fullPathHomeURL]",
                          WCParamJS.homePageURL
                        )
                      ); //metto nell array di contenuto tutti i contenuti
                  }  
                });
              }
              return true;
            });
          }
        });
  
      }).done(function(data) {
  
        if (Object.keys(products).length > 0) {
  
          getProductsModelHeader(products,function() {
            if(espotName=="X_Search_FeaturedProducts"){
              renderTileProducts(products,0,0,0,espotName);
            }else{
                if( typeof espotCallback == 'function'){
                    espotCallback(products, contents, espotName);
                }
            }
            
          })
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error(error)
          });
  
        } else {
            if( typeof espotCallback == 'function'){
                espotCallback(products, contents, espotName)
            }
        }
  
        resolve(data);
    }).fail(function(error) {
      reject(error);
    });
  
    });
  
  }

  function getProductsModelHeader(products,callback) {

    var productIds = [];
    $.each(products,function(k,v) {
      productIds.push(k);
    });
  
    // Compose service url
    var productServiceUrl =
      (isInToolkit ? "" : WCParamJS.homePageURL) +
      "/search/resources/store/" +
      WCParamJS.storeId +
      "/productview/byIds?id=" +
      productIds.join("&id=") +
      "&storeId=" +
      WCParamJS.storeId +
      "&catalogId=" +
      WCParamJS.catalogId +
      "&responseFormat=json&langId=" +
      WCParamJS.langId +
      "&currency=" +
      WCParamJS.commandContextCurrency +
      "&profileName=LUX_findProductByIds_Details" +
      "&isForDDM=true"
      ;
  
    return new Promise((resolve, reject) => {
      $.getJSON(productServiceUrl, function (data) {
        var productModel = data["catalogEntryView"];
  
        // To align objects with those expected by Mustache
        productModel.forEach(function (m, index) {
          m["modelCode"] = m.partNumber.split('__')[0];
          products[m["uniqueID"]]["productModel"] = m;
        });
  
        if (typeof callback === 'function') {
          callback();
        }
  
      }).done(function(data) {
        resolve(data);
      }).fail(function(error) {
        reject(error);
      });
    });
    
  }
  /** 
  function updateSearchTermHistoryCookie(updatedSearchTerm){
    // Set the expiration date to one month from the current date
    var expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 1);
    var cookieKey = "searchTermHistory";
    var cookieValue = "|" + updatedSearchTerm;
    var searchTermHistoryCookie = getCookie(cookieKey);
    if( searchTermHistoryCookie != undefined && searchTermHistoryCookie != 'undefined') {
        var termsArray = searchTermHistoryCookie.split("|");
        if(!termsArray.includes(cookieValue.replace("|",""))){
            cookieValue = getCookie(cookieKey) + cookieValue;
        }
        
    }
    setCookie(cookieKey, cookieValue,{path:'/', domain:cookieDomain, expires: expirationDate});
}


function getSearchTermsCookie(){
    var searchHistoryCookie = getCookie("searchTermHistory");
    var theLastTerms=[];
    if( searchHistoryCookie != undefined && searchHistoryCookie != 'undefined') {
        var termsArray = searchHistoryCookie.split("|");
        var count = 0; 
        for(var i = termsArray.length - 3; i < termsArray.length; i++) {
            if(termsArray[i] != undefined && termsArray[i] != "" && termsArray[i] != 'undefined'){
                theLastTerms[count]= termsArray[i];
                count++;
            }
        }
    }
    return theLastTerms.reverse();
}
**/

function searchError(show){
    if(show){
        var searchedWord = $('input:text[name=searchInput]').val();
        $(".error_search_message #error_word").html(searchedWord);
        $(".error_search_message").show();
        $(".error-search-icon").show();
        $(".input-icon").hide();
    }else{
        $(".error_search_message").hide();
        $(".error-search-icon").hide();
        $(".input-icon").show();
    }
    
}



/**
 * @funtion getStatus 
 * @desc get Product Status (Available, SoldOut, Out-of-stock, etc.) based on inventory informations
 */
function getStatus(inventoryStatus) {
    //var flComingSoon = inventoryStatus.flComingSoon;
    var ranking = inventoryStatus.ranking;
    var status = "";

    switch(ranking) {
        case "0" : {
            status =  "SoldOut";
            break;
        }
        case "1" : {//Coming Soon & Coming Back Soon
            status = "Out-of-stock";  
            break;
        }
        case "2" : {
            status = "Available";
            break;
        } 
        default : {
            status= "/";
        }
    }
    return status;
}

//remove loader as soon as image is displayed
function removeLoader(){
    var articleImages = document.querySelectorAll(".image-container.main > picture >  img");
    var imageSkeleton = '';
    articleImages.forEach(function(img) {
        img.addEventListener('load', function() {
            imageSkeleton = $(img).closest(".image-container");
            $(imageSkeleton).removeClass("skeleton-element");
        });       
    });
}

function clearSearchPanelEditorial(){
	while ($('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length != 0){
		$('#search_hits .ais-Hits .ais-Hits-item.is-editorial')[$('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length-1].remove()
	}
}



//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////
// MiniShopCartDisplay.js (Common implementation) //
////////////////////////////////////////////////////
//console.log("MiniShopCartDisplay.js (Common implementation) loaded");

function closeMiniShopCartDropDown(){
    var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    //Start HB-12482 
    if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "auto");	
    }
  //End HB-12482 
    
    if (visiblePopup.length>0){
    	if(isPersol) {
    		if(productDisplayJS.priceSwitched){
                if (!isWishlistPage){
                    document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    if(affirmEnabled) {
                        customizeAffirmPrice();
                    }
                } else {
                    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
                    document.getElementById('offerPrice_'+ minicartAddedId).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+ minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                    $('#header').removeClass("mincartOpened")
                }
		    	productDisplayJS.priceSwitched = false;
    		}
            //START Early Access
            window.lastOfferPrice = returnLastOfferPrice();
            //END Early Access
    	}
    	else if(isOliver){
    		if(productDisplayJS.priceSwitched){
                var minicartAddedId = $("#cartDropdown .products .product").attr("data-minicart-id");
    			var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+minicartAddedId+']');
        		var div;
        		for(var i = 0; i<elements.length;i++) {
        			if(elements[i].nodeName == "DIV") {
        				div = elements[i];
        			}
        		}
        		if(div != undefined) {
        			div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        		}
	    	 	
                if (!isWishlistPage){
                    document.getElementById('listPrice_'+productParent).innerText = productDisplayJS.lastOfferPriceSaved;
                } else {
                    document.getElementById('listPrice_'+minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                }

		    	if(affirmEnabled && !isWishlistPage) {
		    		customizeAffirmPrice();
		    	}
		    	productDisplayJS.priceSwitched = false;
    		}
    		
    		//open Vm if was opened
    		if ($.cookie("isVMOpen") == "1") {
    			moveVMOverProduct();
    			vmTryThemOn();
    		}
    	}
    	productDisplayJS.lastPriceSaved =  "";
    	productDisplayJS.lastOfferPriceSaved = "";
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}
    	
    
        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }

    visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

    if (visiblePopup.length>0){
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}

        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }
    if (isOliver || isPersol) { 
        manageScrollOverlay(false);
    }

    if (isPersol){
        $('.shopperActions--monogram--added--button.remove').click();
    }
    
}

/*
//Extra events for minishopcart buttons
function bindMiniShopCartEvents(){
    $("#continueShoppingButton").on("click touchstart", function(){
        closeMiniShopCartDropDown();
        return false;
    });
}

$(document).ready(bindMiniShopCartEvents);
$(document).ajaxComplete(bindMiniShopCartEvents);
*/
/*
function repositionMiniShopCart(){
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).css("top",-($(window).scrollTop())+"px");
}

//Manage minishopcart's position on mobile
function onScrollMiniShopCart(){
    console.log("PSL::onScrollMiniShopCart()");
    var reposition = false;
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    if ($(popup).length>0){
        for (var i = 0; i < $(popup).length; i++) {
            var element = $(popup)[i];
            if (!reposition && element.clientHeight > window.innerHeight){
                reposition = true;
            }
        }
    } else {
        console.log("PSL::onScrollMiniShopCart()::No minishopcart on screen");
    }

    if (reposition){
        console.log("PSL::onScrollMiniShopCart()::Repositioning minishopcart");
        var scrollTop = $(window).scrollTop();
        $(popup).css("top",(scrollTop*(-1))+"px");
    } else {
        console.log("PSL::onScrollMiniShopCart()::No reposition needed");
    }
}

$(document.body).on('touchmove', onScrollMiniShopCart); //mobile
$(window).on('scroll', onScrollMiniShopCart);           //desktop

function repositionMiniShopCartPopup(){
    console.log("Posicionando BEGIN");
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).position({
        my: "right top",
        at: "right bottom",
        of: "#miniShopCartPopupPositionReference"
    });
    console.log("Posicionando END");
}
*/

//HB-1816 BEGIN Close MiniShopCart popup when the user clicks outside of it
$(document).click(function(event) {
    //console.log("PSL::MiniShopCartDisplay.js::Document clicked");

    // Ignore this event if preventDefault has been called.
    if (event.defaultPrevented){
        //console.log("PSL::MiniShopCartDisplay.js::event.defaultPrevented");
        return;
    }

    var isFade = ($(event.target).hasClass("quickcart--fade") || $(event.target).hasClass("minishopcartadded--fade"));

    var mouseX = event.pageX;
    var mouseY = event.pageY;

    if (mouseX != undefined && mouseY != undefined){
        //console.log("PSL::MiniShopCartDisplay.js::mouseX: " + mouseX + ", mouseY: " + mouseY);

        var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");

        if (visiblePopup.length>0){
            event.stopPropagation();
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product Added popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                if($('#page').hasClass('pdp') && brandCode == 'PO'){
                    hideHeaderTimeout.setup();
                    $('#header').css('z-index', '5') 
                }
                $(visiblePopup).find(".closeButton").click();

                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }

        visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

        if (visiblePopup.length>0){
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product List popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                $(visiblePopup).find(".closeButton").click();
                if(brandCode == 'PO' && $('#page').hasClass('pdp')){
                    hideHeaderTimeout.setup()
                }
                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }
    }
});
//HB-1816 END

function lockShoppingBagIcon(){
    $("#widget_minishopcart").addClass("isDisabled");
    $("#widget_minishopcart").attr("href-disabled", $("#widget_minishopcart").attr("href") );
    $("#widget_minishopcart").attr("onclick-disabled", $("#widget_minishopcart").attr("onclick") );
    $("#widget_minishopcart").removeAttr("href");
    $("#widget_minishopcart").removeAttr("onclick");
}

function unlockShoppingBagIcon(){
    $("#widget_minishopcart").attr("href", $("#widget_minishopcart").attr("href-disabled") );
    $("#widget_minishopcart").attr("onclick", $("#widget_minishopcart").attr("onclick-disabled") );
    $("#widget_minishopcart").removeAttr("href-disabled");
    $("#widget_minishopcart").removeAttr("onclick-disabled");
    $("#widget_minishopcart").removeClass("isDisabled");
}

$(document).ready(function(){
    unlockShoppingBagIcon();
});


////////////////////////////////////////////////////
// OOTB source code                               //
////////////////////////////////////////////////////
/**
 * @fileOverview This file provides the common functions which are specific to the Mini Shopping cart
 */

/**
 * map order_updated to all the services that result in changes to an order
 * @static
 */

var order_updated = {
    'AjaxAddOrderItem': 'AjaxAddOrderItem',
    'AddOrderItem': 'AddOrderItem',
    'AjaxAddOrderItemWithShipingInfo': 'AjaxAddOrderItemWithShipingInfo',
    'AjaxDeleteOrderItem': 'AjaxDeleteOrderItem',
    'AjaxUpdateOrderItem': 'AjaxUpdateOrderItem',
    'AjaxUpdateOrderShippingInfo': 'AjaxUpdateOrderShippingInfo',
    'AjaxOrderCalculate': 'AjaxOrderCalculate',
    'AjaxLogoff': 'AjaxLogoff',
    'AjaxSetPendingOrder': 'AjaxSetPendingOrder',
    'AjaxUpdatePendingOrder': 'AjaxUpdatePendingOrder',
    'AjaxSingleOrderCancel': 'AjaxSingleOrderCancel',
    'AjaxUpdateRewardOption': 'AjaxUpdateRewardOption'
};

/** This variable indicates whether the mini cart drop down is updated or not. */
var dialogWidget,
    update_content = false,
    dropdownUpdated = false,
    /** This is variable indicates whether the mini cart drop down is being initialized. */
    dropdownInit = false,
    productAddedList = {};

function declareMiniShoppingCartRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea()::BEGIN");
    // ============================================
    // initialize refresh area widgets
    // ============================================

    // ============================================
    // div: MiniShoppingCart refresh area
    // Declares a new refresh controller for the Mini Shopping Cart.

    // declare render context
    wcRenderContext.declare("MiniShoppingCartContext", ["MiniShoppingCart"], { status: "init" });

    /*
    /* Refreshes the mini shopping cart.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().renderContextChangedHandler()::BEGIN");
        if (wcRenderContext.testForChangedRC("MiniShoppingCartContext", ["status"])) {
            wcRenderContext.getRenderContextProperties("MiniShoppingCartContext").deleteCartCookie = true;
            $("#MiniShoppingCart").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShoppingCartContext"));
        }
    };

    // model change
    /*
     * Refreshes the mini shopping cart.
     * If a new order item is added via an Ajax service call, set the mini shopping cart to display the new order item in the dropdown.
     * Otherwise, only refresh the contents of mini shopping cart to the updated order information.
     * This function is called when a modelChanged event is detected.
     *
     * @param {string} event The model changed event
     * @param {object} returnData The data returned from the event
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage" });
    wcTopic.subscribe(events, function(returnData) {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().wcTopic.subscribe()::BEGIN");
        var param = [];
        if (returnData.actionId == 'AddOrderItem') {
            if (returnData.data.orderItem != null && returnData.data.orderItem[0].orderItemId != null) {
                var addedOrderItemIdString = "";
                for (var i = 0; i < returnData.data.orderItem.length; i++) {
                    if (addedOrderItemIdString !== "") {
                        addedOrderItemIdString += ",";
                    }
                    addedOrderItemIdString += returnData.data.orderItem[i].orderItemId;
                }
                param.addedOrderItemId = addedOrderItemIdString;
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            } else {
                param.addedOrderItemId = returnData.data.orderItemId + "";
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            }

            if(productDisplayJS && productDisplayJS.YMALProductFlag) { //se abbiamo aggiunto un prodotto dai prodotti suggeriti a carrello
				productDisplayJS.YMALProductFlag = false;
				showDropdown = false; //no minicart
                window.location.reload();
			} else if (productDisplayJS && productDisplayJS.RMAProductFlag){
                productDisplayJS.RMAProductFlag = false;
				showDropdown = false; //no minicart
            }
            else {
                showDropdown = true;
            }
        }
        param.deleteCartCookie = true;
        if (returnData.data.addedFromSKUList != null && returnData.data.addedFromSKUList[0] != null) {
            param.addedFromSKUList = returnData.data.addedFromSKUList[0];
        }
        if(window.skipMiniCart) {
            getNumberOfItemsInCart(itemsInCartBadge);
            goDirectToCart();
        }
        else
            $("#MiniShoppingCart").refreshWidget("refresh", param);
           
    });

    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().postRefreshHandler()::BEGIN");
        //The dialog contents has changed..so destroy the old dialog with stale data..
        destroyDialog("MiniShopCartProductAdded");

        if (showDropdown) {
            update_content = true;
            //We have added item to cart..So display the drop down with item added message..
            positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
            showDropdown = false;
        }

        if (!multiSessionEnabled) {
            setTimeout(() => {
                updateCartCookie();
            }, 0);
        }

        populateProductAddedDropdown();

        if (!multiSessionEnabled) {
            setTimeout(() => {
                resetDeleteCartCookie();
            }, 0);
        }
    };

    // initialize widget
    $("#MiniShoppingCart").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });
}

function declareMiniShopCartContentsRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea()::BEGIN");
    // ============================================
    // div: MiniShopCartContents refresh area
    // Declares a new refresh controller for the Mini Shopping Cart contents

    // Declares a new render context for the Mini Shopping Cart contents.
    wcRenderContext.declare("MiniShopCartContentsContext", ["MiniShopCartContents"], { status: "init", relativeId: "", contentId: "", contentType: "" });

    /*
     * Refreshes the mini shopping cart contents since it is out of date.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function(event, data) {
        if (!dropdownUpdated) {
            wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext").fetchCartContents = true;
            dropdownUpdated = true;
            $("#MiniShopCartContents").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext"));
        }
    };

    /*
     * Indicate that the mini cart contents are out of date upon an order change action.
     * This function is called when a modelChanged event is detected.
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage", "AjaxRESTOrderLockUnlockOnBehalf": "AjaxRESTOrderLockUnlockOnBehalf" });
    wcTopic.subscribe(events, function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().wcTopic.subscribe()::BEGIN");
        dropdownUpdated = false;
    });

    /*
     * Displays and positions the mini shop cart contents.
     * This function is called after a successful refresh.
     */
    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().postRefreshHandler()::BEGIN");
        var renderContextProperties = wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext");
        positionMiniShopCartDropDown(renderContextProperties.relativeId, renderContextProperties.contentId, renderContextProperties.contentType);
        //
        // This is needed for CSR solution. When CSR and shopper are browsing the store in simultaenously in
        // different browsers and if CSR locks/unlocks the shoppers cart, the miniCart in shopper's browser will
        // NOT reflect the change unless shopper takes some order related actions (add/delete from cart).
        // So to update the miniCart status loadMiniCart() function is called here.
        // It doesn't make another server call. The data returned from the MiniCartContentsUI is used
        // to refresh the miniCart summary.
        //
        updateCartCookie();
        loadMiniCart(WCParamJS.commandContextCurrency, WCParamJS.langId);
    };

    // initialize widget
    $("#MiniShopCartContents").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });

}

/**
 * Displays the dropdown content of the mini shopping cart when the user hovers over the
 * mini shopping cart if the contents are up-to-date or retrieve the latest contents from server.
 *
 * PSL:: This OOTB function can block the minishopcart. The variable dropdownInit is true while the shopcart is loading.
 * If the user clicks the shoppingcart again while it's loading (dropdownInit variable is 'true') sometimes this flag
 * never goes back to false and the user cannot open the MSC anymore until page reload.
 * In order to solve this issue we added a function that prevents extra clicks over the shopping bag icon
 * while the minishoppingcart popup is loading (See lockShoppingBagIcon()/unlockShoppingBagIcon())
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function showMiniShopCartDropDown(relativeId, contentId, contentType) {
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::BEGIN");
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (!dropdownInit && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        dropdownInit = true;
        lockShoppingBagIcon();

        if (!dropdownUpdated) {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el IF");
            update_content = true;
            var params = {
                status: "load",
                relativeId: relativeId,
                contentId: contentId,
                contentType: contentType,
                page_view: "dropdown"
            };
            wcRenderContext.updateRenderContext("MiniShopCartContentsContext", params);
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el ELSE");
            positionMiniShopCartDropDown(relativeId, contentId, contentType);
        }
    }
}

function toggleMiniShopCartDropDown(relativeId, contentId, contentType) {
    if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')) {
        // if(!(window.mobilecheck() || window.tabletPortraitCheck()))hideHeaderTimeout.cancel();
        (dialogWidget && dialogWidget._isOpen) ? $("#page-overflow-wrapper").removeClass("overflow-hidden") : $("#page-overflow-wrapper").addClass("overflow-hidden");
    }
    //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::BEGIN");}
    if (dialogWidget && dialogWidget._isOpen) {
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.setup();
        }
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el IF");
        dialogWidget.close();
    } else {
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el ELSE");
        showMiniShopCartDropDown(relativeId, contentId, contentType);
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.cancel();
        }
    }
}

/*
 * Displays the dropdown content of the mini shopping cart.
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function positionMiniShopCartDropDown(relativeId, contentId, contentType) {
    //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown()::BEGIN");
    var add_event_handlers = function(contentElement) {
        //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown().add_event_handlers()::BEGIN");
        contentElement.on("wcdialogopen", function(event) {
            //deactivate(document.getElementById("header"));
            $("#" + relativeId).addClass("selected");
        });

        contentElement.on("wcdialogclose", function(event) {
            $("#" + relativeId).removeClass("selected");
        });
    };

    // Dialog is not yet created..Create one
    if (!dialogWidget /*PSL Force dialog creation */ || true) {
        var content = $("#" + contentId);
        if (contentId === "MiniShopCartProductAdded") {
            // The content may have been hidden so show it
            $("#MiniShopCartProductAddedWrapper").removeAttr("style");
        }
        dialogWidget = content.WCDialog({
            position: {
                my: "right top",
                at: "right bottom",
                of: "#widget_minishopcart"
            },
            autoOpen: false,
            open: function() {
                // Make the element show up on top of the header elements
                dialogWidget.element.parent().css("z-index", 1);

                if (contentType == 'orderItemAdded') {
                    if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                    }else{
                        $("#MiniShopCartProductAddedWrapper").css("display", "block");
                    }
                }
            },
            appendTo: "#headerRow1",
            title: $("#" + contentId + "_ACCE_Label").html(),
            show_title: false,
            width: "360px",
            //dialogClass: "no-close",
            modal: false
        }).data("wc-WCDialog");
        add_event_handlers(content);
        update_content = false;

		/* APPLEPAY BEGIN */
		if (typeof(showApplePayButtons) == "function") {
			showApplePayButtons();
		}
        /* APPLEPAY END */

    } else {
        dialogWidget.close();
        if (update_content) {
            if (contentType == 'orderItemAdded') {
                if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                    $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                }else{
                    $("#MiniShopCartProductAddedWrapper").css("display", "block");
                }
            }
            var newContent = $("#" + contentId);
            dialogWidget.update_content("#" + contentId);
            add_event_handlers(newContent);
            update_content = false;
        }
    }

    if (Utils.get_IE_version() < 7) {
        dialogWidget.css("display", "block");
    }
    
    //Start HB-12482 
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	    $("html, body").animate({
	        scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }else if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "hidden");
    	$("html, body").animate({
	        //scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }
    //End HB-12482 
    
    dropdownInit = false;

    unlockShoppingBagIcon();
}

/*
 * Store the current mini cart information in the mini cart cookie.
 */
function updateCartCookie() {
    //Save current order information into cookie
    if ($("#currentOrderQuantity").length && $("#currentOrderAmount").length && $("#currentOrderCurrency").length && $("#currentOrderId").length && $("#currentOrderLanguage").length) {
        var cartQuantity = $("#currentOrderQuantity").val();
        var cartAmount = $("#currentOrderAmount").val();
        var cartCurrency = $("#currentOrderCurrency").val();
        var cartLanguage = $("#currentOrderLanguage").val();
        var cartOrderId = $("#currentOrderId").val();
        var currentOrderLocked = $("#currentOrderLocked").val();

        //Clear out previous cookies
        var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);
        if (orderIdCookie != null) {
            setCookie("WC_CartOrderId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
            var cartTotalCookie = getCookie("WC_CartTotal_" + orderIdCookie);
            if (cartTotalCookie != null) {
                setCookie("WC_CartTotal_" + orderIdCookie, null, {
                    expires: -1,
                    path: '/',
                    domain: cookieDomain
                });
            }
        }
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, cartOrderId, {
            path: '/',
            domain: cookieDomain
        });
        if (cartOrderId !== "") {
            setCookie("WC_CartTotal_" + cartOrderId, cartQuantity + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage + ";" + currentOrderLocked, {
                path: '/',
                domain: cookieDomain
            });
        }
    } else {
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, "", { path: '/', domain: cookieDomain });
    }
}

function setProductAddedList(newProductAddedList) {
    productAddedList = newProductAddedList;
}

/*
 * Populates the Product Added dropdown upon an add to cart action.
 */
function populateProductAddedDropdown() {


    var search = '"';

    var replaceStr = "'";
    for (productId in productAddedList) {
        var productDetails = productAddedList[productId];

        if ($("#MiniShopCartAddedProdName_" + productId).length && productDetails[0] != null && productDetails[0].length != 0) {
            $("#MiniShopCartAddedProdName_" + productId).html(productDetails[0]);
        }

        /* OOTB - PSL:: We disabled this code because it replaces the thumbnail with the fullimage of the catentry
        if ($("#MiniShopCartAddedProdImgSrc_" + productId).length && productDetails[1] != null && productDetails[1].length != 0) {
            $("#MiniShopCartAddedProdImgSrc_" + productId).attr("src", productDetails[1]);
            document.getElementById('MiniShopCartAddedProdImgSrc_' + productId).alt = productDetails[0];
        }
        */

        if ($("#MiniShopCartAddedProdPrice_" + productId).length && productDetails[2] != null && productDetails[2].length != 0) {
            $("#MiniShopCartAddedProdPrice_" + productId).html(productDetails[2]);
        }
        if ($("#MiniShopCartAddedProdQty_" + productId).length && productDetails[3] != null && productDetails[3].length != 0) {
            $("#MiniShopCartAddedProdQty_" + productId).html(productDetails[3]);
        }

        if ($("#MiniShopCartAddedProdAttr_" + productId).length && productDetails[4] != null && productDetails[4].length != 0) {
            $("#MiniShopCartAddedProdAttr_" + productId).html("");

            for (attrName in productDetails[4]) {
                attrValue = productDetails[4][attrName];
                if (attrValue != null && attrValue != 'undefined') {
                    attrValue = attrValue.replace(/&amp;/g, "&").replace(/&#039;/g, "'").replace(/&#034;/g, '"').replace(replaceStr, search);
                }
                document.getElementById('MiniShopCartAddedProdAttr_' + productId).innerHTML += '<div>' + attrName + ': ' + attrValue + '</div>';
            }
        }
    }
    wcTopic.publish("ProductInfo_Reset");
}

/*
 * Loads mini shop cart info upon page load.
 * @param {String} contextCurrency Current currency selected.
 * @param {String} langId Current language selected.
 */
function loadMiniCart(contextCurrency, langId) {
    var updateCart = false;
    var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);

      if (orderIdCookie != undefined && orderIdCookie === "") {
        var subtotal = document.getElementById("minishopcart_subtotal");
        var formattedSubtotal = null;
        if ($("#currentOrderAmount").length) {
            formattedSubtotal = Utils.formatCurrency($("#currentOrderAmount").val(), {
                currency: contextCurrency
            });
        }
        if (formattedSubtotal == null && $("#currentOrderAmount").length) {
            formattedSubtotal = $("#currentOrderAmount").val();
        }

        if (subtotal != null) {
            subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
        }
        var items = document.getElementById("minishopcart_total");
        if (items != null) {
            var itemsMsg = null;
            if ($("#currentOrderQuantity").length) {
                itemMsg = $("#currentOrderQuantity").val();
            }
            if (itemsMsg == null) {
                itemsMsg = "0";
            }
            items.innerHTML = "\n " + itemsMsg + "\n ";
        }
    } else if (orderIdCookie != undefined && orderIdCookie !== "") {
        var cartCookie = getCookie("WC_CartTotal_" + orderIdCookie);

        if (cartCookie != undefined && cartCookie != null && cartCookie !== "") {
            var orderInfo = cartCookie.split(";");

            if (orderInfo != null && orderInfo.length > 3) {
                if (orderInfo[2] == contextCurrency && orderInfo[3] == langId) {
                    var subtotal = document.getElementById("minishopcart_subtotal");
                    if (subtotal != null) {
                        var formattedSubtotal = null;
                        formattedSubtotal = Utils.formatCurrency(orderInfo[1].toString(), {
                            currency: contextCurrency
                        });
                        if (formattedSubtotal == null) {
                            formattedSubtotal = orderInfo[1].toString();
                        }
                        subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
                    }
                    var currentOrderLocked = false;
                    if (orderInfo[4] != null && orderInfo[4] == 'true') {
                        var currentOrderLocked = true;
                    }
                    var items = document.getElementById("minishopcart_total");
                    var lock = document.getElementById("minishopcart_lock");
                    if (items != null) {
                        var itemsMsg = orderInfo[0].toString();
                        items.innerHTML = "\n " + itemsMsg + "\n ";
                        if (currentOrderLocked) {
                            $(items).addClass("nodisplay");
                            $(lock).removeClass("nodisplay");
                        } else {
                            $(items).removeClass("nodisplay");
                            $(lock).addClass("nodisplay");
                        }
                    }
                } else {
                    updateCart = true;
                }
            } else {
                updateCart = true;
            }
        } else {
            updateCart = true;
        }
    } else {
        updateCart = true; 
    }
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (updateCart == true && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        wcRenderContext.updateRenderContext('MiniShoppingCartContext', {
            'status': 'load'
        });
    }
}


/*
 * Turn on the flag to indicate that the mini cart cookies should be refreshed.
 */
function setDeleteCartCookie() {
    setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, true, {
        path: '/',
        domain: cookieDomain
    });
}

/*
 * Check whether the mini cart cookies need to be updated or not.
 */
function checkDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != undefined && deleteCartCookieVal !== "") {
        if (deleteCartCookieVal == 'true') {
            return true;
        }
    }
    return false;
}

/*
 * Delete the flag that indicates the mini cart cookie should be refreshed.
 */
function resetDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != null) {
        setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, null, {
            expires: -1,
            path: '/',
            domain: cookieDomain
        });
    }
}
wcTopic.subscribe("ProductInfo_Added", setProductAddedList);